(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducers = exports.utils = exports.containers = exports.components = undefined;
	
	var _CBGDateTraceLabel = __webpack_require__(2);
	
	var _CBGDateTraceLabel2 = _interopRequireDefault(_CBGDateTraceLabel);
	
	var _FocusedRangeLabels = __webpack_require__(17);
	
	var _FocusedRangeLabels2 = _interopRequireDefault(_FocusedRangeLabels);
	
	var _FocusedSMBGPointLabel = __webpack_require__(32);
	
	var _FocusedSMBGPointLabel2 = _interopRequireDefault(_FocusedSMBGPointLabel);
	
	var _Loader = __webpack_require__(41);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _RangeSelect = __webpack_require__(45);
	
	var _RangeSelect2 = _interopRequireDefault(_RangeSelect);
	
	var _TwoOptionToggle = __webpack_require__(58);
	
	var _TwoOptionToggle2 = _interopRequireDefault(_TwoOptionToggle);
	
	var _PumpSettingsContainer = __webpack_require__(61);
	
	var _PumpSettingsContainer2 = _interopRequireDefault(_PumpSettingsContainer);
	
	var _TrendsContainer = __webpack_require__(102);
	
	var _TrendsContainer2 = _interopRequireDefault(_TrendsContainer);
	
	var _Tooltip = __webpack_require__(4);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _BolusTooltip = __webpack_require__(181);
	
	var _BolusTooltip2 = _interopRequireDefault(_BolusTooltip);
	
	var _SMBGTooltip = __webpack_require__(33);
	
	var _SMBGTooltip2 = _interopRequireDefault(_SMBGTooltip);
	
	var _reducers = __webpack_require__(185);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _format = __webpack_require__(19);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _data = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	__webpack_require__(35);
	
	var components = {
	  CBGDateTraceLabel: _CBGDateTraceLabel2.default,
	  FocusedRangeLabels: _FocusedRangeLabels2.default,
	  FocusedSMBGPointLabel: _FocusedSMBGPointLabel2.default,
	  Loader: _Loader2.default,
	  RangeSelect: _RangeSelect2.default,
	  TwoOptionToggle: _TwoOptionToggle2.default,
	  Tooltip: _Tooltip2.default,
	  BolusTooltip: _BolusTooltip2.default,
	  SMBGTooltip: _SMBGTooltip2.default
	};
	
	var containers = {
	  PumpSettingsContainer: _PumpSettingsContainer2.default,
	  TrendsContainer: _TrendsContainer2.default
	};
	
	var utils = {
	  formatBgValue: _format.formatBgValue,
	  reshapeBgClassesToBgBounds: _bloodglucose.reshapeBgClassesToBgBounds,
	  selectDailyViewData: _data.selectDailyViewData
	};
	
	exports.components = components;
	exports.containers = containers;
	exports.utils = utils;
	exports.reducers = _reducers2.default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(components, 'components', '/Users/krystophv/tidepool/viz/src/index.js');
	
	  __REACT_HOT_LOADER__.register(containers, 'containers', '/Users/krystophv/tidepool/viz/src/index.js');
	
	  __REACT_HOT_LOADER__.register(utils, 'utils', '/Users/krystophv/tidepool/viz/src/index.js');
	})();

	;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(4);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _d3TimeFormat = __webpack_require__(12);
	
	var _CBGDateTraceLabel = __webpack_require__(14);
	
	var _CBGDateTraceLabel2 = _interopRequireDefault(_CBGDateTraceLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CBGDateTraceLabel = function CBGDateTraceLabel(props) {
	  if (!props.focusedDateTrace) {
	    return null;
	  }
	  var _props$focusedDateTra = props.focusedDateTrace,
	      date = _props$focusedDateTra.data.localDate,
	      position = _props$focusedDateTra.position;
	
	  var formattedDate = (0, _d3TimeFormat.utcFormat)('%A, %B %-d')(Date.parse(date));
	  return _react2.default.createElement(
	    'div',
	    { className: _CBGDateTraceLabel2.default.container },
	    _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _CBGDateTraceLabel2.default.dateLabel },
	        formattedDate
	      ),
	      borderWidth: 0,
	      position: { left: position.left, top: 2.25 * position.yPositions.topMargin },
	      side: 'bottom',
	      tail: false
	    })
	  );
	};
	
	CBGDateTraceLabel.propTypes = {
	  focusedDateTrace: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      localDate: _react.PropTypes.string.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      yPositions: _react.PropTypes.shape({
	        top: _react.PropTypes.number.isRequired,
	        topMargin: _react.PropTypes.number.isRequired
	      })
	    })
	  })
	};
	
	var _default = CBGDateTraceLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGDateTraceLabel, 'CBGDateTraceLabel', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTraceLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTraceLabel.js');
	})();

	;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Tooltip = __webpack_require__(7);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Tooltip = function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	    _this.state = { offset: { top: 0, left: 0 } };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculateOffset(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.calculateOffset(nextProps);
	    }
	  }, {
	    key: 'calculateOffset',
	    value: function calculateOffset(currentProps) {
	      var propOffset = currentProps.offset,
	          side = currentProps.side,
	          tail = currentProps.tail;
	
	      var offset = {};
	      var tooltipRect = this.element.getBoundingClientRect();
	      var horizontalOffset = propOffset.left != null ? propOffset.left : propOffset.horizontal || 0;
	      if (side === 'left') {
	        horizontalOffset = -horizontalOffset;
	      }
	      if (tail) {
	        var tailRect = this.tailElem.getBoundingClientRect();
	        var tailCenter = {
	          top: tailRect.top + tailRect.height / 2,
	          left: tailRect.left + tailRect.width / 2
	        };
	        offset.top = -tailCenter.top + tooltipRect.top + propOffset.top;
	        offset.left = -tailCenter.left + tooltipRect.left + horizontalOffset;
	      } else {
	        var leftOffset = void 0;
	        var topOffset = void 0;
	        switch (side) {
	          case 'top':
	            leftOffset = -tooltipRect.width / 2;
	            topOffset = -tooltipRect.height;
	            break;
	          case 'bottom':
	            leftOffset = -tooltipRect.width / 2;
	            topOffset = 0;
	            break;
	          case 'right':
	            leftOffset = 0;
	            topOffset = -tooltipRect.height / 2;
	            break;
	          case 'left':
	          default:
	            leftOffset = -tooltipRect.width;
	            topOffset = -tooltipRect.height / 2;
	        }
	        offset.top = topOffset + propOffset.top;
	        offset.left = leftOffset + horizontalOffset;
	      }
	
	      this.setState({ offset: offset });
	    }
	  }, {
	    key: 'renderTail',
	    value: function renderTail() {
	      var _this2 = this;
	
	      var backgroundColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'white';
	      var _props = this.props,
	          tailWidth = _props.tailWidth,
	          tailHeight = _props.tailHeight,
	          borderWidth = _props.borderWidth,
	          borderColor = _props.borderColor,
	          side = _props.side;
	
	      var tailSide = side === 'left' ? 'right' : 'left';
	      var padding = 10;
	      var marginOuterValue = void 0;
	      var marginInnerValue = void 0;
	      if (tailSide === 'left') {
	        marginOuterValue = 'calc(-100% - (4 * ' + tailWidth + 'px - ' + padding + 'px)';
	        marginInnerValue = 'calc(-100% - (4 * ' + tailWidth + 'px - ' + padding + 'px - ' + (borderWidth + 1) + 'px))';
	      } else {
	        marginOuterValue = 'calc(' + padding + 'px + ' + borderWidth + 'px)';
	        marginInnerValue = padding - 1 + 'px';
	      }
	      var borderSide = tailSide === 'left' ? 'right' : 'left';
	      var tailInnerColor = this.props.tailColor || this.props.backgroundColor || backgroundColor;
	      // The two child divs form the solid color tail and the border around it by layering
	      // on one another offset by the border width adjusted slightly for the angle
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', {
	          ref: function ref(_ref2) {
	            _this2.tailElem = _ref2;
	          },
	          className: _Tooltip2.default.tail,
	          style: _defineProperty({
	            marginTop: '-' + tailHeight + 'px',
	            marginLeft: marginOuterValue,
	            borderWidth: tailHeight + 'px ' + 2 * tailWidth + 'px'
	          }, 'border' + _lodash2.default.capitalize(borderSide) + 'Color', borderColor)
	        }),
	        tailInnerColor !== borderColor && _react2.default.createElement('div', {
	          className: _Tooltip2.default.tail,
	          style: _defineProperty({
	            marginTop: '-' + tailHeight + 'px',
	            marginLeft: marginInnerValue,
	            borderWidth: tailHeight + 'px ' + 2 * tailWidth + 'px'
	          }, 'border' + _lodash2.default.capitalize(borderSide) + 'Color', this.props.tailColor || this.props.backgroundColor || backgroundColor)
	        })
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(title) {
	      var _props2 = this.props,
	          tail = _props2.tail,
	          content = _props2.content;
	
	      var renderedTitle = null;
	      if (title) {
	        renderedTitle = _react2.default.createElement(
	          'div',
	          { className: _Tooltip2.default.title },
	          _react2.default.createElement(
	            'span',
	            null,
	            title
	          ),
	          tail && !content && this.renderTail(_Tooltip2.default.tooltipTitleBg)
	        );
	      }
	      return renderedTitle;
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent(content) {
	      var renderedContent = null;
	      var tail = this.props.tail;
	
	      if (content) {
	        renderedContent = _react2.default.createElement(
	          'div',
	          { className: _Tooltip2.default.content },
	          _react2.default.createElement(
	            'span',
	            null,
	            content
	          ),
	          tail && this.renderTail()
	        );
	      }
	      return renderedContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          title = _props3.title,
	          content = _props3.content,
	          position = _props3.position,
	          backgroundColor = _props3.backgroundColor,
	          borderColor = _props3.borderColor,
	          borderWidth = _props3.borderWidth;
	      var offset = this.state.offset;
	
	      var top = position.top + offset.top;
	      var left = position.left + offset.left;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: _Tooltip2.default.tooltip,
	          style: { top: top, left: left, backgroundColor: backgroundColor, borderColor: borderColor, borderWidth: borderWidth + 'px' },
	          ref: function ref(_ref4) {
	            _this3.element = _ref4;
	          }
	        },
	        title && this.renderTitle(title),
	        content && this.renderContent(content)
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.propTypes = {
	  title: _react.PropTypes.node,
	  content: _react.PropTypes.node,
	  position: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  offset: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number,
	    horizontal: _react.PropTypes.number
	  }).isRequired,
	  tail: _react.PropTypes.bool.isRequired,
	  side: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
	  tailWidth: _react.PropTypes.number.isRequired,
	  tailHeight: _react.PropTypes.number.isRequired,
	  tailColor: _react.PropTypes.string,
	  backgroundColor: _react.PropTypes.string,
	  borderColor: _react.PropTypes.string.isRequired,
	  borderWidth: _react.PropTypes.number.isRequired
	};
	
	Tooltip.defaultProps = {
	  tail: true,
	  side: 'left',
	  tailWidth: 7,
	  tailHeight: 8,
	  borderColor: 'black',
	  borderWidth: 2,
	  offset: { top: 0, left: 0 }
	};
	
	var _default = Tooltip;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Tooltip, 'Tooltip', '/Users/krystophv/tidepool/viz/src/components/common/tooltips/Tooltip.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/common/tooltips/Tooltip.js');
	})();

	;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)(module), (function() { return this; }())))

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(8);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Tooltip.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Tooltip.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".Tooltip--tooltip--11k8T{display:block;background-color:#fff;border:solid;pointer-events:none;position:absolute;border-radius:4px}.Tooltip--content--3kiTD{display:flex;align-items:center;justify-content:space-between;width:100%;padding:5px 10px;box-sizing:border-box}.Tooltip--content--3kiTD span{width:100%}.Tooltip--title--3FG33{background-color:var(--tooltip-title-bg)}.Tooltip--tail--3IQ2Y{width:0;height:0;border-style:solid;border-color:transparent;position:absolute}", ""]);
	
	// exports
	exports.locals = {
		"tooltipTitleBg": "var(--tooltip-title-bg)",
		"tooltip": "Tooltip--tooltip--11k8T " + __webpack_require__(10).locals["defaultSize"] + "",
		"content": "Tooltip--content--3kiTD",
		"title": "Tooltip--title--3FG33 " + __webpack_require__(10).locals["mediumContrastText"] + " Tooltip--content--3kiTD",
		"tail": "Tooltip--tail--3IQ2Y"
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".typography--whiteText--2eeXA{color:#fff;fill:#fff}.typography--boldText--osnHv{font-weight:700}.typography--lightText--3OxWt{font-weight:300}.typography--smallSize--3N0Zi{font-size:12px}.typography--axisSize--1AWL1{font-size:14px}.typography--largeSize--2187z{font-size:17px}.typography--defaultSize--vpvHG{font-size:14px}.typography--largeSize--2187z{font-size:16px}.typography--mediumContrastText--uXnbW{color:var(--text-medium-contrast);fill:var(--text-medium-contrast)}.typography--highContrastText--3ek29{color:var(--text-high-contrast);fill:var(--text-high-contrast)}.typography--noWrap--3endD{white-space:nowrap}.typography--svgMiddleAnchored--3FWrW{text-anchor:middle}.typography--svgRightAnchored--uk3Z8{text-anchor:end}.typography--svgStartAnchored--3vZKR{text-anchor:start}.typography--svgVerticalCentered--39MGn{dominant-baseline:central}", ""]);
	
	// exports
	exports.locals = {
		"whiteText": "typography--whiteText--2eeXA",
		"boldText": "typography--boldText--osnHv",
		"lightText": "typography--lightText--3OxWt",
		"smallSize": "typography--smallSize--3N0Zi",
		"axisSize": "typography--axisSize--1AWL1",
		"largeSize": "typography--largeSize--2187z",
		"defaultSize": "typography--defaultSize--vpvHG",
		"mediumContrastText": "typography--mediumContrastText--uXnbW",
		"highContrastText": "typography--highContrastText--3ek29",
		"noWrap": "typography--noWrap--3endD",
		"svgMiddleAnchored": "typography--svgMiddleAnchored--3FWrW",
		"svgRightAnchored": "typography--svgRightAnchored--uk3Z8",
		"svgStartAnchored": "typography--svgStartAnchored--3vZKR",
		"svgVerticalCentered": "typography--svgVerticalCentered--39MGn"
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(13)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = require("d3-time");

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(15);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(16), undefined);
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".CBGDateTraceLabel--container--2soV7{top:0}", ""]);
	
	// exports
	exports.locals = {
		"container": "CBGDateTraceLabel--container--2soV7 " + __webpack_require__(16).locals["absolute"] + " " + __webpack_require__(16).locals["smallHorizontalPadding"] + "",
		"dateLabel": "CBGDateTraceLabel--dateLabel--1f7xM " + __webpack_require__(10).locals["highContrastText"] + " " + __webpack_require__(10).locals["noWrap"] + " " + __webpack_require__(10).locals["defaultSize"] + ""
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".layout--absolute--8t5yq{pointer-events:none;position:absolute}.layout--smallHorizontalPadding--aaAoX{padding:0 6px}", ""]);
	
	// exports
	exports.locals = {
		"absolute": "layout--absolute--8t5yq",
		"smallHorizontalPadding": "layout--smallHorizontalPadding--aaAoX"
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(4);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _constants = __webpack_require__(18);
	
	var _format = __webpack_require__(19);
	
	var _datetime = __webpack_require__(22);
	
	var _FocusedRangeLabels = __webpack_require__(30);
	
	var _FocusedRangeLabels2 = _interopRequireDefault(_FocusedRangeLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var FocusedRangeLabels = function FocusedRangeLabels(props) {
	  var focusedKeys = props.focusedKeys,
	      focusedRange = props.focusedRange,
	      focusedSlice = props.focusedSlice;
	
	  if (!(focusedRange || focusedKeys && focusedSlice)) {
	    return null;
	  }
	  // no range labels when focus is the median only on cbg version
	  if (focusedKeys && focusedKeys.length === 1) {
	    return null;
	  }
	
	  var bgPrefs = props.bgPrefs,
	      dataType = props.dataType;
	
	  var isCbg = dataType === 'cbg';
	  var dataBucket = isCbg ? 'focusedSlice' : 'focusedRange';
	  var _props$dataBucket = props[dataBucket],
	      data = _props$dataBucket.data,
	      position = _props$dataBucket.position;
	
	  var timeFrom = (0, _datetime.formatClocktimeFromMsPer24)(data.msFrom);
	  var timeTo = (0, _datetime.formatClocktimeFromMsPer24)(data.msTo);
	  var top = isCbg ? focusedKeys[1] : 'max';
	  var center = isCbg ? 'median' : 'mean';
	  var bottom = isCbg ? focusedKeys[0] : 'min';
	  var topPosition = {
	    top: position.yPositions[top],
	    left: position.left
	  };
	  var bottomPosition = {
	    top: position.yPositions[bottom],
	    left: position.left
	  };
	  var centerPosition = {
	    top: position.yPositions[center],
	    left: position.left
	  };
	  var centerSide = position.tooltipLeft ? 'left' : 'right';
	  return _react2.default.createElement(
	    'div',
	    { className: _FocusedRangeLabels2.default.container },
	    isCbg ? _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.timeLabel },
	        timeFrom,
	        ' - ',
	        timeTo
	      ),
	      borderWidth: 0,
	      position: { left: position.left, top: position.yPositions.topMargin },
	      side: 'bottom',
	      tail: false
	    }) : null,
	    _react2.default.createElement(_Tooltip2.default, {
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.number },
	        (0, _format.formatBgValue)(data[top], bgPrefs, data.outOfRangeThresholds)
	      ),
	      backgroundColor: 'transparent',
	      borderColor: 'transparent',
	      offset: { left: 0, top: isCbg ? props.numberOffsets.top : 0 },
	      position: topPosition,
	      side: 'top',
	      tail: false
	    }),
	    isCbg ? null : _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.explainerText },
	        timeFrom,
	        ' - ',
	        timeTo
	      ),
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.number },
	        'Average ' + (0, _format.formatBgValue)(data[center], bgPrefs, data.outOfRangeThresholds)
	      ),
	      offset: { top: 0, horizontal: props.numberOffsets.horizontal },
	      position: centerPosition,
	      side: centerSide
	    }),
	    _react2.default.createElement(_Tooltip2.default, {
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.number },
	        (0, _format.formatBgValue)(data[bottom], bgPrefs, data.outOfRangeThresholds)
	      ),
	      backgroundColor: 'transparent',
	      borderColor: 'transparent',
	      offset: { left: 0, top: isCbg ? props.numberOffsets.bottom : 0 },
	      position: bottomPosition,
	      side: 'bottom',
	      tail: false
	    })
	  );
	};
	
	FocusedRangeLabels.defaultProps = {
	  numberOffsets: {
	    bottom: -5,
	    horizontal: 10,
	    top: 5
	  }
	};
	
	FocusedRangeLabels.propTypes = {
	  bgPrefs: _react.PropTypes.shape({
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  dataType: _react.PropTypes.oneOf(['cbg', 'smbg']).isRequired,
	  focusedKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	  focusedRange: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      id: _react.PropTypes.string.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      mean: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      msX: _react.PropTypes.number.isRequired,
	      msFrom: _react.PropTypes.number.isRequired,
	      msTo: _react.PropTypes.number.isRequired,
	      outOfRangeThresholds: _react.PropTypes.shape({
	        low: _react.PropTypes.number,
	        high: _react.PropTypes.number
	      })
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        max: _react.PropTypes.number.isRequired,
	        mean: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  focusedSlice: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      id: _react.PropTypes.string.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      msFrom: _react.PropTypes.number.isRequired,
	      msTo: _react.PropTypes.number.isRequired,
	      msX: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      outOfRangeThresholds: _react.PropTypes.shape({
	        low: _react.PropTypes.number,
	        high: _react.PropTypes.number
	      }),
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired,
	        topMargin: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  numberOffsets: _react.PropTypes.shape({
	    bottom: _react.PropTypes.number.isRequired,
	    horizontal: _react.PropTypes.number.isRequired,
	    top: _react.PropTypes.number.isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react2.default.PropTypes.bool.isRequired,
	    timezoneName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, null])
	  }).isRequired
	};
	
	var _default = FocusedRangeLabels;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FocusedRangeLabels, 'FocusedRangeLabels', '/Users/krystophv/tidepool/viz/src/components/trends/common/FocusedRangeLabels.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/FocusedRangeLabels.js');
	})();

	;

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ANIMAS, _INSULET, _MEDTRONIC, _TANDEM, _default, _pumpVocabulary;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var BG_HIGH = exports.BG_HIGH = 'High';
	var BG_LOW = exports.BG_LOW = 'Low';
	
	var STIFFNESS = 180;
	var DAMPING = 40;
	var PRECISION = 0.1;
	
	var springConfig = exports.springConfig = { stiffness: STIFFNESS, damping: DAMPING, precision: PRECISION };
	
	var MGDL_CLAMP_TOP = exports.MGDL_CLAMP_TOP = 400;
	var MMOLL_CLAMP_TOP = exports.MMOLL_CLAMP_TOP = 22.5;
	
	var MGDL_UNITS = exports.MGDL_UNITS = 'mg/dL';
	var MMOLL_UNITS = exports.MMOLL_UNITS = 'mmol/L';
	var MGDL_PER_MMOLL = exports.MGDL_PER_MMOLL = 18.01559;
	
	var ONE_WEEK = 7;
	var TWO_WEEKS = 14;
	var FOUR_WEEKS = 28;
	
	var trends = exports.trends = { extentSizes: { ONE_WEEK: ONE_WEEK, TWO_WEEKS: TWO_WEEKS, FOUR_WEEKS: FOUR_WEEKS } };
	
	var MS_IN_DAY = exports.MS_IN_DAY = 864e5;
	var MS_IN_HOUR = exports.MS_IN_HOUR = 864e5 / 24;
	var MS_IN_MIN = exports.MS_IN_MIN = MS_IN_HOUR / 60;
	
	var CGM_READINGS_ONE_DAY = exports.CGM_READINGS_ONE_DAY = 288;
	var CGM_DATA_KEY = exports.CGM_DATA_KEY = 'cbg';
	var BGM_DATA_KEY = exports.BGM_DATA_KEY = 'smbg';
	var NO_CGM = exports.NO_CGM = 'noCGM';
	var CGM_CALCULATED = exports.CGM_CALCULATED = 'calculatedCGM';
	var NOT_ENOUGH_CGM = exports.NOT_ENOUGH_CGM = 'notEnoughCGM';
	
	var NO_SITE_CHANGE = exports.NO_SITE_CHANGE = 'noSiteChange';
	var SITE_CHANGE = exports.SITE_CHANGE = 'siteChange';
	var SITE_CHANGE_RESERVOIR = exports.SITE_CHANGE_RESERVOIR = 'reservoirChange';
	var SITE_CHANGE_TUBING = exports.SITE_CHANGE_TUBING = 'tubingPrime';
	var SITE_CHANGE_CANNULA = exports.SITE_CHANGE_CANNULA = 'cannulaPrime';
	
	var AUTOMATED_DELIVERY = exports.AUTOMATED_DELIVERY = 'automatedDelivery';
	var SCHEDULED_DELIVERY = exports.SCHEDULED_DELIVERY = 'scheduledDelivery';
	
	var SECTION_TYPE_UNDECLARED = exports.SECTION_TYPE_UNDECLARED = 'undeclared';
	
	var INSULET = exports.INSULET = 'Insulet';
	var TANDEM = exports.TANDEM = 'Tandem';
	var ANIMAS = exports.ANIMAS = 'Animas';
	var MEDTRONIC = exports.MEDTRONIC = 'Medtronic';
	
	var pumpVocabulary = exports.pumpVocabulary = (_pumpVocabulary = {}, _defineProperty(_pumpVocabulary, ANIMAS, (_ANIMAS = {}, _defineProperty(_ANIMAS, SITE_CHANGE_RESERVOIR, 'Go Rewind'), _defineProperty(_ANIMAS, SITE_CHANGE_TUBING, 'Go Prime'), _defineProperty(_ANIMAS, SITE_CHANGE_CANNULA, 'Fill Cannula'), _ANIMAS)), _defineProperty(_pumpVocabulary, INSULET, (_INSULET = {}, _defineProperty(_INSULET, SITE_CHANGE_RESERVOIR, 'Change Pod'), _defineProperty(_INSULET, SITE_CHANGE_TUBING, 'Activate Pod'), _defineProperty(_INSULET, SITE_CHANGE_CANNULA, 'Prime'), _INSULET)), _defineProperty(_pumpVocabulary, MEDTRONIC, (_MEDTRONIC = {}, _defineProperty(_MEDTRONIC, SITE_CHANGE_RESERVOIR, 'Rewind'), _defineProperty(_MEDTRONIC, SITE_CHANGE_TUBING, 'Prime'), _defineProperty(_MEDTRONIC, SITE_CHANGE_CANNULA, 'Prime Cannula'), _defineProperty(_MEDTRONIC, AUTOMATED_DELIVERY, 'Auto Mode'), _defineProperty(_MEDTRONIC, SCHEDULED_DELIVERY, 'Manual'), _MEDTRONIC)), _defineProperty(_pumpVocabulary, TANDEM, (_TANDEM = {}, _defineProperty(_TANDEM, SITE_CHANGE_RESERVOIR, 'Change Cartridge'), _defineProperty(_TANDEM, SITE_CHANGE_TUBING, 'Fill Tubing'), _defineProperty(_TANDEM, SITE_CHANGE_CANNULA, 'Fill Cannula'), _TANDEM)), _defineProperty(_pumpVocabulary, 'default', (_default = {}, _defineProperty(_default, SITE_CHANGE_RESERVOIR, 'Change Cartridge'), _defineProperty(_default, SITE_CHANGE_TUBING, 'Fill Tubing'), _defineProperty(_default, SITE_CHANGE_CANNULA, 'Fill Cannula'), _defineProperty(_default, AUTOMATED_DELIVERY, 'Automated'), _defineProperty(_default, SCHEDULED_DELIVERY, 'Manual'), _default)), _pumpVocabulary);
	
	var AUTOMATED_BASAL_DEVICE_MODELS = exports.AUTOMATED_BASAL_DEVICE_MODELS = _defineProperty({}, MEDTRONIC, ['1780']);
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BG_HIGH, 'BG_HIGH', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(BG_LOW, 'BG_LOW', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(STIFFNESS, 'STIFFNESS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(DAMPING, 'DAMPING', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(PRECISION, 'PRECISION', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(springConfig, 'springConfig', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MGDL_CLAMP_TOP, 'MGDL_CLAMP_TOP', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MMOLL_CLAMP_TOP, 'MMOLL_CLAMP_TOP', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MGDL_UNITS, 'MGDL_UNITS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MMOLL_UNITS, 'MMOLL_UNITS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MGDL_PER_MMOLL, 'MGDL_PER_MMOLL', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(ONE_WEEK, 'ONE_WEEK', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(TWO_WEEKS, 'TWO_WEEKS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(FOUR_WEEKS, 'FOUR_WEEKS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(trends, 'trends', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MS_IN_DAY, 'MS_IN_DAY', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MS_IN_HOUR, 'MS_IN_HOUR', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MS_IN_MIN, 'MS_IN_MIN', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(CGM_READINGS_ONE_DAY, 'CGM_READINGS_ONE_DAY', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(CGM_DATA_KEY, 'CGM_DATA_KEY', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(BGM_DATA_KEY, 'BGM_DATA_KEY', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(NO_CGM, 'NO_CGM', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(CGM_CALCULATED, 'CGM_CALCULATED', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(NOT_ENOUGH_CGM, 'NOT_ENOUGH_CGM', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(NO_SITE_CHANGE, 'NO_SITE_CHANGE', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(SITE_CHANGE, 'SITE_CHANGE', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(SITE_CHANGE_RESERVOIR, 'SITE_CHANGE_RESERVOIR', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(SITE_CHANGE_TUBING, 'SITE_CHANGE_TUBING', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(SITE_CHANGE_CANNULA, 'SITE_CHANGE_CANNULA', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(AUTOMATED_DELIVERY, 'AUTOMATED_DELIVERY', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(SCHEDULED_DELIVERY, 'SCHEDULED_DELIVERY', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(SECTION_TYPE_UNDECLARED, 'SECTION_TYPE_UNDECLARED', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(INSULET, 'INSULET', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(TANDEM, 'TANDEM', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(ANIMAS, 'ANIMAS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MEDTRONIC, 'MEDTRONIC', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(pumpVocabulary, 'pumpVocabulary', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(AUTOMATED_BASAL_DEVICE_MODELS, 'AUTOMATED_BASAL_DEVICE_MODELS', '/Users/krystophv/tidepool/viz/src/utils/constants.js');
	})();

	;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatBgValue = formatBgValue;
	exports.formatDecimalNumber = formatDecimalNumber;
	exports.formatInsulin = formatInsulin;
	exports.formatPercentage = formatPercentage;
	exports.removeTrailingZeroes = removeTrailingZeroes;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Format = __webpack_require__(20);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * formatBgValue
	 * @param {Number} val - integer or float blood glucose value in either mg/dL or mmol/L
	 * @param {Object} bgPrefs - object containing bgUnits String and bgBounds Object
	 * @param {Object} [outOfRangeThresholds] - optional thresholds for `low` and `high` values;
	 *                                          derived from annotations in PwD's data, so may not exist
	 *
	 * @return {String} formatted blood glucose value
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	/*
	 * Guidelines for these utilities:
	 *
	 * 1. Only "workhorse" functions used in 2+ places should be here.
	 * 1a. A function used in multiple components for one view should live
	 * in view-specific utils: src/utils/[view]/format.js
	 * 1b. A function used in only one component should just be part of that component,
	 * potentially as a named export if tests are deemed important to have.
	 * 1c. This set of utilities is ONLY for NON-datetime related formatting. Any functions
	 * used for formatting dates and/or times should go in src/utils/datetime.js
	 *
	 * 2. Function naming scheme: the main verb here is `format`. Start all function names with that.
	 *
	 * 3. Function organizational scheme in this file and tests file: alphabetical plz
	 *
	 * 4. Try to be consistent in how params are used:
	 * (e.g., always pass in `bgPrefs`) rather than some (subset) of bgUnits and/or bgBounds
	 * and try to copy & paste JSDoc @param descriptions for common params.
	 *
	 */
	
	function formatBgValue(val, bgPrefs, outOfRangeThresholds) {
	  var units = _lodash2.default.get(bgPrefs, 'bgUnits', '');
	  if (!_lodash2.default.isEmpty(outOfRangeThresholds)) {
	    var lowThreshold = outOfRangeThresholds.low;
	    var highThreshold = outOfRangeThresholds.high;
	    if (units === _constants.MMOLL_UNITS) {
	      if (lowThreshold) {
	        lowThreshold = (0, _bloodglucose.convertToMmolL)(lowThreshold);
	      }
	      if (highThreshold) {
	        highThreshold = (0, _bloodglucose.convertToMmolL)(highThreshold);
	      }
	    }
	    if (lowThreshold && val < lowThreshold) {
	      return _constants.BG_LOW;
	    }
	    if (highThreshold && val > highThreshold) {
	      return _constants.BG_HIGH;
	    }
	  }
	  if (units === _constants.MMOLL_UNITS) {
	    return (0, _d3Format.format)('.1f')(val);
	  }
	  return (0, _d3Format.format)('d')(val);
	}
	
	/**
	 * formatDecimalNumber
	 * @param {Number} val - numeric value to format
	 * @param {Number} [places] - optional number of decimal places to display;
	 *                            if not provided, will display as integer (0 decimal places)
	 *
	 * @return {String} numeric value rounded to the desired number of decimal places
	 */
	function formatDecimalNumber(val, places) {
	  if (places === null || places === undefined) {
	    return (0, _d3Format.format)('d')(val);
	  }
	  return (0, _d3Format.format)('.' + places + 'f')(val);
	}
	
	/**
	 * formatInsulin
	 *
	 * @export
	 * @param {Number} val - numeric value to format
	 * @returns {String} numeric value formatted for the precision of insulin dosing
	 */
	function formatInsulin(val) {
	  var decimalLength = 1;
	  var qtyString = val.toString();
	  if (qtyString.indexOf('.') !== -1) {
	    var length = qtyString.split('.')[1].length;
	    decimalLength = _lodash2.default.min([length, 3]);
	  }
	  return formatDecimalNumber(val, decimalLength);
	}
	
	/**
	 * formatPercentage
	 * @param {Number} val - raw decimal proportion, range of 0.0 to 1.0
	 *
	 * @return {String} percentage
	 */
	function formatPercentage(val) {
	  if (Number.isNaN(val)) {
	    return '--%';
	  }
	  return (0, _d3Format.format)('.0%')(val);
	}
	
	/**
	 * removeTrailingZeroes
	 * @param {String} - formatted decimal value, may have trailing zeroes
	 *
	 * @return {String} - formatted decimal value w/o trailing zero-indexes
	 */
	function removeTrailingZeroes(val) {
	  return val.replace(/\.0+$/, '');
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(formatBgValue, 'formatBgValue', '/Users/krystophv/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(formatDecimalNumber, 'formatDecimalNumber', '/Users/krystophv/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(formatInsulin, 'formatInsulin', '/Users/krystophv/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(formatPercentage, 'formatPercentage', '/Users/krystophv/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(removeTrailingZeroes, 'removeTrailingZeroes', '/Users/krystophv/tidepool/viz/src/utils/format.js');
	})();

	;

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = require("d3-format");

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.classifyBgValue = classifyBgValue;
	exports.calcBgPercentInCategories = calcBgPercentInCategories;
	exports.convertToMmolL = convertToMmolL;
	exports.reshapeBgClassesToBgBounds = reshapeBgClassesToBgBounds;
	exports.generateBgRangeLabels = generateBgRangeLabels;
	exports.getOutOfRangeThreshold = getOutOfRangeThreshold;
	exports.weightedCGMCount = weightedCGMCount;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(18);
	
	var _format = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	/**
	 * classifyBgValue
	 * @param {Object} bgBounds - object describing boundaries for blood glucose categories
	 * @param {Number} bgValue - integer or float blood glucose value in either mg/dL or mmol/L
	 * @param {String} classificationType - 'threeWay' or 'fiveWay'
	 *
	 * @return {String} bgClassification - low, target, high
	 */
	function classifyBgValue(bgBounds, bgValue) {
	  var classificationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'threeWay';
	
	  if (_lodash2.default.isEmpty(bgBounds) || !_lodash2.default.isNumber(_lodash2.default.get(bgBounds, 'targetLowerBound')) || !_lodash2.default.isNumber(_lodash2.default.get(bgBounds, 'targetUpperBound'))) {
	    throw new Error('You must provide a `bgBounds` object with a `targetLowerBound` and a `targetUpperBound`!');
	  }
	  if (!_lodash2.default.isNumber(bgValue) || !_lodash2.default.gt(bgValue, 0)) {
	    throw new Error('You must provide a positive, numerical blood glucose value to categorize!');
	  }
	  var veryLowThreshold = bgBounds.veryLowThreshold,
	      targetLowerBound = bgBounds.targetLowerBound,
	      targetUpperBound = bgBounds.targetUpperBound,
	      veryHighThreshold = bgBounds.veryHighThreshold;
	
	  if (classificationType === 'fiveWay') {
	    if (bgValue < veryLowThreshold) {
	      return 'veryLow';
	    } else if (bgValue >= veryLowThreshold && bgValue < targetLowerBound) {
	      return 'low';
	    } else if (bgValue > targetUpperBound && bgValue <= veryHighThreshold) {
	      return 'high';
	    } else if (bgValue > veryHighThreshold) {
	      return 'veryHigh';
	    }
	    return 'target';
	  }
	  if (bgValue < targetLowerBound) {
	    return 'low';
	  } else if (bgValue > targetUpperBound) {
	    return 'high';
	  }
	  return 'target';
	}
	
	/**
	 * calcBgPercentInCategories
	 * @param {Array} data - Array of Tidepool cbg or smbg data
	 * @param {Object} bgBounds - object describing boundaries for blood glucose categories
	 *
	 * @return {Object} bgPercentInCategories - object w/keys veryLow, low, target, high, veryHigh
	 *                  and 0.0 to 1.0 percentage values
	 */
	function calcBgPercentInCategories(data, bgBounds) {
	  var bgPercentInCategories = {};
	  var grouped = _lodash2.default.groupBy(data, function (d) {
	    return classifyBgValue(bgBounds, d.value, 'fiveWay');
	  });
	  _lodash2.default.each(['veryLow', 'low', 'target', 'high', 'veryHigh'], function (key) {
	    bgPercentInCategories[key] = (grouped[key] && grouped[key].length || 0) / data.length;
	  });
	  return bgPercentInCategories;
	}
	
	/**
	 * convertToMmolL
	 * @param {Number} bgVal - blood glucose value in mg/dL
	 *
	 * @return {Number} convertedBgVal - blood glucose value in mmol/L, unrounded
	 */
	function convertToMmolL(val) {
	  return val / _constants.MGDL_PER_MMOLL;
	}
	
	/**
	 * reshapeBgClassesToBgBounds
	 * @param {Object} bgPrefs - bgPrefs object from blip containing tideline-style bgClasses
	 *
	 * @return {Object} bgBounds - @tidepool/viz-style bgBounds
	 */
	function reshapeBgClassesToBgBounds(bgPrefs) {
	  var bgClasses = bgPrefs.bgClasses;
	
	  var bgBounds = {
	    veryHighThreshold: bgClasses.high.boundary,
	    targetUpperBound: bgClasses.target.boundary,
	    targetLowerBound: bgClasses.low.boundary,
	    veryLowThreshold: bgClasses['very-low'].boundary
	  };
	
	  return bgBounds;
	}
	
	/**
	 * Generate BG Range Labels for a given set of bg prefs
	 *
	 * @export
	 * @param {Object} bgPrefs - bgPrefs object containing viz-style bgBounds and the bgUnits
	 * @returns {Object} bgRangeLabels - map of labels keyed by bgClassification
	 */
	function generateBgRangeLabels(bgPrefs) {
	  var bgBounds = bgPrefs.bgBounds,
	      bgUnits = bgPrefs.bgUnits;
	
	  var thresholds = _lodash2.default.mapValues(bgBounds, function (threshold) {
	    return (0, _format.formatBgValue)(threshold, bgPrefs);
	  });
	
	  return {
	    veryLow: 'below ' + thresholds.veryLowThreshold + ' ' + bgUnits,
	    low: 'between ' + thresholds.veryLowThreshold + ' - ' + thresholds.targetLowerBound + ' ' + bgUnits,
	    target: 'between ' + thresholds.targetLowerBound + ' - ' + thresholds.targetUpperBound + ' ' + bgUnits,
	    high: 'between ' + thresholds.targetUpperBound + ' - ' + thresholds.veryHighThreshold + ' ' + bgUnits,
	    veryHigh: 'above ' + thresholds.veryHighThreshold + ' ' + bgUnits
	  };
	}
	
	/**
	 * getOutOfRangeThreshold
	 * @param {Object} bgDatum
	 * @return Object containing out of range threshold or null
	 */
	function getOutOfRangeThreshold(bgDatum) {
	  var outOfRangeAnnotation = _lodash2.default.find(bgDatum.annotations || [], function (annotation) {
	    return annotation.code === 'bg/out-of-range';
	  });
	  return outOfRangeAnnotation ? _defineProperty({}, outOfRangeAnnotation.value, outOfRangeAnnotation.threshold) : null;
	}
	
	/**
	 * Get the adjusted count of expected CGM data points for devices that do not sample at the default
	 * 5 minute interval, such as the Abbot FreeStyle Libre, which samples every 15 mins
	 *
	 * @param {Array} data - cgm data
	 * @return {Integer} count - the weighted count
	 */
	function weightedCGMCount(data) {
	  return _lodash2.default.reduce(data, function (total, datum) {
	    var datumWeight = 1;
	
	    // Because our decision as to whether or not there's enough cgm data to warrant using
	    // it to calculate average BGs is based on the expected number of readings in a day,
	    // we need to adjust the weight of a for the Freestyle Libre datum, as it only
	    // collects BG samples every 15 minutes as opposed the default 5 minutes from dexcom.
	    if (datum.type === 'cbg' && datum.deviceId.indexOf('AbbottFreeStyleLibre') === 0) {
	      datumWeight = 3;
	    }
	
	    return total + datumWeight;
	  }, 0);
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(classifyBgValue, 'classifyBgValue', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(calcBgPercentInCategories, 'calcBgPercentInCategories', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(convertToMmolL, 'convertToMmolL', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(reshapeBgClassesToBgBounds, 'reshapeBgClassesToBgBounds', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(generateBgRangeLabels, 'generateBgRangeLabels', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(getOutOfRangeThreshold, 'getOutOfRangeThreshold', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(weightedCGMCount, 'weightedCGMCount', '/Users/krystophv/tidepool/viz/src/utils/bloodglucose.js');
	})();

	;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TWENTY_FOUR_HRS = exports.THREE_HRS = exports.ONE_HR = exports.THIRTY_MINS = undefined;
	exports.addDuration = addDuration;
	exports.getBrowserTimezone = getBrowserTimezone;
	exports.getTimezoneFromTimePrefs = getTimezoneFromTimePrefs;
	exports.formatBirthdate = formatBirthdate;
	exports.formatClocktimeFromMsPer24 = formatClocktimeFromMsPer24;
	exports.formatCurrentDate = formatCurrentDate;
	exports.formatDiagnosisDate = formatDiagnosisDate;
	exports.formatDateRange = formatDateRange;
	exports.formatDuration = formatDuration;
	exports.formatLocalizedFromUTC = formatLocalizedFromUTC;
	exports.getHammertimeFromDatumWithTimePrefs = getHammertimeFromDatumWithTimePrefs;
	exports.getLocalizedCeiling = getLocalizedCeiling;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3TimeFormat = __webpack_require__(12);
	
	var _momentTimezone = __webpack_require__(23);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _sundial = __webpack_require__(24);
	
	var _sundial2 = _interopRequireDefault(_sundial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	/*
	 * Guidelines for these utilities:
	 *
	 * 1. Only "workhorse" functions used in 2+ places should be here.
	 * 1a. A function used in multiple components for one view should live
	 * in view-specific utils: src/utils/[view]/datetime.js
	 * 1b. A function used in only one component should just be part of that component,
	 * potentially as a named export if tests are deemed important to have.
	 *
	 * 2. Function naming scheme: the two main verbs here are `get` and `format`.
	 * 2a. If the function returns any kind of datetime (JavaScript Date, hammertime, ISO 8601 String),
	 * then the function name should start with `get`.
	 * 2b. If the function returns a _formatted_ String that will be **surfaced to the end user**,
	 * then the function name should start with `format`.
	 *
	 * 3. Function organizational scheme in this file and tests file: alphabetical plz, unless ESLint
	 * complains about an undefined (e.g., getTimezoneFromTimePrefs must be at the top).
	 *
	 * 4. Try to be consistent in how params are used:
	 * (e.g., always pass in `timePrefs`) rather than a named timezone
	 * and try to copy & paste JSDoc @param descriptions for common params.
	 *
	 */
	
	var THIRTY_MINS = exports.THIRTY_MINS = 1800000;
	// using d3-time-format because time is time of data access in
	// user’s browser time, not PwD’s configured timezone
	var ONE_HR = exports.ONE_HR = 3600000;
	var THREE_HRS = exports.THREE_HRS = 10800000;
	var TWENTY_FOUR_HRS = exports.TWENTY_FOUR_HRS = 86400000;
	
	/**
	 * addDuration
	 * @param {String} datetime - an ISO date string
	 * @param {Number} duration - milliseconds to add to date
	 * @returns new Date ISO string - the provided datetime + duration
	 */
	function addDuration(startTime, duration) {
	  var dateTime = new Date(startTime);
	
	  return new Date(dateTime.valueOf() + duration).toISOString();
	}
	
	/**
	 * getBrowserTimezone
	 * @returns {String} browser-determined timezone name
	 */
	function getBrowserTimezone() {
	  return new Intl.DateTimeFormat().resolvedOptions().timeZone;
	}
	
	/**
	 * getTimezoneFromTimePrefs
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {String} timezoneName from timePrefs, browser, or fallback to 'UTC'
	 */
	function getTimezoneFromTimePrefs(timePrefs) {
	  var timezoneAware = timePrefs.timezoneAware,
	      timezoneName = timePrefs.timezoneName;
	
	  try {
	    var timezone = getBrowserTimezone() || 'UTC';
	    if (timezoneAware && timezoneName) {
	      timezone = timezoneName;
	    }
	    _sundial2.default.checkTimezoneName(timezone);
	    return timezone;
	  } catch (err) {
	    return 'UTC';
	  }
	}
	
	/**
	 * formatBirthdate
	 * @param {Object} patient - Tidepool patient object containing profile
	 *
	 * @return {String} formatted birthdate, e.g., 'Jul 4, 1975'; empty String if none found
	 */
	function formatBirthdate(patient) {
	  var bday = _lodash2.default.get(patient, ['profile', 'patient', 'birthday'], '');
	  if (bday) {
	    return (0, _d3TimeFormat.utcFormat)('%b %-d, %Y')(Date.parse(bday));
	  }
	  return '';
	}
	
	/**
	 * formatClocktimeFromMsPer24
	 * @param {Number} duration - positive integer representing a time of day
	 *                            in milliseconds within a 24-hr day
	 * @param {String} [format] - optional moment display format string; default is 'h:mm a'
	 *
	 * @return {String} formatted clocktime, e.g., '12:05 pm'
	 */
	function formatClocktimeFromMsPer24(milliseconds) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'h:mm a';
	
	  if (_lodash2.default.isNull(milliseconds) || _lodash2.default.isUndefined(milliseconds) || milliseconds < 0 || milliseconds > TWENTY_FOUR_HRS || milliseconds instanceof Date) {
	    throw new Error('First argument must be a value in milliseconds per twenty-four hour day!');
	  }
	  return _momentTimezone2.default.utc(milliseconds).format(format);
	}
	
	/**
	 * formatCurrentDate
	 * @return {String} formatted current date, e.g., 'Jul 4, 2017';
	 */
	function formatCurrentDate() {
	  return (0, _d3TimeFormat.timeFormat)('%b %-d, %Y')(new Date());
	}
	
	/**
	 * formatDiagnosisDate
	 * @param {Object} patient - Tidepool patient object containing profile
	 *
	 * @return {String} formatted diagnosis date, e.g., 'Jul 4, 1975'; empty String if none found
	 */
	function formatDiagnosisDate(patient) {
	  var diagnosis = _lodash2.default.get(patient, ['profile', 'patient', 'diagnosisDate'], '');
	  if (diagnosis) {
	    return (0, _d3TimeFormat.utcFormat)('%b %-d, %Y')(Date.parse(diagnosis));
	  }
	  return '';
	}
	
	/**
	 * formatDateRange
	 * @param {String|Date} startDate - A moment-compatible date object or string
	 * @param {String|Date} endDate - A moment-compatible date object or string
	 * @param {String} format - Optional. The moment format string to parse startDate and endDate with
	 */
	function formatDateRange(startDate, endDate, format) {
	  var start = _momentTimezone2.default.utc(startDate, format);
	  var end = _momentTimezone2.default.utc(endDate, format);
	
	  var isSameYear = start.isSame(end, 'year');
	  var startFormat = isSameYear ? start.format('MMM D') : start.format('MMM D, YYYY');
	  var endFormat = end.format('MMM D, YYYY');
	
	  var formattedRange = startFormat + ' - ' + endFormat;
	
	  return formattedRange;
	}
	
	/**
	 * formatDuration
	 * @param {Number} duration - positive integer duration in milliseconds
	 *
	 * @return {String} formatted duration, e.g., '1¼ hr'
	 */
	function formatDuration(duration) {
	  var momentDuration = _momentTimezone2.default.duration(duration);
	  var QUARTER = '¼';
	  var THIRD = '⅓';
	  var HALF = '½';
	  var TWO_THIRDS = '⅔';
	  var THREE_QUARTERS = '¾';
	  var hours = momentDuration.hours();
	  var minutes = momentDuration.minutes();
	
	  if (hours !== 0) {
	    var suffix = hours === 1 ? 'hr' : 'hrs';
	    switch (minutes) {
	      case 0:
	        return hours + ' ' + suffix;
	      case 15:
	        return '' + hours + QUARTER + ' ' + suffix;
	      case 20:
	        return '' + hours + THIRD + ' ' + suffix;
	      case 30:
	        return '' + hours + HALF + ' ' + suffix;
	      case 40:
	        return '' + hours + TWO_THIRDS + ' ' + suffix;
	      case 45:
	        return '' + hours + THREE_QUARTERS + ' ' + suffix;
	      default:
	        return hours + ' ' + suffix + ' ' + minutes + ' min';
	    }
	  } else {
	    return minutes + ' min';
	  }
	}
	
	/**
	 * formatLocalizedFromUTC
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 * @param  {String} [format] - optional moment display format string; default is 'dddd, MMMM D'
	 *
	 * @return {String} formatted datetime, e.g., 'Sunday, January 1'
	 */
	function formatLocalizedFromUTC(utc, timePrefs) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dddd, MMMM D';
	
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = getTimezoneFromTimePrefs(timePrefs);
	  return _momentTimezone2.default.utc(utc).tz(timezone).format(format);
	}
	
	/**
	 * getHammertimeFromDatumWithTimePrefs
	 * @param {Object} datum - a Tidepool datum with a time (required) and deviceTime (optional)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {Number} Integer hammertime (i.e., UTC time in milliseconds)
	 */
	function getHammertimeFromDatumWithTimePrefs(datum, timePrefs) {
	  var hammertime = void 0;
	  if (timePrefs.timezoneAware) {
	    if (!_lodash2.default.isUndefined(datum.time)) {
	      hammertime = Date.parse(datum.time);
	    } else {
	      hammertime = null;
	    }
	  } else {
	    if (!_lodash2.default.isUndefined(datum.deviceTime)) {
	      hammertime = Date.parse(datum.deviceTime);
	    } else {
	      hammertime = null;
	    }
	  }
	  if (_lodash2.default.isNaN(hammertime)) {
	    throw new Error('Check your input datum; could not parse `time` or `deviceTime` with Date.parse.');
	  }
	  return hammertime;
	}
	
	/**
	 * getLocalizedCeiling
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {Object} a JavaScript Date, the closest (future) midnight according to timePrefs;
	 *                  if utc is already local midnight, returns utc
	 */
	function getLocalizedCeiling(utc, timePrefs) {
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = getTimezoneFromTimePrefs(timePrefs);
	  var startOfDay = _momentTimezone2.default.utc(utc).tz(timezone).startOf('day');
	
	  var utcHammertime = typeof utc === 'string' ? Date.parse(utc) : utc;
	  if (startOfDay.valueOf() === utcHammertime) {
	    return startOfDay.toDate();
	  }
	  return startOfDay.add(1, 'day').toDate();
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(THIRTY_MINS, 'THIRTY_MINS', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(ONE_HR, 'ONE_HR', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(THREE_HRS, 'THREE_HRS', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(TWENTY_FOUR_HRS, 'TWENTY_FOUR_HRS', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(addDuration, 'addDuration', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getBrowserTimezone, 'getBrowserTimezone', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getTimezoneFromTimePrefs, 'getTimezoneFromTimePrefs', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatBirthdate, 'formatBirthdate', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatClocktimeFromMsPer24, 'formatClocktimeFromMsPer24', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatCurrentDate, 'formatCurrentDate', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatDiagnosisDate, 'formatDiagnosisDate', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatDateRange, 'formatDateRange', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatDuration, 'formatDuration', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatLocalizedFromUTC, 'formatLocalizedFromUTC', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getHammertimeFromDatumWithTimePrefs, 'getHammertimeFromDatumWithTimePrefs', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getLocalizedCeiling, 'getLocalizedCeiling', '/Users/krystophv/tidepool/viz/src/utils/datetime.js');
	})();

	;

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = require("moment-timezone");

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// == BSD2 LICENSE ==
	// Copyright (c) 2014, Tidepool Project
	//
	// This program is free software; you can redistribute it and/or modify it under
	// the terms of the associated License, which is identical to the BSD 2-Clause
	// License as published by the Open Source Initiative at opensource.org.
	//
	// This program is distributed in the hope that it will be useful, but WITHOUT
	// ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	// FOR A PARTICULAR PURPOSE. See the License for more details.
	//
	// You should have received a copy of the License along with this program; if
	// not, you can obtain one from Tidepool Project at tidepool.org.
	// == BSD2 LICENSE ==
	
	'use strict';
	
	var moment = __webpack_require__(23);
	
	module.exports = __webpack_require__(25)(moment);


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// == BDS2 LICENSE ==
	// Copyright (C) 2014 Tidepool Project
	//
	// This program is free software; you can redistribute it and/or modify it under
	// the terms of the associated License, which is identical to the BSD 2-Clause
	// License as published by the Open Source Initiative at opensource.org.
	//
	// This program is distributed in the hope that it will be useful, but WITHOUT
	// ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	// FOR A PARTICULAR PURPOSE. See the License for more details.
	//
	// You should have received a copy of the License along with this program; if
	// not, you can obtain one at http://tidepool.org/licenses/
	// == BDS2 LICENSE ==
	
	/* * * * */
	// NB: DO NOT RETURN MOMENT OBJECTS FROM ANY METHOD IN THIS MODULE
	// DO NOT PASS GO, DO NOT COLLECT $200
	/* * * * */
	
	'use strict';
	var format = __webpack_require__(26).format;
	
	var datetimeWrapper = function(moment) {
	  var DEFAULT_DISPLAY_MASK = 'MMMM D [at] h:mm a';
	
	  function _applyMask(moment, mask) {
	    return moment.format(mask);
	  }
	
	  var timezoneNames = {};
	  moment.tz.names().forEach(function(name) {
	    timezoneNames[name] = true;
	  });
	
	  return {
	    /*
	     * Apply an offset to a timestamp (timezone-naive or Zulu)
	     *
	     * @param {String} timestamp
	     * @param {Number} offset mins ~from~ UTC
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    applyOffset: function(timestamp, offset) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      return moment.utc(timestamp).add(offset, 'minutes').toDate();
	    },
	    /*
	     * Apply a timezone to a timezone-naive timestamp
	     *
	     * @param {String} timestamp
	     * @param {String} timezone a valid timezone name as per moment-timezone
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    applyTimezone: function(timestamp, timezone) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      this.checkTimezoneName(timezone);
	      // NB: the result of this method will *not* yield the correct timezone offset from .getTimezoneOffset()
	      // that is, the offset corresponding to the passed in timezone
	      // because JavaScript Date doesn't do arbitrary timezones, only browser local
	      if (timezone == null) {
	        // some browsers assume no timezone offset means local time and others assume it means UTC
	        // we explicitly make them all act like it is UTC
	        return moment.utc(timestamp).toDate();
	      } else {
	        if (timestamp instanceof Date) {
	          return moment.tz(timestamp.toISOString().slice(0,-5), timezone).toDate();
	        }
	        return moment.tz(timestamp, timezone).toDate();
	      }
	    },
	    /*
	     * Apply a timezone and a conversionOffset to a timezone-naive timestamp
	     *
	     * @param {String} timestamp
	     * @param {String} timezone a valid timezone name as per moment-timezone
	     * @param {Number} conversionOffset milliseconds ~from~ UTC
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    applyTimezoneAndConversionOffset: function(timestamp, timezone, conversionOffset) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      this.checkTimezoneName(timezone);
	      // NB: the result of this method will *not* yield the correct timezone offset from .getTimezoneOffset()
	      // that is, the offset corresponding to the passed in timezone
	      // because JavaScript Date doesn't do arbitrary timezones, only browser local
	      if (timezone == null) {
	        // some browsers assume no timezone offset means local time and others assume it means UTC
	        // we explicitly make them all act like it is UTC
	        return moment.utc(timestamp).toDate();
	      } else {
	        if (timestamp instanceof Date) {
	          return moment.tz(timestamp.toISOString().slice(0,-5), timezone)
	            .subtract(conversionOffset, 'milliseconds').toDate();
	        }
	        return moment.tz(timestamp, timezone)
	          .subtract(conversionOffset, 'milliseconds').toDate();
	      }
	    },
	    /*
	     * Construct a Date from canonically-named time fields in the provided object
	     *
	     * @param {Object} with time fields 'year', 'month', 'day', etc.
	     * @return {Object} JavaScript Date
	     */
	    buildTimestamp: function(o) {
	      // months are (annoyingly) zero-indexed in JavaScript (i.e., January is 0, not 1)
	      var d = Date.UTC(o.year, o.month - 1, o.day, o.hours, o.minutes, o.seconds);
	      if (isNaN(d)) {
	        return null;
	      }
	      return new Date(d);
	    },
	    /*
	     * Get the ceiling for a date (see D3's time functions)
	     *
	     * @param {String} timestamp
	     * @param {String} units a valid units identifier per moment
	     * @param {String} timezone a valid timezone name as per moment-timezone
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    ceil: function(time, units, timezone) {
	      this.checkTimezoneName(timezone);
	      if (timezone == null) {
	        timezone = 'UTC';
	      }
	      return moment.utc(time).tz(timezone).startOf(units).add(1, units).toDate();
	    },
	    /*
	     * Check a timezone name against moment's database
	     *
	     * @param {String} timezone timezone name
	     */
	    checkTimezoneName: function(timezone) {
	      // actually want truthiness here; all of null, undefined, and '' should *not* throw Error
	      // only check actual strings to see if recognized by moment
	      if (timezone && timezoneNames[timezone] !== true) {
	        throw new Error('Unrecognized timezone name!');
	      }
	    },
	    /*
	     * Get the difference between two dates in the asked for units
	     *
	     * @param {String} timestampA
	     * @param {String} timestampB
	     * @param {String} units, a valid units identifier per moment e.g. days, hours, years ...
	     *
	     * @return {string} the difference between the two timestamps (which will be rounded down)
	     */
	    dateDifference: function(timestampA, timestampB, units) {
	      return moment.utc(timestampA).diff(moment.utc(timestampB), units);
	    },
	    /*
	     * Apply Tidepool timezoneOffset and conversionOffset to a JavaScript Date
	     *
	     * @param {Object} JavaScript Date formed from a deviceTime
	     * @param {Number} timezoneOffset mins ~from~ UTC
	     * @param {Number} conversionOffset milliseconds ~from~ UTC
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    findTimeFromDeviceTimeAndOffsets: function(dt, timezoneOffset, conversionOffset) {
	      if (!dt) {
	        throw new Error('No Date provided as first argument!');
	      }
	      return moment.utc(dt)
	        .subtract(timezoneOffset, 'minutes')
	        .subtract(conversionOffset, 'milliseconds')
	        .toDate();
	    },
	    /*
	     * Get the floor for a date (see D3's time functions)
	     *
	     * @param {String} timestamp
	     * @param {String} units a valid units identifier per moment
	     * @param {String} timezone a valid timezone name as per moment-timezone
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    floor: function(time, units, timezone) {
	      this.checkTimezoneName(timezone);
	      if (timezone == null) {
	        timezone = 'UTC';
	      }
	      return moment.utc(time).tz(timezone).startOf(units).toDate();
	    },
	    /*
	     * Format the input datetime as a deviceTime
	     *
	     * @param {Object|String|Number} JavaScript Date object, string timestamp, or integer timestamp
	     *
	     * @return {String} timezone-naive timestamp
	     */
	    formatDeviceTime: function(dt) {
	      if (!dt) {
	        throw new Error('No datetime provided as first argument!');
	      }
	      // use of .utc() here is for cross-browser consistency
	      return _applyMask(moment.utc(dt), 'YYYY-MM-DDTHH:mm:ss');
	    },
	    /*
	     * Format the given timestamp for display after applying the given offset
	     *
	     * @param {String} UTC timestamp
	     * @param {Number} offset mins ~from~ UTC
	     * @param {String} mask [mask='MMMM D [at] h:mm a'] the date format mask to apply
	     *
	     * @return {String} the formatted datetime
	     */
	    formatFromOffset: function(timestamp, offset, mask) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      mask = mask || DEFAULT_DISPLAY_MASK;
	      return _applyMask(moment(timestamp).utcOffset(offset), mask);
	    },
	    /*
	     * Format the given timestamp or Date obj with moment's "calendar time"
	     *
	     * @param {String|Object} timestamp or JavaScript Date object
	     *
	     * @return {String} the formatted "calendar time"
	     */
	    formatCalendarTime: function(dt) {
	      if (!dt) {
	        throw new Error('No datetime provided as first argument!');
	      }
	      return moment(dt).calendar();
	    },
	    /*
	     * Format the given timestamp for storage
	     *
	     * @param {String} timestamp
	     * @param {Number} offset mins ~from~ UTC
	     *
	     * @return {String} an ISO8601-formatted timestamp
	     */
	    formatForStorage: function(timestamp, offset) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      return moment(timestamp).utcOffset(offset).format();
	    },
	    /*
	     * Format the given timestamp for display in the given named timezone
	     *
	     * @param {String} UTC timestamp
	     * @param {String} timezone a valid timezone name as per moment-timezone
	     * @param {String} mask [mask='MMMM D [at] h:mm a'] the date format mask to apply
	     *
	     * @return {String} the formatted datetime
	     */
	    formatInTimezone: function(timestamp, timezone, mask) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      this.checkTimezoneName(timezone);
	      timezone = timezone || '';
	      mask = mask || DEFAULT_DISPLAY_MASK;
	      return _applyMask(moment(timestamp).tz(timezone), mask);
	    },
	    /*
	     * Get a date N days into the future
	     *
	     * @return {string} an ISO-8601-formatted zulu timestamp N days from now
	     */
	    futureDate: function(ndays) {
	      return moment().utc().add(ndays, 'days').toISOString();
	    },
	    /*
	     * Get how many milliseconds you are into a day
	     *
	     * @param {Object|String} JavaScript Date object or string timestamp
	     * @param {Number} offset mins ~from~ UTC
	     *
	     * @return {Number} milliseconds in current day
	     */
	    getMsFromMidnight: function(dt, offset) {
	      if (!dt) {
	        throw new Error('No datetime provided as first argument!');
	      }
	      // this function is used mainly for deciding when an event matches a device setting
	      // since devices report setting start times in milliseconds from midnight, device's local time
	      // i.e., a basal rate that starts at midnight device local time has a `start` of 0
	      // since we translate device local time into a UTC `time` and a `timezoneOffset` ~from~ UTC
	      // we need to translate back to local time then subtract midnight in local time
	      // to yield the number of milliseconds from midnight for the event
	      dt = moment(dt);
	      if (offset == null) {
	        offset = 0;
	      }
	      // we use -offset here because moment deals in offsets that are ~to~ UTC
	      // but we store JavaScript Date-style offsets that are ~from~ UTC
	      return dt.utcOffset(offset) - dt.clone().utcOffset(offset).startOf('day');
	    },
	    /*
	     * Get the offset from the current date
	     *
	     * @return {String} number of minutes offset ~from~ UTC
	     */
	    getOffset: function() {
	      return moment().utcOffset();
	    },
	    /*
	     * Get the offset from the given date
	     *
	     * @return {String} number of minutes offset ~from~ UTC
	     */
	    getOffsetFromTime: function(timestamp) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      function containsZone() {
	        var zonePattern = /^([+-][0-2]\d:[0-5]\d)$/;
	        return zonePattern.test(timestamp.slice(-6));
	      }
	      if (containsZone()) {
	        return moment.parseZone(timestamp).utcOffset();
	      }
	      return moment(timestamp).utcOffset();
	    },
	    /*
	     * Get the offset from the given UTC date plus named timezone
	     *
	     * @return {String} number of minutes offset ~from~ UTC
	     */
	    getOffsetFromZone: function(timestamp, timezone) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      this.checkTimezoneName(timezone);
	      return moment.utc(timestamp).tz(timezone).utcOffset();
	    },
	    /*
	     * Get all timezone objects
	     *
	     * @return {Object} a hash of arrays of timezone objects
	     * in convenient categories for displaying in a searchable dropdown
	     */
	    getTimezones: function() {
	      var tzNames = moment.tz.names();
	      var timezones = {
	        // main timezones of the U.S. lower 48
	        bigFour: [],
	        // remainder of U.S. timezones
	        unitedStates: [],
	        // the English-speaking world + Europe
	        hoisted: [],
	        // everywhere else
	        theRest: []
	      };
	      var big4 = {
	        'US/Eastern': true,
	        'US/Central': true,
	        'US/Mountain': true,
	        'US/Pacific': true
	      };
	      var newZealand = {
	        'Pacific/Auckland': true,
	        'Pacific/Chatham': true
	      };
	      var now = new Date().valueOf();
	      for (var i = 0; i < tzNames.length; ++i) {
	        var zone = moment.tz.zone(tzNames[i]);
	        // we use the current epoch time to determine the current UTC
	        // offset for each timezone (i.e., adjust for DST or not)
	        // the offset is part of the `label` attribute
	        var offsetInHours = moment.duration(zone.offset(now), 'minutes')
	          .asMilliseconds()/(1000*60*60);
	
	        // because moment signs offsets the opposite way from the ISO 8601 standard
	        // the standard is negative for N. American timezones
	        // but moment (and JavaScript in general) represent them as positive
	        var offsetAsString = offsetInHours > 0 ?
	          '-' + offsetInHours : '+' + Math.abs(offsetInHours);
	
	        var timezone = {
	          label: format('%s (UTC%s)', tzNames[i], offsetAsString),
	          value: tzNames[i],
	          offset: Number(offsetAsString)
	        };
	
	        if (big4[tzNames[i]]) {
	          timezones.bigFour.push(timezone);
	        }
	        else if (tzNames[i].search('US/') === 0) {
	          timezones.unitedStates.push(timezone);
	        }
	        else if (tzNames[i].search('Canada/') === 0) {
	          timezones.hoisted.push(timezone);
	        }
	        else if (tzNames[i].search('Europe/') === 0) {
	          timezones.hoisted.push(timezone);
	        }
	        else if (tzNames[i].search('Australia/') === 0) {
	          timezones.hoisted.push(timezone);
	        }
	        else if (newZealand[tzNames[i]]) {
	          timezones.hoisted.push(timezone);
	        }
	        // reformat these a tiny bit so that 'New Zealand' is searchable
	        else if (tzNames[i].search('NZ') === 0) {
	          timezone.label = timezone.label.replace('NZ', 'New Zealand');
	          timezones.hoisted.push(timezone);
	        }
	        // there's a whole bunch of timezones listed as "Etc/GMT+1"
	        // that clutter things up a lot...
	        else if (tzNames[i].search('GMT') !== -1) {}
	        else {
	          timezones.theRest.push(timezone);
	        }
	      }
	      return timezones;
	    },
	    /*
	     * Get the UTC time for a timezone-naive timestamp and timezone
	     *
	     * @param {String} timezone-naive timestamp
	     *
	     * @param {String} timezone name
	     *
	     * @return {Integer} UTC time
	     */
	    getUTCFromLocalTimeAndTimezone: function(timestamp, timezone) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      if (!timezone) {
	        throw new Error('A timezone is required!');
	      }
	      return moment.tz(timestamp, timezone).valueOf();
	    },
	    /*
	     * Is this an ISO8601-formatted timestamp?
	     *
	     * @param {String} timestamp
	     *
	     * @return {Boolean}
	     */
	    isISODate: function(timestamp) {
	      return (/^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/).test(timestamp);
	    },
	    /*
	     * Is this a valid date?
	     *
	     * @param {String} timestamp
	     *
	     * @return {Boolean}
	     */
	    isValidDate: function(timestamp) {
	      var m = moment(timestamp);
	      // Be careful, if `value` is empty, `m` can be null
	      return m && m.isValid();
	    },
	    /*
	     * Is this a valid date that matches the given date mask
	     * This is STRONGER validation than isValidDate and should be used
	     * e.g., when validating dates entered in forms
	     *
	     * @param {String} timestamp
	     * @param {String} mask [mask='MMMM D [at] h:mm a'] the date format mask to apply
	     *
	     * @return {Boolean}
	     */
	    isValidDateForMask: function(timestamp, mask) {
	      var m = moment(timestamp, mask, true);
	      // Be careful, if `value` is empty, `m` can be null
	      return m && m.isValid();
	    },
	    /*
	     * Parse a timestamp string using provided format and (optionally) timezone into a JavaScript Date
	     *
	     * @param {String} timestamp
	     * @param {String} format to parse the string with
	     * @param {String} timezone a valid timezone specifier as per moment-timezone
	     *
	     * @return {Object} JavaScript Date yielding accurate UTC string from .toISOString()
	     */
	    parseFromFormat: function(timestamp, format, timezone) {
	      if (!timestamp) {
	        throw new Error('No timestamp provided as first argument!');
	      }
	      this.checkTimezoneName(timezone);
	      if (timezone == null) {
	        // some browsers assume no timezone offset means local time and others assume it means UTC
	        // we explicitly make them all act like it is UTC
	        return moment.utc(timestamp, format).toDate();
	      } else {
	        return moment.tz(timestamp, format, timezone).toDate();
	      }
	    },
	    /*
	     * Translate a datetime string from one format mask to another
	     *
	     * @param {String} Input date and/or time string
	     * @param {String} Input's format mask
	     * @param {String} Desired output format mask
	     *
	     * @return {String} Reformatted date and/or time string
	     */
	    translateMask: function(timestr, inputMask, outputMask) {
	      if (!timestr) {
	        throw new Error('No datetime provided as first argument!');
	      }
	      var res = moment(timestr, inputMask).format(outputMask);
	      if (res !== 'Invalid date') {
	        return res;
	      }
	      else {
	        var e = new Error('Input datetime ' + timestr + ' did not match input mask ' + inputMask);
	        console.error(e);
	        throw e;
	      }
	    },
	    /*
	     * Get a UTC based string that represents `now`
	     *
	     * @return {String} an ISO8601-formatted timestamp with the offset from UTC specified
	     */
	    utcDateString: function() {
	      return moment().format();
	    },
	    /*
	     *== CONSTANTS ==*
	     */
	    SEC_TO_MSEC: 1000,
	    MIN_TO_MSEC: 60 * 1000,
	    MIN30_TO_MSEC: 30 * 60 * 1000
	  };
	};
	
	// CommonJS module is defined
	if(typeof module != 'undefined' && module.exports){
	  module.exports = datetimeWrapper;
	}


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(28);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(29);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(27)))

/***/ },
/* 27 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 29 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(31);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedRangeLabels.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedRangeLabels.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(16), undefined);
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".FocusedRangeLabels--container--3xGNN{top:0}.FocusedRangeLabels--explainerText--LaA5m{display:block}", ""]);
	
	// exports
	exports.locals = {
		"container": "FocusedRangeLabels--container--3xGNN " + __webpack_require__(16).locals["absolute"] + " " + __webpack_require__(16).locals["smallHorizontalPadding"] + "",
		"number": "FocusedRangeLabels--number--2kw_y " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(10).locals["highContrastText"] + " " + __webpack_require__(10).locals["noWrap"] + " " + __webpack_require__(10).locals["largeSize"] + "",
		"explainerText": "FocusedRangeLabels--explainerText--LaA5m " + __webpack_require__(10).locals["highContrastText"] + " " + __webpack_require__(10).locals["noWrap"] + "",
		"timeLabel": "FocusedRangeLabels--timeLabel--1DqNJ " + __webpack_require__(10).locals["highContrastText"] + " " + __webpack_require__(10).locals["noWrap"] + " " + __webpack_require__(10).locals["defaultSize"] + ""
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Tooltip = __webpack_require__(4);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _SMBGTooltip = __webpack_require__(33);
	
	var _SMBGTooltip2 = _interopRequireDefault(_SMBGTooltip);
	
	var _constants = __webpack_require__(18);
	
	var _format = __webpack_require__(19);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _datetime = __webpack_require__(22);
	
	var _FocusedSMBGPointLabel = __webpack_require__(39);
	
	var _FocusedSMBGPointLabel2 = _interopRequireDefault(_FocusedSMBGPointLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// tooltip offsets
	var SIMPLE_VALUE_TOP_OFFSET = 10; /*
	                                   * == BSD2 LICENSE ==
	                                   * Copyright (c) 2016, Tidepool Project
	                                   *
	                                   * This program is free software; you can redistribute it and/or modify it under
	                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                   * License as published by the Open Source Initiative at opensource.org.
	                                   *
	                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                   *
	                                   * You should have received a copy of the License along with this program; if
	                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                   * == BSD2 LICENSE ==
	                                   */
	
	var SIMPLE_DAY_TOP_OFFSET = 10;
	var SIMPLE_DAY_HORIZ_OFFSET = 30;
	var DETAILED_DAY_HORIZ_OFFSET = 10;
	
	var FocusedSMBGPointLabel = function FocusedSMBGPointLabel(props) {
	  var focusedPoint = props.focusedPoint;
	
	  if (!focusedPoint) {
	    return null;
	  }
	
	  var bgPrefs = props.bgPrefs,
	      _props$focusedPoint = props.focusedPoint,
	      datum = _props$focusedPoint.datum,
	      position = _props$focusedPoint.position,
	      allSmbgsOnDate = _props$focusedPoint.allSmbgsOnDate,
	      allPositions = _props$focusedPoint.allPositions,
	      timePrefs = props.timePrefs,
	      lines = props.lines;
	
	
	  var hammertime = (0, _datetime.getHammertimeFromDatumWithTimePrefs)(datum, timePrefs);
	  var lineDate = (0, _datetime.formatLocalizedFromUTC)(hammertime, timePrefs);
	  var shortDate = (0, _datetime.formatLocalizedFromUTC)(hammertime, timePrefs, 'MMM D');
	  var side = position.tooltipLeft ? 'left' : 'right';
	  var smbgsOnDate = allSmbgsOnDate.slice();
	  var positions = allPositions.slice();
	  if (!lines) {
	    var focusedPointIndex = _lodash2.default.findIndex(allSmbgsOnDate, function (d) {
	      return d.value === datum.value;
	    });
	    _lodash2.default.pullAt(smbgsOnDate, focusedPointIndex);
	    _lodash2.default.pullAt(positions, focusedPointIndex);
	  }
	  var pointTooltips = _lodash2.default.map(smbgsOnDate, function (smbg, i) {
	    return _react2.default.createElement(_Tooltip2.default, {
	      key: i,
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.number },
	        (0, _format.formatBgValue)(smbg.value, bgPrefs, (0, _bloodglucose.getOutOfRangeThreshold)(smbg))
	      ),
	      position: positions[i],
	      side: 'bottom',
	      tail: false,
	      offset: { top: SIMPLE_VALUE_TOP_OFFSET, left: 0 }
	    });
	  });
	  var focusedTooltip = void 0;
	  if (lines) {
	    focusedTooltip = _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.explainerText },
	        lineDate
	      ),
	      position: position,
	      side: side,
	      offset: {
	        top: SIMPLE_DAY_TOP_OFFSET,
	        horizontal: SIMPLE_DAY_HORIZ_OFFSET
	      }
	    });
	  } else {
	    focusedTooltip = _react2.default.createElement(_SMBGTooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.tipWrapper },
	        _react2.default.createElement(
	          'span',
	          { className: _FocusedSMBGPointLabel2.default.dateTime },
	          shortDate + ', ' + (0, _datetime.formatClocktimeFromMsPer24)(datum.msPer24)
	        )
	      ),
	      position: position,
	      side: side,
	      offset: {
	        top: 0,
	        horizontal: DETAILED_DAY_HORIZ_OFFSET
	      },
	      smbg: datum,
	      bgPrefs: bgPrefs,
	      timePrefs: timePrefs
	    });
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: _FocusedSMBGPointLabel2.default.container },
	    pointTooltips,
	    focusedTooltip
	  );
	};
	
	FocusedSMBGPointLabel.propTypes = {
	  bgPrefs: _react.PropTypes.shape({
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  focusedPoint: _react.PropTypes.shape({
	    allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })),
	    allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    })),
	    date: _react.PropTypes.string.isRequired,
	    datum: _react.PropTypes.shape({
	      deviceTime: _react.PropTypes.string,
	      msPer24: _react.PropTypes.number.isRequired,
	      subType: _react.PropTypes.string,
	      time: _react.PropTypes.string,
	      value: _react.PropTypes.number.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })
	  }),
	  grouped: _react2.default.PropTypes.bool.isRequired,
	  lines: _react2.default.PropTypes.bool.isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react2.default.PropTypes.bool.isRequired,
	    timezoneName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, null])
	  }).isRequired
	};
	
	var _default = FocusedSMBGPointLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SIMPLE_VALUE_TOP_OFFSET, 'SIMPLE_VALUE_TOP_OFFSET', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(SIMPLE_DAY_TOP_OFFSET, 'SIMPLE_DAY_TOP_OFFSET', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(SIMPLE_DAY_HORIZ_OFFSET, 'SIMPLE_DAY_HORIZ_OFFSET', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(DETAILED_DAY_HORIZ_OFFSET, 'DETAILED_DAY_HORIZ_OFFSET', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(FocusedSMBGPointLabel, 'FocusedSMBGPointLabel', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	})();

	;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _format = __webpack_require__(19);
	
	var _datetime = __webpack_require__(22);
	
	var _annotations = __webpack_require__(34);
	
	var _Tooltip = __webpack_require__(4);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _colors = __webpack_require__(35);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _SMBGTooltip = __webpack_require__(37);
	
	var _SMBGTooltip2 = _interopRequireDefault(_SMBGTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGTooltip = function (_PureComponent) {
	  _inherits(SMBGTooltip, _PureComponent);
	
	  function SMBGTooltip() {
	    _classCallCheck(this, SMBGTooltip);
	
	    return _possibleConstructorReturn(this, (SMBGTooltip.__proto__ || Object.getPrototypeOf(SMBGTooltip)).apply(this, arguments));
	  }
	
	  _createClass(SMBGTooltip, [{
	    key: 'renderSMBG',
	    value: function renderSMBG() {
	      var smbg = this.props.smbg;
	      var outOfRangeMessage = (0, _annotations.getOutOfRangeAnnotationMessage)(smbg);
	      var rows = [_react2.default.createElement(
	        'div',
	        { key: 'bg', className: _SMBGTooltip2.default.bg },
	        _react2.default.createElement(
	          'div',
	          { className: _SMBGTooltip2.default.label },
	          'BG'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _SMBGTooltip2.default.value },
	          '' + (0, _format.formatBgValue)(smbg.value, this.props.bgPrefs, (0, _bloodglucose.getOutOfRangeThreshold)(smbg))
	        )
	      )];
	
	      var source = !_lodash2.default.isEmpty(smbg.subType) ? '' + _lodash2.default.capitalize(smbg.subType) : 'Meter';
	      rows.push(_react2.default.createElement(
	        'div',
	        { key: 'source', className: _SMBGTooltip2.default.source },
	        _react2.default.createElement(
	          'div',
	          { className: _SMBGTooltip2.default.label },
	          'Source'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _SMBGTooltip2.default.value },
	          source
	        )
	      ));
	
	      _lodash2.default.each((0, _annotations.getMedtronic600AnnotationMessages)(smbg), function (annotation) {
	        rows.push(_react2.default.createElement(
	          'div',
	          {
	            key: annotation.message.label,
	            className: _SMBGTooltip2.default[_lodash2.default.camelCase(annotation.message.label)]
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _SMBGTooltip2.default.label },
	            annotation.message.label
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _SMBGTooltip2.default.value },
	            annotation.message.value
	          )
	        ));
	      });
	
	      if (!_lodash2.default.isEmpty(outOfRangeMessage)) {
	        var bgClass = (0, _bloodglucose.classifyBgValue)((0, _bloodglucose.reshapeBgClassesToBgBounds)(this.props.bgPrefs), this.props.smbg.value);
	        rows.push(_react2.default.createElement('div', {
	          key: 'divider',
	          className: _SMBGTooltip2.default.dividerLarge,
	          style: { backgroundColor: _colors2.default[bgClass] }
	        }));
	        rows.push(_react2.default.createElement(
	          'div',
	          { key: 'outOfRange', className: _SMBGTooltip2.default.annotation },
	          outOfRangeMessage[0].message.value
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _SMBGTooltip2.default.container },
	        rows
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bgClass = (0, _bloodglucose.classifyBgValue)((0, _bloodglucose.reshapeBgClassesToBgBounds)(this.props.bgPrefs), this.props.smbg.value);
	      var title = this.props.title ? this.props.title : _react2.default.createElement(
	        'div',
	        { className: _SMBGTooltip2.default.title },
	        (0, _datetime.formatLocalizedFromUTC)(this.props.smbg.normalTime, this.props.timePrefs, 'h:mm a')
	      );
	      return _react2.default.createElement(_Tooltip2.default, _extends({}, this.props, {
	        title: title,
	        content: this.renderSMBG(),
	        borderColor: _colors2.default[bgClass],
	        tailColor: _colors2.default[bgClass]
	      }));
	    }
	  }]);
	
	  return SMBGTooltip;
	}(_react.PureComponent);
	
	SMBGTooltip.propTypes = {
	  position: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  offset: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number,
	    horizontal: _react.PropTypes.number
	  }),
	  titls: _react.PropTypes.node,
	  tail: _react.PropTypes.bool.isRequired,
	  side: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
	  tailColor: _react.PropTypes.string.isRequired,
	  tailWidth: _react.PropTypes.number.isRequired,
	  tailHeight: _react.PropTypes.number.isRequired,
	  backgroundColor: _react.PropTypes.string,
	  borderColor: _react.PropTypes.string.isRequired,
	  borderWidth: _react.PropTypes.number.isRequired,
	  smbg: _react.PropTypes.shape({
	    type: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string.isRequired,
	    value: _react.PropTypes.number.isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.object.isRequired,
	  bgPrefs: _react.PropTypes.shape({
	    bgClasses: _react.PropTypes.object.isRequired,
	    bgUnits: _react.PropTypes.string.isRequired
	  }).isRequired
	};
	
	SMBGTooltip.defaultProps = {
	  tail: true,
	  side: 'right',
	  tailWidth: 9,
	  tailHeight: 17,
	  tailColor: _colors2.default.bolus,
	  borderColor: _colors2.default.bolus,
	  borderWidth: 2
	};
	
	var _default = SMBGTooltip;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGTooltip, 'SMBGTooltip', '/Users/krystophv/tidepool/viz/src/components/daily/smbgtooltip/SMBGTooltip.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/daily/smbgtooltip/SMBGTooltip.js');
	})();

	;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAnnotations = getAnnotations;
	exports.getAnnotationCodes = getAnnotationCodes;
	exports.getMedtronic600AnnotationMessages = getMedtronic600AnnotationMessages;
	exports.getOutOfRangeAnnotationMessage = getOutOfRangeAnnotationMessage;
	exports.getAnnotationMessages = getAnnotationMessages;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var medtronic600BGMessages = {
	  'medtronic600/smbg/user-accepted-remote-bg': 'Yes',
	  'medtronic600/smbg/user-rejected-remote-bg': 'No',
	  'medtronic600/smbg/remote-bg-acceptance-screen-timeout': 'Timed Out'
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	/*
	 * Guidelines for these utilities:
	 *
	 * 1. Only "workhorse" functions used in 2+ places should be here.
	 * 1a. A function used in only one component should just be part of that component,
	 * potentially as a named export if tests are deemed important to have.
	 *
	 * 2. Function naming scheme: the main verb here is `get`. Start all function names with that.
	 *
	 * 3. Function organizational scheme in this file and tests file: alphabetical plz
	 *
	 * 4. Try to be consistent in how params are used:
	 * (e.g., always pass in `bgPrefs`) rather than some (subset) of bgUnits and/or bgBounds
	 * and try to copy & paste JSDoc @param descriptions for common params.
	 *
	 */
	
	/* eslint-disable max-len */
	
	
	var simpleAnnotationMessages = {
	  'animas/bolus/extended-equal-split': "* Animas pumps don't capture the details of how combo boluses are split between the normal and extended amounts."
	};
	
	/**
	 * getAnnotations
	 *
	 * @export
	 * @param {Object} datum - data object potentially containing annotations
	 * @returns {Array} array of annotation objects or empty array
	 */
	function getAnnotations(datum) {
	  return _lodash2.default.get(datum, 'annotations', []);
	}
	
	/**
	 * getAnnotationCodes
	 *
	 * @export
	 * @param {Object} datum - data object potentially containing annotations
	 * @returns {Array} array of annotation codes or empty array
	 */
	function getAnnotationCodes(datum) {
	  return _lodash2.default.map(getAnnotations(datum), 'code');
	}
	
	/**
	 * getMedtronic600AnnotationMessages
	 *
	 * @export
	 * @param {Object} datum - data object potentially containing annotations
	 * @returns {Array} array of objects with string values and labels or empty array
	 */
	function getMedtronic600AnnotationMessages(datum) {
	  var annotations = getAnnotations(datum);
	  var annotationCodes = getAnnotationCodes(datum);
	  var messages = [];
	  var medtronic600BGMessage = _lodash2.default.intersection(_lodash2.default.keys(medtronic600BGMessages), annotationCodes);
	  if (medtronic600BGMessage.length > 0) {
	    messages.push(_lodash2.default.assign(_lodash2.default.find(annotations, { code: medtronic600BGMessage[0] }), {
	      message: {
	        label: 'Confirm BG',
	        value: medtronic600BGMessages[medtronic600BGMessage[0]]
	      }
	    }));
	  }
	  return messages;
	}
	
	/**
	 * getOutOfRangeAnnotationMessage
	 *
	 * @export
	 * @param {Object} datum - data object potentially containing annotations
	 * @returns {Array} array with object with string value or empty array
	 */
	function getOutOfRangeAnnotationMessage(datum) {
	  var annotations = getAnnotations(datum);
	  var messages = [];
	  _lodash2.default.each(annotations, function (annotation) {
	    if (_lodash2.default.get(annotation, 'code', '') === 'bg/out-of-range') {
	      var value = annotation.value;
	      messages.push(_lodash2.default.assign(annotation, {
	        message: {
	          value: '* This BG value was ' + value + 'er than your device could record. Your actual BG value is ' + value + 'er than it appears here.'
	        }
	      }));
	    }
	  });
	  return messages;
	}
	
	/**
	 * getAnnotationMessages
	 *
	 * @export
	 * @param {Object} datum - data object potentially containing annotations
	 * @returns {Array} array of objects with string values and potentially labels or empty array
	 */
	function getAnnotationMessages(datum) {
	  var annotations = getAnnotations(datum);
	  var messages = [];
	  messages = messages.concat(getMedtronic600AnnotationMessages(datum), getOutOfRangeAnnotationMessage(datum));
	
	  _lodash2.default.each(annotations, function (annotation) {
	    var code = _lodash2.default.get(annotation, 'code');
	    if (_lodash2.default.has(simpleAnnotationMessages, code)) {
	      messages.push(_lodash2.default.assign(annotation, {
	        message: {
	          value: simpleAnnotationMessages[code]
	        }
	      }));
	    }
	  });
	  return messages;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(medtronic600BGMessages, 'medtronic600BGMessages', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	
	  __REACT_HOT_LOADER__.register(simpleAnnotationMessages, 'simpleAnnotationMessages', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	
	  __REACT_HOT_LOADER__.register(getAnnotations, 'getAnnotations', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	
	  __REACT_HOT_LOADER__.register(getAnnotationCodes, 'getAnnotationCodes', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	
	  __REACT_HOT_LOADER__.register(getMedtronic600AnnotationMessages, 'getMedtronic600AnnotationMessages', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	
	  __REACT_HOT_LOADER__.register(getOutOfRangeAnnotationMessage, 'getOutOfRangeAnnotationMessage', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	
	  __REACT_HOT_LOADER__.register(getAnnotationMessages, 'getAnnotationMessages', '/Users/krystophv/tidepool/viz/src/utils/annotations.js');
	})();

	;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(36);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../node_modules/postcss-loader/index.js!./colors.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../node_modules/postcss-loader/index.js!./colors.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--basal:#19a0d7;--basal-automated:#00d3e6;--bolus:#7cd0f0;--bolus--interrupted:#ff8b7c;--bolus--ride:#107ea8;--bolus--undelivered:#bcecfa;--carbs:#ffd382;--collapsible--border:#ededed;--table-stripe--light:#f7f7f7;--table-stripe--dark:#ececec;--trends--light:#d0d0d0;--trends--light--faded:#f0f0f0;--trends--dark:#bcbcbc;--trends--dark--faded:#e3e3e3;--axis-tick:#e7e7e7;--bkgrnd:#f8f8f8;--bkgrnd-lines:#e7e7e7;--bkgrnd-white:#fff;--tooltip-title-bg:#eaeaee;--chrome:#989897;--text-medium-contrast:#727375;--text-high-contrast:#281946;--text-black:#000;--bg-low:#ff8b7c;--bg-target:#76d3a6;--bg-high:#bb9ae7;--text-hover:#00d3d9;--blue-green-light:#12d3d8;--gray-medium:#989897;--gray-dark:#4e4e4f;--white:#fff;--brand-purple:#627cff;--brand-purple-dark:#281946}", ""]);
	
	// exports
	exports.locals = {
		"bolus": "#7CD0F0",
		"basal": "#19A0D7",
		"low": "#FF8B7C",
		"target": "#76D3A6",
		"high": "#BB9AE7"
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(38);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGTooltip.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGTooltip.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(36), "");
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".SMBGTooltip--container--2cF-n{opacity:1;display:flex;flex-direction:column;min-width:80px;margin:2px 0;max-width:180px}.SMBGTooltip--row--2rmuD{display:flex;flex-direction:row;justify-content:space-between;line-height:20px}.SMBGTooltip--label--U7635{flex-grow:1}.SMBGTooltip--value--11Dgt{margin-left:20px}.SMBGTooltip--units--20sNy{min-width:.7em;margin-left:10px}.SMBGTooltip--title--3eGJu{text-align:right}.SMBGTooltip--bg--2Br6x{font-weight:700}.SMBGTooltip--subType--2t0uD{color:var(--gray-dark)}.SMBGTooltip--dividerLarge--2oXSH{height:4px;margin:5px -10px}", ""]);
	
	// exports
	exports.locals = {
		"container": "SMBGTooltip--container--2cF-n",
		"row": "SMBGTooltip--row--2rmuD " + __webpack_require__(10).locals["smallSize"] + "",
		"label": "SMBGTooltip--label--U7635",
		"value": "SMBGTooltip--value--11Dgt",
		"units": "SMBGTooltip--units--20sNy",
		"title": "SMBGTooltip--title--3eGJu " + __webpack_require__(10).locals["smallSize"] + "",
		"bg": "SMBGTooltip--bg--2Br6x SMBGTooltip--row--2rmuD " + __webpack_require__(10).locals["smallSize"] + "",
		"subType": "SMBGTooltip--subType--2t0uD SMBGTooltip--row--2rmuD " + __webpack_require__(10).locals["smallSize"] + "",
		"confirmBg": "SMBGTooltip--confirmBg--2ysRW SMBGTooltip--subType--2t0uD SMBGTooltip--row--2rmuD " + __webpack_require__(10).locals["smallSize"] + "",
		"source": "SMBGTooltip--source--1_PiL SMBGTooltip--subType--2t0uD SMBGTooltip--row--2rmuD " + __webpack_require__(10).locals["smallSize"] + "",
		"annotation": "SMBGTooltip--annotation--3_Hw8 SMBGTooltip--subType--2t0uD SMBGTooltip--row--2rmuD " + __webpack_require__(10).locals["smallSize"] + "",
		"dividerLarge": "SMBGTooltip--dividerLarge--2oXSH"
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(40);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedSMBGPointLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedSMBGPointLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(16), undefined);
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".FocusedSMBGPointLabel--container--tKvDB{top:0}.FocusedSMBGPointLabel--explainerText--I3VOk{display:block}.FocusedSMBGPointLabel--detailNumber--1s0C_{text-align:center}.FocusedSMBGPointLabel--subType--3c9Mz{font-style:italic}.FocusedSMBGPointLabel--tipWrapper--3Im_f{text-align:right}", ""]);
	
	// exports
	exports.locals = {
		"container": "FocusedSMBGPointLabel--container--tKvDB " + __webpack_require__(16).locals["absolute"] + " " + __webpack_require__(16).locals["smallHorizontalPadding"] + "",
		"number": "FocusedSMBGPointLabel--number--W173a " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(10).locals["highContrastText"] + " " + __webpack_require__(10).locals["noWrap"] + " " + __webpack_require__(10).locals["largeSize"] + "",
		"explainerText": "FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(10).locals["smallSize"] + " " + __webpack_require__(10).locals["noWrap"] + "",
		"detailNumber": "FocusedSMBGPointLabel--detailNumber--1s0C_ FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(10).locals["smallSize"] + " " + __webpack_require__(10).locals["noWrap"] + " FocusedSMBGPointLabel--number--W173a " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(10).locals["highContrastText"] + " " + __webpack_require__(10).locals["noWrap"] + " " + __webpack_require__(10).locals["largeSize"] + "",
		"dateTime": "FocusedSMBGPointLabel--dateTime--1voYn FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(10).locals["smallSize"] + " " + __webpack_require__(10).locals["noWrap"] + "",
		"subType": "FocusedSMBGPointLabel--subType--3c9Mz FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(10).locals["smallSize"] + " " + __webpack_require__(10).locals["noWrap"] + "",
		"tipWrapper": "FocusedSMBGPointLabel--tipWrapper--3Im_f"
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Loader = __webpack_require__(43);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var Loader = function Loader(props) {
	  var _cx2;
	
	  var show = props.show,
	      overlay = props.overlay,
	      text = props.text;
	
	
	  var loaderOuterClasses = (0, _classnames2.default)(_defineProperty({
	    loader: true
	  }, _Loader2.default.loader, true));
	
	  var loaderInnerClasses = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _Loader2.default.loaderDots, true), _defineProperty(_cx2, _Loader2.default.hidden, !show), _defineProperty(_cx2, _Loader2.default.overlay, overlay), _cx2));
	
	  return _react2.default.createElement(
	    'div',
	    { className: loaderOuterClasses },
	    _react2.default.createElement(
	      'div',
	      { className: loaderInnerClasses },
	      _react2.default.createElement('div', { className: _Loader2.default.loaderDot }),
	      _react2.default.createElement('div', { className: _Loader2.default.loaderDot }),
	      _react2.default.createElement('div', { className: _Loader2.default.loaderDot }),
	      _react2.default.createElement('div', { className: _Loader2.default.loaderDot }),
	      _react2.default.createElement('div', { className: _Loader2.default.loaderDot }),
	      _react2.default.createElement(
	        'div',
	        { className: _Loader2.default.loaderText },
	        text
	      )
	    )
	  );
	};
	
	Loader.defaultProps = {
	  overlay: false,
	  show: true,
	  text: 'Loading...'
	};
	
	Loader.propTypes = {
	  overlay: _react.PropTypes.bool.isRequired,
	  show: _react.PropTypes.bool.isRequired,
	  text: _react.PropTypes.string
	};
	
	var _default = Loader;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Loader, 'Loader', '/Users/krystophv/tidepool/viz/src/components/common/loader/Loader.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/common/loader/Loader.js');
	})();

	;

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = require("classnames");

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(44);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Loader.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Loader.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".Loader--loader--239CI{display:flex;pointer-events:none}.Loader--loaderDots--IcVlR{opacity:1;transition:opacity .25s ease;z-index:10;top:50%;align-items:center;height:100%}.Loader--loaderDots--IcVlR,.Loader--loaderText--10JJd{display:flex;position:absolute;left:50%;transform:translate(-50%,-50%);justify-content:center;width:100%}.Loader--loaderText--10JJd{color:var(--text-high-contrast);font-size:14px;top:calc(50% + 29px)}.Loader--loaderDots--IcVlR.Loader--overlay--SAerc{background:radial-gradient(hsla(0,0%,100%,.9),hsla(0,0%,100%,.7))}.Loader--loaderDots--IcVlR.Loader--hidden--2YWt4{opacity:.01}.Loader--loaderDot--1B5L3{margin:5px;width:16px;height:16px;border-radius:50%;background:var(--brand-purple-dark);transform:scale(.5);animation:Loader--scale-dot--29bkn 1.2s ease-out infinite}.Loader--loaderDot--1B5L3:nth-of-type(2){animation-delay:.2s}.Loader--loaderDot--1B5L3:nth-of-type(3){animation-delay:.3s}.Loader--loaderDot--1B5L3:nth-of-type(4){animation-delay:.4s}.Loader--loaderDot--1B5L3:nth-of-type(5){animation-delay:.5s}@keyframes Loader--scale-dot--29bkn{0%{transform:scale(.5)}25%{transform:scale(1)}75%{transform:scale(.5)}to{transform:scale(.5)}}", ""]);
	
	// exports
	exports.locals = {
		"loader": "Loader--loader--239CI",
		"loaderDots": "Loader--loaderDots--IcVlR",
		"loaderText": "Loader--loaderText--10JJd",
		"overlay": "Loader--overlay--SAerc",
		"hidden": "Loader--hidden--2YWt4",
		"loaderDot": "Loader--loaderDot--1B5L3",
		"scale-dot": "Loader--scale-dot--29bkn"
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RangeSelect = undefined;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _actions = __webpack_require__(48);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _LabeledCheckbox = __webpack_require__(53);
	
	var _LabeledCheckbox2 = _interopRequireDefault(_LabeledCheckbox);
	
	var _RangeSelect = __webpack_require__(56);
	
	var _RangeSelect2 = _interopRequireDefault(_RangeSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RangeSelect = exports.RangeSelect = function RangeSelect(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _RangeSelect2.default.container },
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbg100Enabled,
	      name: 'hundred',
	      label: '100% of Readings',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, '100'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, '100')
	    }),
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbg80Enabled,
	      name: 'eighty',
	      label: '80% of Readings',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, '80'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, '80')
	    }),
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbg50Enabled,
	      name: 'fifty',
	      label: '50% of Readings',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, '50'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, '50')
	    }),
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbgMedianEnabled,
	      name: 'median',
	      label: 'Median',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, 'median'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, 'median')
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	RangeSelect.propTypes = {
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  turnOnCbgRange: _react.PropTypes.func.isRequired,
	  turnOffCbgRange: _react.PropTypes.func.isRequired,
	  currentPatientInViewId: _react.PropTypes.string.isRequired
	};
	
	function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    turnOnCbgRange: _lodash2.default.partial(actions.turnOnCbgRange, ownProps.currentPatientInViewId),
	    turnOffCbgRange: _lodash2.default.partial(actions.turnOffCbgRange, ownProps.currentPatientInViewId)
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(RangeSelect);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RangeSelect, 'RangeSelect', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/RangeSelect.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/RangeSelect.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/RangeSelect.js');
	})();

	;

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = require("react-redux");

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = require("redux");

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _thunks = __webpack_require__(49);
	
	Object.keys(_thunks).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _thunks[key];
	    }
	  });
	});
	
	var _trends = __webpack_require__(50);
	
	Object.keys(_trends).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _trends[key];
	    }
	  });
	});
	
	var _settings = __webpack_require__(52);
	
	Object.keys(_settings).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _settings[key];
	    }
	  });
	});
	; /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2016, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */

	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	})();

	;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.delayShowCbgTracesOnFocus = delayShowCbgTracesOnFocus;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _trends = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function delayShowCbgTracesOnFocus(userId, sliceData, slicePosition, focusedKeys) {
	  return function (dispatch, getState) {
	    dispatch((0, _trends.focusTrendsCbgSlice)(userId, sliceData, slicePosition, focusedKeys));
	    setTimeout(function () {
	      var currentTrendsStateForUser = _lodash2.default.get(getState(), ['viz', 'trends', userId], {});
	      var currentFocusedSlice = currentTrendsStateForUser.focusedCbgSlice,
	          currentFocusedKeys = currentTrendsStateForUser.focusedCbgSliceKeys;
	      var sliceId = sliceData.id;
	
	      if (sliceId === _lodash2.default.get(currentFocusedSlice, ['data', 'id']) && _lodash2.default.isEqual(focusedKeys, currentFocusedKeys)) {
	        dispatch((0, _trends.showCbgDateTraces)(userId));
	      }
	    }, 250);
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(delayShowCbgTracesOnFocus, 'delayShowCbgTracesOnFocus', '/Users/krystophv/tidepool/viz/src/redux/actions/thunks.js');
	})();

	;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusTrendsCbgDateTrace = focusTrendsCbgDateTrace;
	exports.focusTrendsCbgSlice = focusTrendsCbgSlice;
	exports.focusTrendsSmbg = focusTrendsSmbg;
	exports.focusTrendsSmbgRangeAvg = focusTrendsSmbgRangeAvg;
	exports.markTrendsViewed = markTrendsViewed;
	exports.showCbgDateTraces = showCbgDateTraces;
	exports.turnOffCbgRange = turnOffCbgRange;
	exports.turnOnCbgRange = turnOnCbgRange;
	exports.unfocusTrendsCbgDateTrace = unfocusTrendsCbgDateTrace;
	exports.unfocusTrendsCbgSlice = unfocusTrendsCbgSlice;
	exports.unfocusTrendsSmbg = unfocusTrendsSmbg;
	exports.unfocusTrendsSmbgRangeAvg = unfocusTrendsSmbgRangeAvg;
	
	var _actionTypes = __webpack_require__(51);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function focusTrendsCbgDateTrace(userId, cbgDatum, cbgPosition) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_CBG_DATE_TRACE,
	    payload: { userId: userId, cbgDatum: cbgDatum, cbgPosition: cbgPosition }
	  };
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2016, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	function focusTrendsCbgSlice(userId, sliceData, slicePosition, focusedKeys) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_CBG_SLICE,
	    payload: { focusedKeys: focusedKeys, sliceData: sliceData, slicePosition: slicePosition, userId: userId }
	  };
	}
	
	function focusTrendsSmbg(userId, smbgDatum, smbgPosition, allSmbgsOnDate, allPositions, date) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_SMBG,
	    payload: { userId: userId, smbgDatum: smbgDatum, smbgPosition: smbgPosition, allSmbgsOnDate: allSmbgsOnDate, allPositions: allPositions, date: date }
	  };
	}
	
	function focusTrendsSmbgRangeAvg(userId, rangeAvgData, rangeAvgPosition) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_SMBG_RANGE_AVG,
	    payload: { rangeAvgData: rangeAvgData, rangeAvgPosition: rangeAvgPosition, userId: userId }
	  };
	}
	
	function markTrendsViewed(userId) {
	  return {
	    type: actionTypes.MARK_TRENDS_VIEWED,
	    payload: { userId: userId }
	  };
	}
	
	function showCbgDateTraces(userId) {
	  return {
	    type: actionTypes.SHOW_CBG_DATE_TRACES,
	    payload: { userId: userId }
	  };
	}
	
	function turnOffCbgRange(userId, range) {
	  return {
	    type: actionTypes.TURN_OFF_CBG_RANGE,
	    payload: { userId: userId, range: range }
	  };
	}
	
	function turnOnCbgRange(userId, range) {
	  return {
	    type: actionTypes.TURN_ON_CBG_RANGE,
	    payload: { userId: userId, range: range }
	  };
	}
	
	function unfocusTrendsCbgDateTrace(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_CBG_DATE_TRACE,
	    payload: { userId: userId }
	  };
	}
	
	function unfocusTrendsCbgSlice(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_CBG_SLICE,
	    payload: { userId: userId }
	  };
	}
	
	function unfocusTrendsSmbg(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_SMBG,
	    payload: { userId: userId }
	  };
	}
	
	function unfocusTrendsSmbgRangeAvg(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_SMBG_RANGE_AVG,
	    payload: { userId: userId }
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(focusTrendsCbgDateTrace, 'focusTrendsCbgDateTrace', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(focusTrendsCbgSlice, 'focusTrendsCbgSlice', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(focusTrendsSmbg, 'focusTrendsSmbg', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(focusTrendsSmbgRangeAvg, 'focusTrendsSmbgRangeAvg', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(markTrendsViewed, 'markTrendsViewed', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(showCbgDateTraces, 'showCbgDateTraces', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(turnOffCbgRange, 'turnOffCbgRange', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(turnOnCbgRange, 'turnOnCbgRange', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsCbgDateTrace, 'unfocusTrendsCbgDateTrace', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsCbgSlice, 'unfocusTrendsCbgSlice', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsSmbg, 'unfocusTrendsSmbg', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsSmbgRangeAvg, 'unfocusTrendsSmbgRangeAvg', '/Users/krystophv/tidepool/viz/src/redux/actions/trends.js');
	})();

	;

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var FOCUS_TRENDS_CBG_DATE_TRACE = exports.FOCUS_TRENDS_CBG_DATE_TRACE = 'FOCUS_TRENDS_CBG_DATE_TRACE';
	var FOCUS_TRENDS_CBG_SLICE = exports.FOCUS_TRENDS_CBG_SLICE = 'FOCUS_TRENDS_CBG_SLICE';
	var FOCUS_TRENDS_SMBG = exports.FOCUS_TRENDS_SMBG = 'FOCUS_TRENDS_SMBG';
	var FOCUS_TRENDS_SMBG_RANGE_AVG = exports.FOCUS_TRENDS_SMBG_RANGE_AVG = 'FOCUS_TRENDS_SMBG_RANGE_AVG';
	
	var MARK_SETTINGS_VIEWED = exports.MARK_SETTINGS_VIEWED = 'MARK_SETTINGS_VIEWED';
	var MARK_TRENDS_VIEWED = exports.MARK_TRENDS_VIEWED = 'MARK_TRENDS_VIEWED';
	
	var SHOW_CBG_DATE_TRACES = exports.SHOW_CBG_DATE_TRACES = 'SHOW_CBG_DATE_TRACES';
	
	var TOGGLE_SETTINGS_SECTION = exports.TOGGLE_SETTINGS_SECTION = 'TOGGLE_SETTINGS_SECTION';
	
	var TURN_OFF_CBG_RANGE = exports.TURN_OFF_CBG_RANGE = 'TURN_OFF_CBG_RANGE';
	var TURN_ON_CBG_RANGE = exports.TURN_ON_CBG_RANGE = 'TURN_ON_CBG_RANGE';
	
	var UNFOCUS_TRENDS_CBG_DATE_TRACE = exports.UNFOCUS_TRENDS_CBG_DATE_TRACE = 'UNFOCUS_TRENDS_CBG_DATE_TRACE';
	var UNFOCUS_TRENDS_CBG_SLICE = exports.UNFOCUS_TRENDS_CBG_SLICE = 'UNFOCUS_TRENDS_CBG_SLICE';
	var UNFOCUS_TRENDS_SMBG = exports.UNFOCUS_TRENDS_SMBG = 'UNFOCUS_TRENDS_SMBG';
	var UNFOCUS_TRENDS_SMBG_RANGE_AVG = exports.UNFOCUS_TRENDS_SMBG_RANGE_AVG = 'UNFOCUS_TRENDS_SMBG_RANGE_AVG';
	
	// from blip's redux implementation
	// TODO: how could we DRY this out??
	
	var FETCH_PATIENT_DATA_SUCCESS = exports.FETCH_PATIENT_DATA_SUCCESS = 'FETCH_PATIENT_DATA_SUCCESS';
	var LOGOUT_REQUEST = exports.LOGOUT_REQUEST = 'LOGOUT_REQUEST';
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_CBG_DATE_TRACE, 'FOCUS_TRENDS_CBG_DATE_TRACE', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_CBG_SLICE, 'FOCUS_TRENDS_CBG_SLICE', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_SMBG, 'FOCUS_TRENDS_SMBG', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_SMBG_RANGE_AVG, 'FOCUS_TRENDS_SMBG_RANGE_AVG', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(MARK_SETTINGS_VIEWED, 'MARK_SETTINGS_VIEWED', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(MARK_TRENDS_VIEWED, 'MARK_TRENDS_VIEWED', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SHOW_CBG_DATE_TRACES, 'SHOW_CBG_DATE_TRACES', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(TOGGLE_SETTINGS_SECTION, 'TOGGLE_SETTINGS_SECTION', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(TURN_OFF_CBG_RANGE, 'TURN_OFF_CBG_RANGE', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(TURN_ON_CBG_RANGE, 'TURN_ON_CBG_RANGE', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_CBG_DATE_TRACE, 'UNFOCUS_TRENDS_CBG_DATE_TRACE', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_CBG_SLICE, 'UNFOCUS_TRENDS_CBG_SLICE', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_SMBG, 'UNFOCUS_TRENDS_SMBG', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_SMBG_RANGE_AVG, 'UNFOCUS_TRENDS_SMBG_RANGE_AVG', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PATIENT_DATA_SUCCESS, 'FETCH_PATIENT_DATA_SUCCESS', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGOUT_REQUEST, 'LOGOUT_REQUEST', '/Users/krystophv/tidepool/viz/src/redux/constants/actionTypes.js');
	})();

	;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.markSettingsViewed = markSettingsViewed;
	exports.toggleSettingsSection = toggleSettingsSection;
	
	var _actionTypes = __webpack_require__(51);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function markSettingsViewed(userId) {
	  return {
	    type: actionTypes.MARK_SETTINGS_VIEWED,
	    payload: { userId: userId }
	  };
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2016, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	function toggleSettingsSection(userId, deviceKey, scheduleOrProfileKey) {
	  return {
	    type: actionTypes.TOGGLE_SETTINGS_SECTION,
	    payload: { deviceKey: deviceKey, scheduleOrProfileKey: scheduleOrProfileKey, userId: userId }
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(markSettingsViewed, 'markSettingsViewed', '/Users/krystophv/tidepool/viz/src/redux/actions/settings.js');
	
	  __REACT_HOT_LOADER__.register(toggleSettingsSection, 'toggleSettingsSection', '/Users/krystophv/tidepool/viz/src/redux/actions/settings.js');
	})();

	;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LabeledCheckbox = __webpack_require__(54);
	
	var _LabeledCheckbox2 = _interopRequireDefault(_LabeledCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var LabeledCheckbox = function LabeledCheckbox(props) {
	  var name = props.name,
	      checked = props.checked,
	      onFn = props.onFn,
	      offFn = props.offFn,
	      label = props.label;
	
	  var handleChange = function handleChange() {
	    if (checked) {
	      offFn();
	    } else {
	      onFn();
	    }
	  };
	
	  return _react2.default.createElement(
	    'label',
	    { htmlFor: name, className: _LabeledCheckbox2.default.label },
	    _react2.default.createElement('input', {
	      type: 'checkbox', name: name, id: name,
	      checked: checked,
	      onChange: handleChange
	    }),
	    ' ',
	    label
	  );
	};
	
	LabeledCheckbox.propTypes = {
	  checked: _react.PropTypes.bool.isRequired,
	  onFn: _react.PropTypes.func.isRequired,
	  offFn: _react.PropTypes.func.isRequired,
	  label: _react.PropTypes.node.isRequired,
	  name: _react.PropTypes.string.isRequired
	};
	
	var _default = LabeledCheckbox;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LabeledCheckbox, 'LabeledCheckbox', '/Users/krystophv/tidepool/viz/src/components/common/controls/LabeledCheckbox.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/common/controls/LabeledCheckbox.js');
	})();

	;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(55);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./LabeledCheckbox.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./LabeledCheckbox.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".LabeledCheckbox--label--8KYrB{padding-right:12px}", ""]);
	
	// exports
	exports.locals = {
		"label": "LabeledCheckbox--label--8KYrB " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["largeSize"] + ""
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(57);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./RangeSelect.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./RangeSelect.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".RangeSelect--container--wOEXa{display:flex;flex-direction:row;padding-top:15px}", ""]);
	
	// exports
	exports.locals = {
		"container": "RangeSelect--container--wOEXa " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["defaultSize"] + ""
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toggle = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TwoOptionToggle = __webpack_require__(59);
	
	var _TwoOptionToggle2 = _interopRequireDefault(_TwoOptionToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var TwoOptionToggle = function TwoOptionToggle(props) {
	  var disabled = props.disabled,
	      left = props.left,
	      right = props.right,
	      toggleFn = props.toggleFn;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _TwoOptionToggle2.default.container },
	    _react2.default.createElement(
	      'span',
	      { className: _TwoOptionToggle2.default.label },
	      left.label
	    ),
	    _react2.default.createElement(Toggle, { disabled: disabled, leftOptionActive: left.state, toggleFn: toggleFn }),
	    _react2.default.createElement(
	      'span',
	      { className: _TwoOptionToggle2.default.label },
	      right.label
	    )
	  );
	};
	
	TwoOptionToggle.defaultProps = {
	  disabled: false
	};
	
	TwoOptionToggle.propTypes = {
	  disabled: _react.PropTypes.bool.isRequired,
	  left: _react.PropTypes.shape({
	    label: _react.PropTypes.string.isRequired,
	    state: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  right: _react.PropTypes.shape({
	    label: _react.PropTypes.string.isRequired,
	    state: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  toggleFn: _react.PropTypes.func.isRequired
	};
	
	var Toggle = exports.Toggle = function Toggle(props) {
	  var disabled = props.disabled,
	      leftOptionActive = props.leftOptionActive,
	      toggleFn = props.toggleFn;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: disabled ? _TwoOptionToggle2.default.disabled : _TwoOptionToggle2.default.toggle,
	      onClick: disabled ? function () {} : toggleFn
	    },
	    _react2.default.createElement('div', { className: _TwoOptionToggle2.default.track }),
	    _react2.default.createElement('div', { className: leftOptionActive ? _TwoOptionToggle2.default.leftThumb : _TwoOptionToggle2.default.rightThumb })
	  );
	};
	
	Toggle.propTypes = {
	  disabled: _react.PropTypes.bool.isRequired,
	  leftOptionActive: _react.PropTypes.bool.isRequired,
	  toggleFn: _react.PropTypes.func.isRequired
	};
	
	var _default = TwoOptionToggle;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TwoOptionToggle, 'TwoOptionToggle', '/Users/krystophv/tidepool/viz/src/components/common/controls/TwoOptionToggle.js');
	
	  __REACT_HOT_LOADER__.register(Toggle, 'Toggle', '/Users/krystophv/tidepool/viz/src/components/common/controls/TwoOptionToggle.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/common/controls/TwoOptionToggle.js');
	})();

	;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(60);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoOptionToggle.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoOptionToggle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".TwoOptionToggle--container--1zUwx{display:flex;justify-content:center;align-items:center}.TwoOptionToggle--label--2EJ_a{padding:4px}.TwoOptionToggle--toggle--1xSoR{display:inline-block;position:relative;background-color:transparent;border:0;cursor:pointer;padding:0;user-select:none}.TwoOptionToggle--disabled--ucm9-{cursor:not-allowed;opacity:.5;transition:opacity .25s}.TwoOptionToggle--track--276ia{width:50px;height:24px;background-color:var(--chrome);border-radius:30px;padding:0;transition:all .2s ease}.TwoOptionToggle--thumb--3MohE{position:absolute;top:1px;width:22px;height:22px;background-color:#fff;border:1px solid var(--chrome);border-radius:50%;box-sizing:border-box;transition:all .25s ease}.TwoOptionToggle--leftThumb--sj1OH{left:1px}.TwoOptionToggle--rightThumb--3rMQE{left:27px}", ""]);
	
	// exports
	exports.locals = {
		"container": "TwoOptionToggle--container--1zUwx",
		"label": "TwoOptionToggle--label--2EJ_a " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["smallSize"] + "",
		"toggle": "TwoOptionToggle--toggle--1xSoR",
		"disabled": "TwoOptionToggle--disabled--ucm9- TwoOptionToggle--toggle--1xSoR",
		"track": "TwoOptionToggle--track--276ia",
		"thumb": "TwoOptionToggle--thumb--3MohE",
		"leftThumb": "TwoOptionToggle--leftThumb--sj1OH TwoOptionToggle--thumb--3MohE",
		"rightThumb": "TwoOptionToggle--rightThumb--3rMQE TwoOptionToggle--thumb--3MohE"
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PumpSettingsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _actions = __webpack_require__(48);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _constants = __webpack_require__(18);
	
	var _NonTandem = __webpack_require__(62);
	
	var _NonTandem2 = _interopRequireDefault(_NonTandem);
	
	var _Tandem = __webpack_require__(99);
	
	var _Tandem2 = _interopRequireDefault(_Tandem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var PumpSettingsContainer = exports.PumpSettingsContainer = function (_PureComponent) {
	  _inherits(PumpSettingsContainer, _PureComponent);
	
	  function PumpSettingsContainer() {
	    _classCallCheck(this, PumpSettingsContainer);
	
	    return _possibleConstructorReturn(this, (PumpSettingsContainer.__proto__ || Object.getPrototypeOf(PumpSettingsContainer)).apply(this, arguments));
	  }
	
	  _createClass(PumpSettingsContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var markSettingsViewed = this.props.markSettingsViewed;
	      var _props = this.props,
	          manufacturerKey = _props.manufacturerKey,
	          _props$pumpSettings = _props.pumpSettings,
	          activeSchedule = _props$pumpSettings.activeSchedule,
	          lastManualBasalSchedule = _props$pumpSettings.lastManualBasalSchedule,
	          toggleSettingsSection = _props.toggleSettingsSection,
	          touched = _props.settingsState.touched;
	
	
	      if (!touched) {
	        markSettingsViewed();
	        toggleSettingsSection(manufacturerKey, lastManualBasalSchedule || activeSchedule);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          settingsState = _props2.settingsState,
	          user = _props2.user;
	
	      if (_lodash2.default.isEmpty(settingsState)) {
	        return null;
	      }
	      var _props3 = this.props,
	          bgUnits = _props3.bgUnits,
	          copySettingsClicked = _props3.copySettingsClicked,
	          manufacturerKey = _props3.manufacturerKey,
	          pumpSettings = _props3.pumpSettings,
	          timePrefs = _props3.timePrefs,
	          toggleSettingsSection = _props3.toggleSettingsSection;
	
	      var supportedNonTandemPumps = ['animas', 'carelink', 'insulet', 'medtronic'];
	      var toggleFn = _lodash2.default.partial(toggleSettingsSection, manufacturerKey);
	
	      if (manufacturerKey === 'tandem') {
	        return _react2.default.createElement(_Tandem2.default, {
	          bgUnits: bgUnits,
	          copySettingsClicked: copySettingsClicked,
	          deviceKey: manufacturerKey,
	          openedSections: settingsState[manufacturerKey],
	          pumpSettings: pumpSettings,
	          timePrefs: timePrefs,
	          toggleProfileExpansion: toggleFn,
	          user: user
	        });
	      } else if (_lodash2.default.includes(supportedNonTandemPumps, manufacturerKey)) {
	        return _react2.default.createElement(_NonTandem2.default, {
	          bgUnits: bgUnits,
	          copySettingsClicked: copySettingsClicked,
	          deviceKey: manufacturerKey,
	          openedSections: settingsState[manufacturerKey],
	          pumpSettings: pumpSettings,
	          timePrefs: timePrefs,
	          toggleBasalScheduleExpansion: toggleFn,
	          user: user
	        });
	      }
	      // eslint-disable-next-line no-console
	      console.warn('Unknown manufacturer key: [' + manufacturerKey + ']!');
	      return null;
	    }
	  }]);
	
	  return PumpSettingsContainer;
	}(_react.PureComponent);
	
	PumpSettingsContainer.propTypes = {
	  bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired,
	  copySettingsClicked: _react.PropTypes.func.isRequired,
	  manufacturerKey: _react.PropTypes.oneOf(['animas', 'carelink', 'insulet', 'medtronic', 'tandem']).isRequired,
	  markSettingsViewed: _react.PropTypes.func.isRequired,
	  // see more specific schema in NonTandem and Tandem components!
	  pumpSettings: _react.PropTypes.shape({
	    activeSchedule: _react.PropTypes.string.isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react.PropTypes.string.isRequired
	  }).isRequired,
	  settingsState: _react.PropTypes.object.isRequired,
	  toggleSettingsSection: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state, ownProps) {
	  var userId = _lodash2.default.get(ownProps, 'currentPatientInViewId');
	  var user = _lodash2.default.get(state.blip.allUsersMap, userId, {});
	  return {
	    settingsState: _lodash2.default.get(state, ['viz', 'settings', userId], {}),
	    user: user
	  };
	}
	
	function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    markSettingsViewed: _lodash2.default.partial(actions.markSettingsViewed, ownProps.currentPatientInViewId),
	    toggleSettingsSection: _lodash2.default.partial(actions.toggleSettingsSection, ownProps.currentPatientInViewId)
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PumpSettingsContainer);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PumpSettingsContainer, 'PumpSettingsContainer', '/Users/krystophv/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	})();

	;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactClipboard = __webpack_require__(63);
	
	var _reactClipboard2 = _interopRequireDefault(_reactClipboard);
	
	var _Header = __webpack_require__(72);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Table = __webpack_require__(75);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _CollapsibleContainer = __webpack_require__(79);
	
	var _CollapsibleContainer2 = _interopRequireDefault(_CollapsibleContainer);
	
	var _constants = __webpack_require__(18);
	
	var _nonTandemData = __webpack_require__(91);
	
	var nonTandemData = _interopRequireWildcard(_nonTandemData);
	
	var _data = __webpack_require__(92);
	
	var _textData = __webpack_require__(93);
	
	var _NonTandem = __webpack_require__(97);
	
	var _NonTandem2 = _interopRequireDefault(_NonTandem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NonTandem = function NonTandem(props) {
	  var bgUnits = props.bgUnits,
	      copySettingsClicked = props.copySettingsClicked,
	      deviceKey = props.deviceKey,
	      openedSections = props.openedSections,
	      pumpSettings = props.pumpSettings,
	      timePrefs = props.timePrefs,
	      toggleBasalScheduleExpansion = props.toggleBasalScheduleExpansion,
	      user = props.user;
	
	
	  var lookupKey = deviceKey;
	
	  if (deviceKey === 'carelink') {
	    lookupKey = 'medtronic';
	  }
	
	  function buildTable(rows, columns, title, tableStyle) {
	    return _react2.default.createElement(_Table2.default, {
	      title: title,
	      rows: rows,
	      columns: columns,
	      tableStyle: tableStyle
	    });
	  }
	
	  function openSection(sectionName) {
	    return _lodash2.default.get(openedSections, sectionName, false);
	  }
	
	  function renderBasalsData() {
	    return _lodash2.default.map(nonTandemData.basalSchedules(pumpSettings), function (schedule) {
	      var basal = nonTandemData.basal(schedule, pumpSettings, deviceKey);
	      var toggleFn = _lodash2.default.partial(toggleBasalScheduleExpansion, basal.scheduleName);
	
	      var labelClass = _NonTandem2.default.singleLineBasalScheduleHeader;
	
	      if (basal.isAutomated) {
	        // We only show automated basal schedules if active at upload
	        if (!basal.activeAtUpload) {
	          return null;
	        }
	
	        basal.title.secondary = basal.title.secondary.toLowerCase();
	
	        var title = {
	          label: basal.title,
	          className: _NonTandem2.default.automatedBasalHeaderBackground
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { className: _NonTandem2.default.categoryContainer, key: schedule },
	          buildTable(basal.rows, basal.columns, title, [labelClass, _NonTandem2.default.settingsTable].join(' '))
	        );
	      }
	
	      if (basal.activeAtUpload) {
	        labelClass = _NonTandem2.default.twoLineBasalScheduleHeader;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _NonTandem2.default.categoryContainer, key: schedule },
	        _react2.default.createElement(
	          _CollapsibleContainer2.default,
	          {
	            label: basal.title,
	            labelClass: labelClass,
	            opened: openSection(basal.scheduleName),
	            toggleExpansion: toggleFn,
	            twoLineLabel: true
	          },
	          buildTable(basal.rows, basal.columns, null, _NonTandem2.default.basalTable)
	        )
	      );
	    });
	  }
	
	  function renderSensitivityData() {
	    var sensitivity = nonTandemData.sensitivity(pumpSettings, lookupKey, bgUnits);
	    var title = {
	      label: {
	        main: sensitivity.title,
	        secondary: bgUnits + '/U'
	      },
	      className: _NonTandem2.default.bolusSettingsHeader
	    };
	    return _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.categoryContainer },
	      buildTable(sensitivity.rows, sensitivity.columns, title, _NonTandem2.default.settingsTable)
	    );
	  }
	
	  function renderRatioData() {
	    var ratio = nonTandemData.ratio(pumpSettings, lookupKey);
	    var title = {
	      label: {
	        main: ratio.title,
	        secondary: 'g/U'
	      },
	      className: _NonTandem2.default.bolusSettingsHeader
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.categoryContainer },
	      buildTable(ratio.rows, ratio.columns, title, _NonTandem2.default.settingsTable)
	    );
	  }
	
	  function renderTargetData() {
	    var target = nonTandemData.target(pumpSettings, lookupKey, bgUnits);
	    var title = {
	      label: {
	        main: target.title,
	        secondary: bgUnits
	      },
	      className: _NonTandem2.default.bolusSettingsHeader
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.categoryContainer },
	      buildTable(target.rows, target.columns, title, _NonTandem2.default.settingsTable)
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactClipboard2.default,
	      {
	        className: _NonTandem2.default.copyButton,
	        'button-title': 'For email or notes',
	        'data-clipboard-target': '#copySettingsText',
	        onSuccess: copySettingsClicked
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Copy as text'
	      )
	    ),
	    _react2.default.createElement(_Header2.default, {
	      deviceDisplayName: (0, _data.deviceName)(lookupKey),
	      deviceMeta: nonTandemData.deviceMeta(pumpSettings, timePrefs)
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.settingsContainer },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _NonTandem2.default.basalSettingsContainer },
	          _react2.default.createElement(
	            'div',
	            { className: _NonTandem2.default.categoryTitle },
	            'Basal Rates'
	          ),
	          renderBasalsData()
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _NonTandem2.default.bolusSettingsContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _NonTandem2.default.categoryTitle },
	          nonTandemData.bolusTitle(lookupKey)
	        ),
	        renderSensitivityData(),
	        renderTargetData(),
	        renderRatioData()
	      )
	    ),
	    _react2.default.createElement(
	      'pre',
	      { className: _NonTandem2.default.copyText, id: 'copySettingsText' },
	      (0, _textData.nonTandemText)(user, pumpSettings, bgUnits, lookupKey)
	    )
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	NonTandem.propTypes = {
	  bgUnits: _react.PropTypes.oneOf([_constants.MMOLL_UNITS, _constants.MGDL_UNITS]).isRequired,
	  copySettingsClicked: _react.PropTypes.func.isRequired,
	  deviceKey: _react.PropTypes.oneOf(['animas', 'carelink', 'insulet', 'medtronic']).isRequired,
	  openedSections: _react.PropTypes.object.isRequired,
	  pumpSettings: _react.PropTypes.shape({
	    activeSchedule: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.object.isRequired,
	    deviceId: _react.PropTypes.string.isRequired,
	    basalSchedules: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      name: _react.PropTypes.string.isRequired,
	      value: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        start: _react.PropTypes.number.isRequired,
	        rate: _react.PropTypes.number.isRequired
	      }))
	    })).isRequired,
	    bgTarget: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      target: _react.PropTypes.number,
	      range: _react.PropTypes.number
	    })).isRequired,
	    carbRatio: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired,
	    insulinSensitivity: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react.PropTypes.oneOfType([_react.PropTypes.string, null])
	  }).isRequired,
	  toggleBasalScheduleExpansion: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired
	};
	
	var _default = NonTandem;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NonTandem, 'NonTandem', '/Users/krystophv/tidepool/viz/src/components/settings/NonTandem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/NonTandem.js');
	})();

	;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(3), __webpack_require__(64));
		else if(typeof define === 'function' && define.amd)
			define(["react", "clipboard"], factory);
		else if(typeof exports === 'object')
			exports["ReactClipboard"] = factory(require("react"), require("clipboard"));
		else
			root["ReactClipboard"] = factory(root["React"], root["Clipboard"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_40__, __WEBPACK_EXTERNAL_MODULE_41__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _get = __webpack_require__(1)['default'];
	
		var _inherits = __webpack_require__(17)['default'];
	
		var _createClass = __webpack_require__(26)['default'];
	
		var _classCallCheck = __webpack_require__(29)['default'];
	
		var _extends = __webpack_require__(30)['default'];
	
		var _Object$keys = __webpack_require__(36)['default'];
	
		var _interopRequireDefault = __webpack_require__(39)['default'];
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		var _react = __webpack_require__(40);
	
		var _react2 = _interopRequireDefault(_react);
	
		var ClipboardButton = (function (_React$Component) {
		  _inherits(ClipboardButton, _React$Component);
	
		  function ClipboardButton() {
		    _classCallCheck(this, ClipboardButton);
	
		    _get(Object.getPrototypeOf(ClipboardButton.prototype), 'constructor', this).apply(this, arguments);
		  }
	
		  _createClass(ClipboardButton, [{
		    key: 'propsWith',
	
		    /* Returns a object with all props that fulfill a certain naming pattern
		     *
		     * @param {RegExp} regexp - Regular expression representing which pattern
		     *                          you'll be searching for.
		     * @param {Boolean} remove - Determines if the regular expression should be
		     *                           removed when transmitting the key from the props
		     *                           to the new object.
		     *
		     * e.g:
		     *
		     * // Considering:
		     * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
		     *
		     * // *RegExps not using // so that this comment doesn't break up
		     * this.propsWith(option-*, true); // returns {foo: 1}
		     * this.propsWith(on*, true); // returns {Bar: 2}
		     * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
		     */
		    value: function propsWith(regexp) {
		      var remove = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		      var object = {};
	
		      _Object$keys(this.props).forEach(function (key) {
		        if (key.search(regexp) !== -1) {
		          var objectKey = remove ? key.replace(regexp, '') : key;
		          object[objectKey] = this.props[key];
		        }
		      }, this);
	
		      return object;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.clipboard && this.clipboard.destroy();
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Support old API by trying to assign this.props.options first;
		      var options = this.props.options || this.propsWith(/^option-/, true);
		      var element = _react2['default'].version.match(/0\.13(.*)/) ? this.refs.element.getDOMNode() : this.refs.element;
		      var Clipboard = __webpack_require__(41);
		      this.clipboard = new Clipboard(element, options);
	
		      var callbacks = this.propsWith(/^on/, true);
		      _Object$keys(callbacks).forEach(function (callback) {
		        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
		      }, this);
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var attributes = _extends({
		        type: this.getType(),
		        className: this.props.className || '',
		        style: this.props.style || {},
		        ref: 'element',
		        onClick: this.props.onClick
		      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
	
		      return _react2['default'].createElement(this.getComponent(), attributes, this.props.children);
		    }
		  }, {
		    key: 'getType',
		    value: function getType() {
		      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
		        return this.props.type || 'button';
		      } else {
		        return undefined;
		      }
		    }
		  }, {
		    key: 'getComponent',
		    value: function getComponent() {
		      return this.props.component || 'button';
		    }
		  }], [{
		    key: 'propTypes',
		    value: {
		      options: _react2['default'].PropTypes.object,
		      type: _react2['default'].PropTypes.string,
		      className: _react2['default'].PropTypes.string,
		      style: _react2['default'].PropTypes.object,
		      component: _react2['default'].PropTypes.string,
		      children: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.element, _react2['default'].PropTypes.string, _react2['default'].PropTypes.number, _react2['default'].PropTypes.object])
		    },
		    enumerable: true
		  }, {
		    key: 'defaultProps',
		    value: {
		      onClick: function onClick() {}
		    },
		    enumerable: true
		  }]);
	
		  return ClipboardButton;
		})(_react2['default'].Component);
	
		exports['default'] = ClipboardButton;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$getOwnPropertyDescriptor = __webpack_require__(2)["default"];
	
		exports["default"] = function get(_x, _x2, _x3) {
		  var _again = true;
	
		  _function: while (_again) {
		    var object = _x,
		        property = _x2,
		        receiver = _x3;
		    _again = false;
		    if (object === null) object = Function.prototype;
	
		    var desc = _Object$getOwnPropertyDescriptor(object, property);
	
		    if (desc === undefined) {
		      var parent = Object.getPrototypeOf(object);
	
		      if (parent === null) {
		        return undefined;
		      } else {
		        _x = parent;
		        _x2 = property;
		        _x3 = receiver;
		        _again = true;
		        desc = parent = undefined;
		        continue _function;
		      }
		    } else if ("value" in desc) {
		      return desc.value;
		    } else {
		      var getter = desc.get;
	
		      if (getter === undefined) {
		        return undefined;
		      }
	
		      return getter.call(receiver);
		    }
		  }
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(3), __esModule: true };
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(4);
		__webpack_require__(5);
		module.exports = function getOwnPropertyDescriptor(it, key){
		  return $.getDesc(it, key);
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		var $Object = Object;
		module.exports = {
		  create:     $Object.create,
		  getProto:   $Object.getPrototypeOf,
		  isEnum:     {}.propertyIsEnumerable,
		  getDesc:    $Object.getOwnPropertyDescriptor,
		  setDesc:    $Object.defineProperty,
		  setDescs:   $Object.defineProperties,
		  getKeys:    $Object.keys,
		  getNames:   $Object.getOwnPropertyNames,
		  getSymbols: $Object.getOwnPropertySymbols,
		  each:       [].forEach
		};
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
		var toIObject = __webpack_require__(6);
	
		__webpack_require__(10)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
		  return function getOwnPropertyDescriptor(it, key){
		    return $getOwnPropertyDescriptor(toIObject(it), key);
		  };
		});
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(7)
		  , defined = __webpack_require__(9);
		module.exports = function(it){
		  return IObject(defined(it));
		};
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(8);
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(11)
		  , core    = __webpack_require__(13)
		  , fails   = __webpack_require__(16);
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global    = __webpack_require__(12)
		  , core      = __webpack_require__(13)
		  , ctx       = __webpack_require__(14)
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && key in target;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(param){
		        return this instanceof C ? new C(param) : C(param);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
		  }
		};
		// type bitmap
		$export.F = 1;  // forced
		$export.G = 2;  // global
		$export.S = 4;  // static
		$export.P = 8;  // proto
		$export.B = 16; // bind
		$export.W = 32; // wrap
		module.exports = $export;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		var core = module.exports = {version: '1.2.6'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		// optional / simple context binding
		var aFunction = __webpack_require__(15);
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$create = __webpack_require__(18)["default"];
	
		var _Object$setPrototypeOf = __webpack_require__(20)["default"];
	
		exports["default"] = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		  }
	
		  subClass.prototype = _Object$create(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(19), __esModule: true };
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(4);
		module.exports = function create(P, D){
		  return $.create(P, D);
		};
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(21), __esModule: true };
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(22);
		module.exports = __webpack_require__(13).Object.setPrototypeOf;
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.3.19 Object.setPrototypeOf(O, proto)
		var $export = __webpack_require__(11);
		$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(23).set});
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Works with __proto__ only. Old v8 can't work with null proto objects.
		/* eslint-disable no-proto */
		var getDesc  = __webpack_require__(4).getDesc
		  , isObject = __webpack_require__(24)
		  , anObject = __webpack_require__(25);
		var check = function(O, proto){
		  anObject(O);
		  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
		};
		module.exports = {
		  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
		    function(test, buggy, set){
		      try {
		        set = __webpack_require__(14)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
		        set(test, []);
		        buggy = !(test instanceof Array);
		      } catch(e){ buggy = true; }
		      return function setPrototypeOf(O, proto){
		        check(O, proto);
		        if(buggy)O.__proto__ = proto;
		        else set(O, proto);
		        return O;
		      };
		    }({}, false) : undefined),
		  check: check
		};
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(24);
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$defineProperty = __webpack_require__(27)["default"];
	
		exports["default"] = (function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];
		      descriptor.enumerable = descriptor.enumerable || false;
		      descriptor.configurable = true;
		      if ("value" in descriptor) descriptor.writable = true;
	
		      _Object$defineProperty(target, descriptor.key, descriptor);
		    }
		  }
	
		  return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);
		    if (staticProps) defineProperties(Constructor, staticProps);
		    return Constructor;
		  };
		})();
	
		exports.__esModule = true;
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(28), __esModule: true };
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(4);
		module.exports = function defineProperty(it, key, desc){
		  return $.setDesc(it, key, desc);
		};
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		"use strict";
	
		exports["default"] = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$assign = __webpack_require__(31)["default"];
	
		exports["default"] = _Object$assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];
	
		    for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }
	
		  return target;
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(32), __esModule: true };
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(33);
		module.exports = __webpack_require__(13).Object.assign;
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.3.1 Object.assign(target, source)
		var $export = __webpack_require__(11);
	
		$export($export.S + $export.F, 'Object', {assign: __webpack_require__(34)});
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.1 Object.assign(target, source, ...)
		var $        = __webpack_require__(4)
		  , toObject = __webpack_require__(35)
		  , IObject  = __webpack_require__(7);
	
		// should work with symbols and should have deterministic property order (V8 bug)
		module.exports = __webpack_require__(16)(function(){
		  var a = Object.assign
		    , A = {}
		    , B = {}
		    , S = Symbol()
		    , K = 'abcdefghijklmnopqrst';
		  A[S] = 7;
		  K.split('').forEach(function(k){ B[k] = k; });
		  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
		}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
		  var T     = toObject(target)
		    , $$    = arguments
		    , $$len = $$.length
		    , index = 1
		    , getKeys    = $.getKeys
		    , getSymbols = $.getSymbols
		    , isEnum     = $.isEnum;
		  while($$len > index){
		    var S      = IObject($$[index++])
		      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
		      , length = keys.length
		      , j      = 0
		      , key;
		    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
		  }
		  return T;
		} : Object.assign;
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(9);
		module.exports = function(it){
		  return Object(defined(it));
		};
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(37), __esModule: true };
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(38);
		module.exports = __webpack_require__(13).Object.keys;
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(35);
	
		__webpack_require__(10)('keys', function($keys){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		"use strict";
	
		exports["default"] = function (obj) {
		  return obj && obj.__esModule ? obj : {
		    "default": obj
		  };
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_40__;
	
	/***/ },
	/* 41 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_41__;
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(65), __webpack_require__(67), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }], [{
	            key: 'isSupported',
	            value: function isSupported() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
	
	                var actions = typeof action === 'string' ? [action] : action;
	                var support = !!document.queryCommandSupported;
	
	                actions.forEach(function (action) {
	                    support = support && !!document.queryCommandSupported(action);
	                });
	
	                return support;
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(66)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                document.body.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    document.body.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    document.body.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.target) {
	                    this.target.blur();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ },
/* 66 */
/***/ function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ },
/* 67 */
/***/ function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var is = __webpack_require__(69);
	var delegate = __webpack_require__(70);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(71);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ },
/* 71 */
/***/ function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (element.matches(selector)) return element;
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(73);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Header = function (_PureComponent) {
	  _inherits(Header, _PureComponent);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = { serialNumberExpanded: false };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({ serialNumberExpanded: !this.state.serialNumberExpanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var headerClass = this.state.serialNumberExpanded ? _Header2.default.headerExpanded : _Header2.default.headerClosed;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: _Header2.default.header + ' ' + headerClass, onClick: this.handleClick },
	          _react2.default.createElement(
	            'li',
	            { className: _Header2.default.headerOuter },
	            _react2.default.createElement(
	              'span',
	              { className: _Header2.default.headerInner },
	              this.props.deviceDisplayName
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Header2.default.headerOuter },
	            _react2.default.createElement(
	              'span',
	              { className: _Header2.default.headerInner },
	              'Uploaded on ',
	              this.props.deviceMeta.uploaded
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Header2.default.headerOuter },
	            _react2.default.createElement(
	              'span',
	              { className: _Header2.default.headerInner },
	              'Serial Number: ',
	              this.props.deviceMeta.serial
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.PureComponent);
	
	Header.propTypes = {
	  deviceDisplayName: _react.PropTypes.string.isRequired,
	  deviceMeta: _react.PropTypes.object.isRequired
	};
	
	var _default = Header;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Header, 'Header', '/Users/krystophv/tidepool/viz/src/components/settings/common/Header.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/common/Header.js');
	})();

	;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(74);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Header.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Header.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".Header--header--3ozrH{position:relative;display:table;padding-left:0;margin-bottom:5px;cursor:pointer}.Header--header--3ozrH:hover{color:var(--text-hover)}.Header--headerOuter--3sTjy:last-of-type .Header--headerInner--3SX7m{transition-property:width;transition-duration:.25s;overflow:hidden}.Header--headerClosed--15eLm .Header--headerOuter--3sTjy:last-of-type .Header--headerInner--3SX7m{width:0}.Header--headerExpanded--r2xtw .Header--headerOuter--3sTjy:last-of-type .Header--headerInner--3SX7m{width:100%}.Header--headerOuter--3sTjy{display:inline-block;font-weight:300;overflow:hidden}.Header--headerInner--3SX7m{display:block;margin:5px 5px 5px 0;white-space:nowrap}.Header--headerOuter--3sTjy:first-of-type{cursor:pointer;font-weight:600}.Header--headerOuter--3sTjy:nth-last-of-type(2){padding-right:10px}.Header--headerClosed--15eLm .Header--headerOuter--3sTjy:nth-last-of-type(2):after{content:\"\\203A\";font-size:15px;font-weight:700;position:absolute;right:5px;top:45%;transform:translateY(-50%)}.Header--headerExpanded--r2xtw .Header--headerOuter--3sTjy:nth-last-of-type(2):after{content:\"\\203A\";font-size:15px;font-weight:700;position:absolute;right:5px;top:55%;transform:rotate(180deg) translateY(50%)}@media print{.Header--headerOuter--3sTjy{color:var(--text-black)}.Header--headerOuter--3sTjy:first-of-type{color:var(--text-black);font-weight:400;font-size:16px}}", ""]);
	
	// exports
	exports.locals = {
		"header": "Header--header--3ozrH",
		"headerOuter": "Header--headerOuter--3sTjy Header--header--3ozrH " + __webpack_require__(10).locals["lightText"] + " " + __webpack_require__(10).locals["largeSize"] + "",
		"headerInner": "Header--headerInner--3SX7m Header--header--3ozrH",
		"headerClosed": "Header--headerClosed--15eLm",
		"headerExpanded": "Header--headerExpanded--r2xtw"
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Table = __webpack_require__(76);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Table = function (_PureComponent) {
	  _inherits(Table, _PureComponent);
	
	  function Table() {
	    _classCallCheck(this, Table);
	
	    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
	  }
	
	  _createClass(Table, [{
	    key: 'getItemField',
	    value: function getItemField(item, field) {
	      return item[field];
	    }
	  }, {
	    key: 'normalizeColumns',
	    value: function normalizeColumns() {
	      var getItemField = this.getItemField;
	      var columns = this.props.columns;
	
	
	      return _lodash2.default.map(columns, function (column) {
	        return {
	          cell: getItemField,
	          className: column.className,
	          key: column.key,
	          label: column.label
	        };
	      });
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(normalizedColumns) {
	      var cells = _lodash2.default.map(normalizedColumns, function (column, key) {
	        var label = column.label;
	
	        if ((typeof label === 'undefined' ? 'undefined' : _typeof(label)) === 'object' && _lodash2.default.isEqual(_lodash2.default.keys(label), ['main', 'secondary'])) {
	          return _react2.default.createElement(
	            'th',
	            { key: key, className: column.className },
	            label.main,
	            _react2.default.createElement(
	              'span',
	              { className: _Table2.default.secondaryLabelWithMain },
	              label.secondary
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'th',
	          { key: key, className: _Table2.default.secondaryLabelAlone },
	          label
	        );
	      });
	      return _react2.default.createElement(
	        'thead',
	        { key: 'thead_' + cells.length },
	        _react2.default.createElement(
	          'tr',
	          null,
	          cells
	        )
	      );
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(normalizedColumns, rowKey, rowData) {
	      var cells = _lodash2.default.map(normalizedColumns, function (column) {
	        return _react2.default.createElement(
	          'td',
	          { key: column.key },
	          column.cell(rowData, column.key)
	        );
	      });
	      return _react2.default.createElement(
	        'tr',
	        { key: rowKey },
	        cells
	      );
	    }
	  }, {
	    key: 'renderRows',
	    value: function renderRows(normalizedColumns) {
	      var _this2 = this;
	
	      var rowData = _lodash2.default.map(this.props.rows, function (row, key) {
	        return _this2.renderRow(normalizedColumns, key, row);
	      });
	      return _react2.default.createElement(
	        'tbody',
	        { key: 'tbody_' + rowData.length },
	        rowData
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var normalizedColumns = this.normalizeColumns();
	
	      var tableContents = [];
	
	      if (!_lodash2.default.isEmpty(this.props.title)) {
	        var _props$title = this.props.title,
	            className = _props$title.className,
	            _props$title$label = _props$title.label,
	            main = _props$title$label.main,
	            secondary = _props$title$label.secondary;
	
	        var title = _react2.default.createElement(
	          'caption',
	          {
	            key: main,
	            className: className
	          },
	          main,
	          _react2.default.createElement(
	            'span',
	            { className: _Table2.default.secondaryLabelWithMain },
	            secondary
	          )
	        );
	        tableContents = [title, this.renderHeader(normalizedColumns), this.renderRows(normalizedColumns)];
	      } else {
	        tableContents = [this.renderHeader(normalizedColumns), this.renderRows(normalizedColumns)];
	      }
	
	      return _react2.default.createElement(
	        'table',
	        { className: this.props.tableStyle },
	        tableContents
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.PureComponent);
	
	Table.propTypes = {
	  title: _react2.default.PropTypes.shape({
	    className: _react2.default.PropTypes.string.isRequired,
	    label: _react2.default.PropTypes.object.isRequired
	  }),
	  rows: _react.PropTypes.array.isRequired,
	  columns: _react.PropTypes.array.isRequired,
	  tableStyle: _react.PropTypes.string.isRequired
	};
	
	var _default = Table;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Table, 'Table', '/Users/krystophv/tidepool/viz/src/components/settings/common/Table.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/common/Table.js');
	})();

	;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(77);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Table.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(78), undefined);
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".Table--secondaryLabelAlone--36Ivn{font-weight:400}@media print{.Table--secondaryLabelWithMain--1n5o2{color:var(--text-black)}}", ""]);
	
	// exports
	exports.locals = {
		"secondaryLabelAlone": "Table--secondaryLabelAlone--36Ivn " + __webpack_require__(78).locals["secondaryLeftPadding"] + "",
		"secondaryLabelWithMain": "Table--secondaryLabelWithMain--1n5o2 " + __webpack_require__(10).locals["lightText"] + " " + __webpack_require__(78).locals["secondaryLeftPadding"] + " " + __webpack_require__(10).locals["lightText"] + " " + __webpack_require__(10).locals["largeSize"] + " " + __webpack_require__(78).locals["secondaryLeftPadding"] + ""
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(36), "");
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".settings--copyButton--IE7mR{float:right;line-height:0;padding:5px;border-radius:0;cursor:pointer;color:var(--text-high-contrast);background-color:#f7fafa;border:1px solid #dbdee0;outline:none}.settings--copyButton--IE7mR:active,.settings--copyButton--IE7mR:hover{background-image:none;color:var(--white);background-color:#627cff}.settings--copyButton--IE7mR:active{opacity:.62}.settings--copyText--pjGPI{position:absolute;left:-5000px;top:10px}.settings--settingsTable--LO8hw{min-width:250px;width:100%;border-spacing:1px 0;border-collapse:separate}.settings--settingsTable--LO8hw td,.settings--settingsTable--LO8hw th{padding:10px;text-align:right}.settings--settingsTable--LO8hw td:first-of-type,.settings--settingsTable--LO8hw th:first-of-type{text-align:left}.settings--settingsTable--LO8hw tbody tr:nth-child(odd){background-color:var(--table-stripe--dark)}.settings--settingsTable--LO8hw tbody tr:nth-child(2n),.settings--settingsTable--LO8hw thead tr{background-color:var(--table-stripe--light)}.settings--basalTable--1Xos0 tbody tr:last-of-type{font-weight:700}.settings--basalHeaderBackground--3wVSO{background-image:linear-gradient(90deg,var(--basal) 0,var(--basal) 14px,#d7f1fb 0,#d7f1fb)}.settings--automatedBasalHeaderBackground--1cAWv{background-image:linear-gradient(90deg,var(--basal-automated) 0,var(--basal-automated) 14px,#d7f1fb 0,#d7f1fb)}.settings--bolusHeaderBackground--92Bay{background-image:linear-gradient(90deg,var(--bolus) 0,var(--bolus) 14px,#d7f1fb 0,#d7f1fb)}.settings--settingsHeaderDecoration--2gABz{border-bottom:1px solid var(--table-stripe--dark)}.settings--settingsHeaderHeight--2gxe8{height:40px;line-height:40px}.settings--settingsHeaderLayout--2Qhvq{min-width:160px;padding-left:28px;text-align:left}.settings--secondaryLeftPadding--xxaRk,.settings--secondaryText--4CniZ{padding-left:8px}@media print{.settings--copyButton--IE7mR{display:none}.settings--settingsTable--LO8hw{min-width:250px;width:100%;border:1px solid #000;border-collapse:collapse;padding-bottom:0}.settings--settingsTable--LO8hw tbody tr,.settings--settingsTable--LO8hw tbody tr:nth-child(odd),.settings--settingsTable--LO8hw thead{background-color:var(--bkgrnd-white);border-bottom:1px solid #cbcbcb;font-weight:700;color:var(--text-black)}.settings--settingsTable--LO8hw tbody tr:last-of-type,.settings--settingsTable--LO8hw thead tr:last-of-type{border-bottom:none}.settings--basalTable--1Xos0 tbody tr:last-of-type{font-weight:400}.settings--mainHeaderText--N-PpB{color:var(--text-black);font-weight:400}.settings--basalHeaderBackground--3wVSO,.settings--bolusHeaderBackground--92Bay{background-image:none;color:var(--text-black);font-weight:400;padding-left:0}.settings--secondaryText--4CniZ{color:var(--text-black);padding-left:8px}}", ""]);
	
	// exports
	exports.locals = {
		"copyButton": "settings--copyButton--IE7mR " + __webpack_require__(10).locals["defaultSize"] + "",
		"copyText": "settings--copyText--pjGPI",
		"settingsTable": "settings--settingsTable--LO8hw " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + "",
		"basalTable": "settings--basalTable--1Xos0 settings--settingsTable--LO8hw " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " settings--settingsTable--LO8hw " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + "",
		"basalHeaderBackground": "settings--basalHeaderBackground--3wVSO settings--mainHeaderText--N-PpB " + __webpack_require__(10).locals["largeSize"] + "",
		"automatedBasalHeaderBackground": "settings--automatedBasalHeaderBackground--1cAWv",
		"bolusHeaderBackground": "settings--bolusHeaderBackground--92Bay settings--mainHeaderText--N-PpB " + __webpack_require__(10).locals["largeSize"] + "",
		"settingsHeaderDecoration": "settings--settingsHeaderDecoration--2gABz",
		"settingsHeaderHeight": "settings--settingsHeaderHeight--2gxe8",
		"settingsHeaderLayout": "settings--settingsHeaderLayout--2Qhvq",
		"settingsHeaderText": "settings--settingsHeaderText--3qpFf " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + "",
		"settingsHeader": "settings--settingsHeader--OTqrr settings--settingsHeaderDecoration--2gABz settings--settingsHeaderHeight--2gxe8 settings--settingsHeaderLayout--2Qhvq settings--settingsHeaderText--3qpFf " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["boldText"] + "",
		"secondaryLeftPadding": "settings--secondaryLeftPadding--xxaRk",
		"secondaryText": "settings--secondaryText--4CniZ " + __webpack_require__(10).locals["lightText"] + " " + __webpack_require__(10).locals["lightText"] + " " + __webpack_require__(10).locals["largeSize"] + "",
		"mainHeaderText": "settings--mainHeaderText--N-PpB " + __webpack_require__(10).locals["largeSize"] + ""
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCollapse = __webpack_require__(80);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _SingleLineCollapsibleContainerLabel = __webpack_require__(81);
	
	var _SingleLineCollapsibleContainerLabel2 = _interopRequireDefault(_SingleLineCollapsibleContainerLabel);
	
	var _TwoLineCollapsibleContainerLabel = __webpack_require__(86);
	
	var _TwoLineCollapsibleContainerLabel2 = _interopRequireDefault(_TwoLineCollapsibleContainerLabel);
	
	var _CollapsibleContainer = __webpack_require__(89);
	
	var _CollapsibleContainer2 = _interopRequireDefault(_CollapsibleContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CollapsibleContainer = function CollapsibleContainer(props) {
	  var label = props.label,
	      labelClass = props.labelClass,
	      opened = props.opened,
	      toggleExpansion = props.toggleExpansion;
	
	  var renderedLabel = _react2.default.createElement(_SingleLineCollapsibleContainerLabel2.default, {
	    className: labelClass,
	    isOpened: opened,
	    label: label,
	    onClick: toggleExpansion
	  });
	  var twoLineLabel = props.twoLineLabel,
	      secondary = props.label.secondary;
	
	  if (twoLineLabel && !_lodash2.default.isEmpty(secondary)) {
	    renderedLabel = _react2.default.createElement(_TwoLineCollapsibleContainerLabel2.default, {
	      className: labelClass,
	      isOpened: opened,
	      label: label,
	      onClick: toggleExpansion
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    renderedLabel,
	    _react2.default.createElement(
	      _reactCollapse2.default,
	      {
	        className: _CollapsibleContainer2.default.collapsibleContainer,
	        isOpened: opened,
	        springConfig: { stiffness: 120, damping: 20 }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        props.children
	      )
	    )
	  );
	};
	
	CollapsibleContainer.defaultProps = {
	  twoLineLabel: true
	};
	
	CollapsibleContainer.propTypes = {
	  children: _react.PropTypes.element.isRequired,
	  label: _react.PropTypes.shape({
	    main: _react.PropTypes.string.isRequired,
	    secondary: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string.isRequired
	  }).isRequired,
	  labelClass: _react.PropTypes.string.isRequired,
	  opened: _react.PropTypes.bool.isRequired,
	  toggleExpansion: _react.PropTypes.func.isRequired,
	  twoLineLabel: _react.PropTypes.bool
	};
	
	var _default = CollapsibleContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CollapsibleContainer, 'CollapsibleContainer', '/Users/krystophv/tidepool/viz/src/components/settings/common/CollapsibleContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/common/CollapsibleContainer.js');
	})();

	;

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = require("react-collapse");

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _norgie = __webpack_require__(82);
	
	var _norgie2 = _interopRequireDefault(_norgie);
	
	var _SingleLineCollapsibleContainerLabel = __webpack_require__(84);
	
	var _SingleLineCollapsibleContainerLabel2 = _interopRequireDefault(_SingleLineCollapsibleContainerLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var SingleLineCollapsibleContainerLabel = function SingleLineCollapsibleContainerLabel(props) {
	  var _cx;
	
	  var className = props.className,
	      isOpened = props.isOpened,
	      _props$label = props.label,
	      main = _props$label.main,
	      secondary = _props$label.secondary,
	      units = _props$label.units,
	      onClick = props.onClick;
	
	  var containerClasses = (0, _classnames2.default)((_cx = {
	    label: true }, _defineProperty(_cx, _SingleLineCollapsibleContainerLabel2.default.collapsibleLabel, !Boolean(className)), _defineProperty(_cx, _SingleLineCollapsibleContainerLabel2.default.labelContainer, true), _defineProperty(_cx, className, Boolean(className)), _defineProperty(_cx, _norgie2.default.opened, isOpened), _cx));
	  return _react2.default.createElement(
	    'div',
	    { className: containerClasses, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _SingleLineCollapsibleContainerLabel2.default.mainText },
	        main
	      ),
	      _lodash2.default.isEmpty(secondary) ? null : _react2.default.createElement(
	        'span',
	        { className: _SingleLineCollapsibleContainerLabel2.default.secondaryText },
	        secondary
	      ),
	      _lodash2.default.isEmpty(units) ? null : _react2.default.createElement(
	        'span',
	        { className: _SingleLineCollapsibleContainerLabel2.default.secondaryText },
	        units
	      )
	    )
	  );
	};
	
	SingleLineCollapsibleContainerLabel.propTypes = {
	  className: _react.PropTypes.string,
	  isOpened: _react.PropTypes.bool.isRequired,
	  label: _react.PropTypes.shape({
	    main: _react.PropTypes.string.isRequired,
	    secondary: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string
	  }).isRequired,
	  onClick: _react.PropTypes.func.isRequired
	};
	
	var _default = SingleLineCollapsibleContainerLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SingleLineCollapsibleContainerLabel, 'SingleLineCollapsibleContainerLabel', '/Users/krystophv/tidepool/viz/src/components/settings/common/SingleLineCollapsibleContainerLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/common/SingleLineCollapsibleContainerLabel.js');
	})();

	;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./norgie.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./norgie.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".norgie--norgie--2Xwz0:after{content:\"\\203A\";font-size:15px;font-weight:700;padding-left:8px;margin-right:16px;transform:rotate(0deg);transition-duration:.25s;transition-property:rotate,transform}.norgie--opened--2KlAx:after{transform:rotate(90deg) translate(-20%,-15%)}@media print{.norgie--norgie--2Xwz0:after{content:\"\"}}", ""]);
	
	// exports
	exports.locals = {
		"norgie": "norgie--norgie--2Xwz0",
		"opened": "norgie--opened--2KlAx"
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(85);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SingleLineCollapsibleContainerLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SingleLineCollapsibleContainerLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(78), undefined);
	exports.i(__webpack_require__(10), undefined);
	exports.i(__webpack_require__(83), undefined);
	
	// module
	exports.push([module.id, ".SingleLineCollapsibleContainerLabel--labelContainer--2kj_E{cursor:pointer;display:flex;align-items:baseline}.SingleLineCollapsibleContainerLabel--labelContainer--2kj_E:hover{color:var(--text-hover)}@media print{.SingleLineCollapsibleContainerLabel--labelContainer--2kj_E{align-items:flex-end}}", ""]);
	
	// exports
	exports.locals = {
		"collapsibleLabel": "SingleLineCollapsibleContainerLabel--collapsibleLabel--p_77K " + __webpack_require__(78).locals["settingsHeader"] + "",
		"labelContainer": "SingleLineCollapsibleContainerLabel--labelContainer--2kj_E " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(83).locals["norgie"] + "",
		"mainText": "SingleLineCollapsibleContainerLabel--mainText--3i5PV " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(78).locals["mainHeaderText"] + "",
		"secondaryText": "SingleLineCollapsibleContainerLabel--secondaryText--2DG4E " + __webpack_require__(78).locals["secondaryText"] + " " + __webpack_require__(78).locals["secondaryText"] + ""
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _norgie = __webpack_require__(82);
	
	var _norgie2 = _interopRequireDefault(_norgie);
	
	var _TwoLineCollapsibleContainerLabel = __webpack_require__(87);
	
	var _TwoLineCollapsibleContainerLabel2 = _interopRequireDefault(_TwoLineCollapsibleContainerLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var TwoLineCollapsibleContainerLabel = function TwoLineCollapsibleContainerLabel(props) {
	  var _cx, _cx2;
	
	  var className = props.className,
	      isOpened = props.isOpened,
	      _props$label = props.label,
	      main = _props$label.main,
	      secondary = _props$label.secondary,
	      units = _props$label.units,
	      onClick = props.onClick;
	
	  var containerClasses = (0, _classnames2.default)((_cx = {
	    label: true }, _defineProperty(_cx, _TwoLineCollapsibleContainerLabel2.default.collapsibleLabel, !Boolean(className)), _defineProperty(_cx, _TwoLineCollapsibleContainerLabel2.default.labelContainer, true), _defineProperty(_cx, className, Boolean(className)), _cx));
	  var norgieContainerClasses = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _TwoLineCollapsibleContainerLabel2.default.norgieLabelContainer, true), _defineProperty(_cx2, _norgie2.default.opened, isOpened), _cx2));
	  return _react2.default.createElement(
	    'div',
	    { className: containerClasses, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      { className: _TwoLineCollapsibleContainerLabel2.default.secondaryLabel },
	      secondary
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: norgieContainerClasses },
	      _react2.default.createElement(
	        'div',
	        null,
	        main,
	        _react2.default.createElement(
	          'span',
	          { className: _TwoLineCollapsibleContainerLabel2.default.secondaryText },
	          units
	        )
	      )
	    )
	  );
	};
	
	TwoLineCollapsibleContainerLabel.propTypes = {
	  className: _react.PropTypes.string,
	  isOpened: _react.PropTypes.bool.isRequired,
	  label: _react.PropTypes.shape({
	    main: _react.PropTypes.string.isRequired,
	    secondary: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string.isRequired
	  }),
	  onClick: _react.PropTypes.func.isRequired
	};
	
	var _default = TwoLineCollapsibleContainerLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TwoLineCollapsibleContainerLabel, 'TwoLineCollapsibleContainerLabel', '/Users/krystophv/tidepool/viz/src/components/settings/common/TwoLineCollapsibleContainerLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/common/TwoLineCollapsibleContainerLabel.js');
	})();

	;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(88);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoLineCollapsibleContainerLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoLineCollapsibleContainerLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(78), undefined);
	exports.i(__webpack_require__(10), undefined);
	exports.i(__webpack_require__(83), undefined);
	
	// module
	exports.push([module.id, ".TwoLineCollapsibleContainerLabel--labelContainer--2DwW3{cursor:pointer;box-sizing:border-box;display:flex;flex-direction:column;justify-content:space-between;height:66px;min-width:240px;padding-top:10px;padding-bottom:10px}.TwoLineCollapsibleContainerLabel--labelContainer--2DwW3:hover{color:var(--text-hover)}.TwoLineCollapsibleContainerLabel--norgieLabelContainer--3dhbH{display:flex;justify-content:space-between;align-items:baseline}@media print{.TwoLineCollapsibleContainerLabel--labelContainer--2DwW3{cursor:pointer;box-sizing:border-box;display:flex;flex-direction:row-reverse;text-overflow:ellipsis;max-width:280px;min-width:200px;padding-top:10px;padding-bottom:10px;height:auto}}", ""]);
	
	// exports
	exports.locals = {
		"collapsibleLabel": "TwoLineCollapsibleContainerLabel--collapsibleLabel--1TCr9 " + __webpack_require__(78).locals["settingsHeaderDecoration"] + " " + __webpack_require__(78).locals["settingsHeaderLayout"] + " " + __webpack_require__(78).locals["settingsHeaderText"] + "",
		"labelContainer": "TwoLineCollapsibleContainerLabel--labelContainer--2DwW3 " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + "",
		"norgieLabelContainer": "TwoLineCollapsibleContainerLabel--norgieLabelContainer--3dhbH " + __webpack_require__(83).locals["norgie"] + "",
		"mainText": "TwoLineCollapsibleContainerLabel--mainText--1yQud " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(78).locals["mainHeaderText"] + "",
		"secondaryText": "TwoLineCollapsibleContainerLabel--secondaryText--3xarQ " + __webpack_require__(78).locals["secondaryText"] + " " + __webpack_require__(78).locals["secondaryText"] + "",
		"secondaryLabel": "TwoLineCollapsibleContainerLabel--secondaryLabel--275jJ " + __webpack_require__(10).locals["lightText"] + " " + __webpack_require__(78).locals["secondaryText"] + ""
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(90);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CollapsibleContainer.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CollapsibleContainer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(78), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"secondaryLabel": "CollapsibleContainer--secondaryLabel--25FMD " + __webpack_require__(78).locals["secondaryText"] + ""
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.basalSchedules = basalSchedules;
	exports.deviceMeta = deviceMeta;
	exports.bolusTitle = bolusTitle;
	exports.basal = basal;
	exports.sensitivity = sensitivity;
	exports.ratio = ratio;
	exports.target = target;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _data = __webpack_require__(92);
	
	var data = _interopRequireWildcard(_data);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * basalSchedules
	 * @param  {Object} settings    object with basal schedule properties
	 *
	 * @return {Array}              array of basal schedule names
	 */
	function basalSchedules(settings) {
	  return data.getScheduleNames(settings.basalSchedules);
	}
	
	/**
	 * deviceMeta
	 * @param  {Object} settingsData all settings data
	 * @param  {Object} timePrefs    timezone preferences object
	 *
	 * @return {Object}              filtered meta data
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function deviceMeta(settings, timePrefs) {
	  return data.getDeviceMeta(settings, timePrefs);
	}
	
	/**
	 * bolusTitle
	 * @param  {String} manufacturer one of: animas, carelink, insulet, medtronic
	 *
	 * @return {String}              bolus title for given manufacturer
	 */
	function bolusTitle(manufacturer) {
	  var BOLUS_SETTINGS_LABEL_BY_MANUFACTURER = {
	    animas: 'ezCarb ezBG',
	    insulet: 'Bolus Calculator',
	    medtronic: 'Bolus Wizard'
	  };
	  return BOLUS_SETTINGS_LABEL_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * scheduleLabel
	 * @private
	 */
	function scheduleLabel(scheduleName, activeScheduleName, manufacturer, noUnits) {
	  return data.getScheduleLabel(scheduleName, activeScheduleName, manufacturer, noUnits);
	}
	
	/**
	 * basalRows
	 * @private
	 */
	function basalRows(schedule, settings) {
	  return data.processBasalRateData(settings.basalSchedules[schedule]);
	}
	
	/**
	 * basalColumns
	 * @private
	 */
	function basalColumns() {
	  return data.startTimeAndValue('rate');
	}
	
	/**
	 * basal
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @return {Object}                object with basal title, columns and rows
	 */
	function basal(schedule, settings, manufacturer) {
	  var name = settings.basalSchedules[schedule].name;
	  var lookupKey = manufacturer === 'carelink' ? 'medtronic' : manufacturer;
	
	  var isAutomated = _lodash2.default.get(_constants.pumpVocabulary, [data.deviceName(lookupKey), _constants.AUTOMATED_DELIVERY]) === name;
	
	  return {
	    scheduleName: name,
	    activeAtUpload: name === settings.activeSchedule,
	    isAutomated: isAutomated,
	    title: scheduleLabel(name, settings.activeSchedule, manufacturer, isAutomated),
	    columns: isAutomated ? [] : basalColumns(),
	    rows: isAutomated ? [] : basalRows(schedule, settings)
	  };
	}
	
	/**
	 * sensitivityTitle
	 * @private
	 */
	function sensitivityTitle(manufacturer) {
	  var ISF_BY_MANUFACTURER = {
	    animas: 'ISF',
	    insulet: 'Correction factor',
	    medtronic: 'Sensitivity'
	  };
	  return ISF_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * sensitivityColumns
	 * @private
	 */
	function sensitivityColumns() {
	  return data.startTimeAndValue('amount');
	}
	
	/**
	 * sensitivityRows
	 * @private
	 */
	function sensitivityRows(settings, units) {
	  return data.processSensitivityData(settings.insulinSensitivity, units);
	}
	
	/**
	 * sensitivity
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @param  {String} units          MGDL_UNITS or MMOLL_UNITS
	 * @return {Object}                object with sensitivity title, columns and rows
	 */
	function sensitivity(settings, manufacturer, units) {
	  return {
	    title: sensitivityTitle(manufacturer),
	    columns: sensitivityColumns(),
	    rows: sensitivityRows(settings, units)
	  };
	}
	
	/**
	 * ratioTitle
	 * @private
	 */
	function ratioTitle(manufacturer) {
	  var CARB_RATIO_BY_MANUFACTURER = {
	    animas: 'I:C Ratio',
	    insulet: 'IC ratio',
	    medtronic: 'Carb Ratios'
	  };
	  return CARB_RATIO_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * ratioColumns
	 * @private
	 */
	function ratioColumns() {
	  return data.startTimeAndValue('amount');
	}
	
	/**
	 * ratioRows
	 * @private
	 */
	function ratioRows(settings) {
	  return data.processCarbRatioData(settings.carbRatio);
	}
	
	/**
	 * ratio
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @return {Object}                object with ratio title, columns and rows
	 */
	function ratio(settings, manufacturer) {
	  return {
	    title: ratioTitle(manufacturer),
	    columns: ratioColumns(),
	    rows: ratioRows(settings)
	  };
	}
	
	/**
	 * targetTitle
	 * @private
	 */
	function targetTitle(manufacturer) {
	  var BG_TARGET_BY_MANUFACTURER = {
	    animas: 'BG Target',
	    insulet: 'Target BG',
	    medtronic: 'BG Target'
	  };
	  return BG_TARGET_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * targetColumns
	 * @private
	 */
	function targetColumns(manufacturer) {
	  var BG_TARGET_COLS_BY_MANUFACTURER = {
	    animas: [{ key: 'start', label: 'Start time' }, { key: 'columnTwo', label: 'Target' }, { key: 'columnThree', label: 'Range' }],
	    insulet: [{ key: 'start', label: 'Start time' }, { key: 'columnTwo', label: 'Target' }, { key: 'columnThree', label: 'Correct Above' }],
	    medtronic: [{ key: 'start', label: 'Start time' }, { key: 'columnTwo', label: 'Low' }, { key: 'columnThree', label: 'High' }]
	  };
	  return BG_TARGET_COLS_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * targetRows
	 * @private
	 */
	function targetRows(settings, units, manufacturer) {
	  var BG_TARGET_ACCESSORS_BY_MANUFACTURER = {
	    animas: { columnTwo: 'target', columnThree: 'range' },
	    insulet: { columnTwo: 'target', columnThree: 'high' },
	    medtronic: { columnTwo: 'low', columnThree: 'high' }
	  };
	  return data.processBgTargetData(settings.bgTarget, units, BG_TARGET_ACCESSORS_BY_MANUFACTURER[manufacturer]);
	}
	
	/**
	 * target
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @param  {String} units          MGDL_UNITS or MMOLL_UNITS
	 * @return {Object}                object with target title, columns and rows
	 */
	function target(settings, manufacturer, units) {
	  return {
	    title: targetTitle(manufacturer),
	    columns: targetColumns(manufacturer),
	    rows: targetRows(settings, units, manufacturer)
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(basalSchedules, 'basalSchedules', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(deviceMeta, 'deviceMeta', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(bolusTitle, 'bolusTitle', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(scheduleLabel, 'scheduleLabel', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalRows, 'basalRows', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalColumns, 'basalColumns', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(basal, 'basal', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivityTitle, 'sensitivityTitle', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivityColumns, 'sensitivityColumns', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivityRows, 'sensitivityRows', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivity, 'sensitivity', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratioTitle, 'ratioTitle', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratioColumns, 'ratioColumns', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratioRows, 'ratioRows', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratio, 'ratio', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(targetTitle, 'targetTitle', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(targetColumns, 'targetColumns', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(targetRows, 'targetRows', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(target, 'target', '/Users/krystophv/tidepool/viz/src/utils/settings/nonTandemData.js');
	})();

	;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noData = noData;
	exports.deviceName = deviceName;
	exports.getTotalBasalRates = getTotalBasalRates;
	exports.getScheduleLabel = getScheduleLabel;
	exports.getScheduleNames = getScheduleNames;
	exports.getTimedSchedules = getTimedSchedules;
	exports.getDeviceMeta = getDeviceMeta;
	exports.processBasalRateData = processBasalRateData;
	exports.processBgTargetData = processBgTargetData;
	exports.processCarbRatioData = processCarbRatioData;
	exports.processSensitivityData = processSensitivityData;
	exports.processTimedSettings = processTimedSettings;
	exports.startTimeAndValue = startTimeAndValue;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _datetime = __webpack_require__(22);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _format = __webpack_require__(19);
	
	var format = _interopRequireWildcard(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISPLAY_PRECISION_PLACES = 3;
	
	/**
	 * noData
	 * @param  {ANY} val value to check
	 *
	 * @return {Boolean}     true if value is defined, not null, not empty string, false otherwise
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function noData(val) {
	  return val == null || typeof val === 'string' && _lodash2.default.isEmpty(val);
	}
	
	/**
	 * deviceName
	 * @param  {String} manufacturer one of: animas, insulet, medtronic, tandem
	 *
	 * @return {String}              name for given manufacturer
	 */
	function deviceName(manufacturer) {
	  var DEVICE_DISPLAY_NAME_BY_MANUFACTURER = {
	    animas: 'Animas',
	    insulet: 'OmniPod',
	    medtronic: 'Medtronic',
	    tandem: 'Tandem'
	  };
	  return DEVICE_DISPLAY_NAME_BY_MANUFACTURER[manufacturer] || manufacturer;
	}
	
	/**
	 * getBasalRate
	 * @private
	 * @param  {Array} scheduleData  basal schedule
	 * @param  {Number} startTime    milliseconds from start of day
	 * @return {String}              formatted basal rate
	 */
	function getBasalRate(scheduleData, startTime) {
	  var rate = _lodash2.default.find(scheduleData, function (schedule) {
	    return schedule.start === startTime;
	  }).rate;
	
	  if (noData(rate)) {
	    return '';
	  }
	  return format.formatDecimalNumber(rate, DISPLAY_PRECISION_PLACES);
	}
	
	/**
	 * getValue
	 * @private
	 * @param  {Array} scheduleData  scheduleData
	 * @param  {String} fieldName    field to search for
	 * @param  {Number} startTime    milliseconds from start of day
	 *
	 * @return {String}              value of field for startTime
	 */
	function getValue(scheduleData, fieldName, startTime) {
	  var val = _lodash2.default.find(scheduleData, function (schedule) {
	    return schedule.start === startTime;
	  })[fieldName];
	
	  if (noData(val)) {
	    return '';
	  }
	  return val;
	}
	
	/**
	 * getBloodGlucoseValue
	 * @private
	 * @param  {Array} scheduleData  scheduleData
	 * @param  {String} fieldName    field to search format
	 * @param  {Number} startTime    milliseconds from start of day
	 * @param  {String} units        MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {String}              formatted blood glucose value
	 */
	function getBloodGlucoseValue(scheduleData, fieldName, startTime, units) {
	  var bgValue = getValue(scheduleData, fieldName, startTime);
	  if (noData(bgValue)) {
	    return '';
	  }
	  return format.formatBgValue(bgValue, { bgUnits: units });
	}
	
	/**
	 * getStarts
	 * @private
	 * @param  {Array} timedData array with time based data
	 *
	 * @return {Array}           array of start times in milliseconds
	 */
	function getStarts(timedData) {
	  return _lodash2.default.map(timedData, 'start');
	}
	
	/**
	 * getTotalBasalRates
	 * @param  {Array} scheduleData  basal schedule data
	 *
	 * @return {String}              formatted total of basal rates
	 */
	function getTotalBasalRates(scheduleData) {
	  var HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
	  var DAY_IN_MILLISECONDS = 86400000;
	
	  var total = 0;
	  for (var i = scheduleData.length - 1; i >= 0; i--) {
	    var start = scheduleData[i].start;
	    var finish = DAY_IN_MILLISECONDS;
	    var next = i + 1;
	    if (next < scheduleData.length) {
	      finish = scheduleData[next].start;
	    }
	    var hrs = (finish - start) / HOUR_IN_MILLISECONDS;
	    var amount = parseFloat(scheduleData[i].rate.toFixed(DISPLAY_PRECISION_PLACES)) * hrs;
	    total += parseFloat(amount.toFixed(DISPLAY_PRECISION_PLACES));
	  }
	  return format.formatDecimalNumber(total, DISPLAY_PRECISION_PLACES);
	}
	
	/**
	 * getScheduleLabel
	 * @param  {String} scheduleName  basal schedule name
	 * @param  {String} activeName    name of active basal schedule at time of upload
	 * @param  {String} deviceKey    one of: animas, carelink, insulet, medtronic, tandem
	 * @param  {Boolean} noUnits      whether units should be included in label object
	 *
	 * @return {Object}              object representing basal schedule label
	 */
	function getScheduleLabel(scheduleName, activeName, deviceKey, noUnits) {
	  var CAPITALIZED = ['carelink', 'medtronic'];
	  var displayName = scheduleName;
	  if (_lodash2.default.includes(CAPITALIZED, deviceKey)) {
	    displayName = _lodash2.default.map(scheduleName.split(' '), function (part) {
	      return _lodash2.default.capitalize(part);
	    }).join(' ');
	  }
	  return {
	    main: displayName,
	    secondary: scheduleName === activeName ? 'Active at upload' : '',
	    units: noUnits ? '' : 'U/hr'
	  };
	}
	
	/**
	 * getScheduleNames
	 * @param  {Object} settingsData object with basal schedule properties
	 *
	 * @return {Array}               array of basal schedule names
	 */
	function getScheduleNames(settingsData) {
	  return _lodash2.default.keysIn(settingsData);
	}
	
	/**
	 * getTimedSchedules
	 * @param  {Array} settingsData array of basal schedules
	 *
	 * @return {Array}              array of {name, position} basal objects
	 */
	function getTimedSchedules(settingsData) {
	  var names = _lodash2.default.map(settingsData, 'name');
	  var schedules = [];
	  for (var i = names.length - 1; i >= 0; i--) {
	    schedules.push({ name: names[i], position: i });
	  }
	  return schedules;
	}
	
	/**
	 * getDeviceMeta
	 * @param  {Object} settingsData all settings data
	 * @param  {Object} timePrefs    timezone preferences object
	 *
	 * @return {Object}              filtered meta data
	 */
	function getDeviceMeta(settingsData, timePrefs) {
	  var utc = datetime.getHammertimeFromDatumWithTimePrefs(settingsData, timePrefs);
	  var uploadedTime = utc ? datetime.formatLocalizedFromUTC(utc, timePrefs, 'MMM D, YYYY') : false;
	  return {
	    schedule: settingsData.activeSchedule || 'unknown',
	    uploaded: uploadedTime || 'unknown',
	    serial: settingsData.deviceSerialNumber || 'unknown'
	  };
	}
	
	/**
	 * processBasalRateData
	 * @param  {Object} scheduleData basal schedule object
	 *
	 * @return {Array}               array of formatted schedule entries
	 */
	function processBasalRateData(scheduleData) {
	  var starts = getStarts(scheduleData.value);
	  var noRateData = [{ start: '-', rate: '-' }];
	
	  if (starts.length === 0) {
	    return noRateData;
	  } else if (starts.length === 1) {
	    if (Number(getBasalRate(scheduleData.value, starts[0])) === 0) {
	      return noRateData;
	    }
	  }
	
	  var data = _lodash2.default.map(starts, function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      rate: getBasalRate(scheduleData.value, startTime)
	    };
	  });
	
	  data.push({
	    start: 'Total',
	    rate: getTotalBasalRates(scheduleData.value)
	  });
	  return data;
	}
	
	/**
	 * processBgTargetData
	 * @param  {Array} targetsData  array of blood glucose targets
	 * @param  {String} bgUnits     MGDL_UNITS or MMOLL_UNITS
	 * @param  {Object} keys        key names as {columnTwo, columnThree}
	 *
	 * @return {Array}              formatted bloog glucose target data
	 */
	function processBgTargetData(targetsData, bgUnits, keys) {
	  return _lodash2.default.map(getStarts(targetsData), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      columnTwo: getBloodGlucoseValue(targetsData, keys.columnTwo, startTime, bgUnits),
	      columnThree: getBloodGlucoseValue(targetsData, keys.columnThree, startTime, bgUnits)
	    };
	  });
	}
	
	/**
	 * processCarbRatioData
	 * @param  {Array} carbRatioData  array of carb ratio data
	 *
	 * @return {Array}                array of formatted carb ratio objects
	 */
	function processCarbRatioData(carbRatioData) {
	  return _lodash2.default.map(getStarts(carbRatioData), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      amount: getValue(carbRatioData, 'amount', startTime)
	    };
	  });
	}
	
	/**
	 * processSensitivityData
	 * @param  {Array} sensitivityData  array of sensitivity data
	 * @param  {String} bgUnits         MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {Array}                  array of formatted sensitivity objects
	 */
	function processSensitivityData(sensitivityData, bgUnits) {
	  return _lodash2.default.map(getStarts(sensitivityData), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      amount: getBloodGlucoseValue(sensitivityData, 'amount', startTime, bgUnits)
	    };
	  });
	}
	
	/**
	 * processTimedSettings
	 * @param  {Object} pumpSettings entire pump settings object
	 * @param  {Object} schedule     {name, position} schedule object
	 * @param  {String} bgUnits      MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {Array}               array of formatted objects with
	 *                                 {start, rate, bgTarget, carbRatio, insulinSensitivity}
	 */
	function processTimedSettings(pumpSettings, schedule, bgUnits) {
	  var data = _lodash2.default.map(getStarts(pumpSettings.bgTargets[schedule.name]), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      rate: getBasalRate(pumpSettings.basalSchedules[schedule.position].value, startTime),
	      bgTarget: getBloodGlucoseValue(pumpSettings.bgTargets[schedule.name], 'target', startTime, bgUnits),
	      carbRatio: getValue(pumpSettings.carbRatios[schedule.name], 'amount', startTime),
	      insulinSensitivity: getBloodGlucoseValue(pumpSettings.insulinSensitivities[schedule.name], 'amount', startTime, bgUnits)
	    };
	  });
	
	  data.push({
	    start: 'Total',
	    rate: getTotalBasalRates(pumpSettings.basalSchedules[schedule.position].value),
	    bgTarget: '',
	    carbRatio: '',
	    insulinSensitivity: ''
	  });
	  return data;
	}
	
	/**
	 * startTimeAndValue
	 * @param {TYPE} accessor key for value displayed in this column
	 *
	 * @return {Array} array of objects describing table columns
	 */
	function startTimeAndValue(valueKey) {
	  return [{ key: 'start', label: 'Start time' }, { key: valueKey, label: 'Value' }];
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DISPLAY_PRECISION_PLACES, 'DISPLAY_PRECISION_PLACES', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(noData, 'noData', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(deviceName, 'deviceName', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getBasalRate, 'getBasalRate', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getValue, 'getValue', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getBloodGlucoseValue, 'getBloodGlucoseValue', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getStarts, 'getStarts', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getTotalBasalRates, 'getTotalBasalRates', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getScheduleLabel, 'getScheduleLabel', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getScheduleNames, 'getScheduleNames', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getTimedSchedules, 'getTimedSchedules', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getDeviceMeta, 'getDeviceMeta', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processBasalRateData, 'processBasalRateData', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processBgTargetData, 'processBgTargetData', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processCarbRatioData, 'processCarbRatioData', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processSensitivityData, 'processSensitivityData', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processTimedSettings, 'processTimedSettings', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(startTimeAndValue, 'startTimeAndValue', '/Users/krystophv/tidepool/viz/src/utils/settings/data.js');
	})();

	;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                               * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                               * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                               * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                               * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                               * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                               * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                               * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                               */
	
	exports.nonTandemText = nonTandemText;
	exports.tandemText = tandemText;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _textTable = __webpack_require__(94);
	
	var _textTable2 = _interopRequireDefault(_textTable);
	
	var _tandemData = __webpack_require__(95);
	
	var tandemData = _interopRequireWildcard(_tandemData);
	
	var _nonTandemData = __webpack_require__(91);
	
	var nonTandemData = _interopRequireWildcard(_nonTandemData);
	
	var _datetime = __webpack_require__(22);
	
	var _misc = __webpack_require__(96);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * getItemField
	 * @private
	 */
	function getItemField(item, field) {
	  return item[field];
	}
	
	/**
	 * normalizeColumns
	 * @private
	 */
	function normalizeColumns(columns) {
	  return _lodash2.default.map(columns, function (column) {
	    return {
	      cell: getItemField,
	      key: column.key,
	      label: column.label
	    };
	  });
	}
	
	/**
	 * getRow
	 * @private
	 */
	function getRow(normalizedColumns, rowKey, rowData) {
	  return _lodash2.default.map(normalizedColumns, function (column) {
	    return column.cell(rowData, column.key);
	  });
	}
	
	/**
	 * getHeader
	 * @private
	 */
	function getHeader(normalizedColumns) {
	  return _lodash2.default.map(normalizedColumns, function (column) {
	    if (_typeof(column.label) === 'object') {
	      return column.label.main + ' ' + column.label.secondary;
	    }
	    return column.label;
	  });
	}
	
	/**
	 * getRows
	 * @private
	 */
	function getRows(rows, columns) {
	  return _lodash2.default.map(rows, function (row, key) {
	    return getRow(normalizeColumns(columns), key, row);
	  });
	}
	
	/**
	 * toTextTable
	 * @private
	 */
	function toTextTable(rows, columns) {
	  var header = [getHeader(normalizeColumns(columns))];
	  var content = getRows(rows, columns);
	  return (0, _textTable2.default)(header.concat(content));
	}
	
	/**
	 * buildTextTable
	 * @private
	 */
	function buildTextTable(name, rows, columns) {
	  return '\n' + name + '\n' + toTextTable(rows, columns) + '\n';
	}
	
	/**
	 * formatTitle
	 * @private
	 */
	function formatTitle(patient) {
	  var exported = 'Exported from Tidepool: ' + (0, _datetime.formatCurrentDate)();
	  var bday = 'Date of birth: ' + (0, _datetime.formatBirthdate)(patient);
	  var diagnosis = 'Date of diagnosis: ' + (0, _datetime.formatDiagnosisDate)(patient);
	  var fullname = (0, _misc.getPatientFullName)(patient);
	  return fullname + '\n' + bday + '\n' + diagnosis + '\n' + exported + '\n';
	}
	
	/**
	 * nonTandemText
	 * @param  {Object} patient     the patient object that contains the profile
	 * @param  {String} units         MGDL_UNITS or MMOLL_UNITS
	 * @param  {String} manufacturer  one of: animas, carelink, insulet, medtronic
	 *
	 * @return {String}               non tandem settings as a string table
	 */
	function nonTandemText(patient, settings, units, manufacturer) {
	  var tablesString = formatTitle(patient);
	  _lodash2.default.map(nonTandemData.basalSchedules(settings), function (schedule) {
	    var basal = nonTandemData.basal(schedule, settings, manufacturer);
	    tablesString += buildTextTable(basal.scheduleName, basal.rows, basal.columns);
	  });
	
	  var sensitivity = nonTandemData.sensitivity(settings, manufacturer, units);
	  tablesString += buildTextTable(sensitivity.title + ' ' + units + '/U', sensitivity.rows, sensitivity.columns);
	
	  var target = nonTandemData.target(settings, manufacturer, units);
	  tablesString += buildTextTable(target.title + ' ' + units, target.rows, target.columns);
	
	  var ratio = nonTandemData.ratio(settings, manufacturer);
	  tablesString += buildTextTable(ratio.title + ' g/U', ratio.rows, ratio.columns);
	
	  return tablesString;
	}
	
	/**
	 * tandemText
	 * @param  {Object} patient     the patient object that contains the profile
	 * @param  {Object} settings    all settings data
	 * @param  {String} units       MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {String}             tandem settings as a string table
	 */
	function tandemText(patient, settings, units) {
	  var styles = {
	    bolusSettingsHeader: '',
	    basalScheduleHeader: ''
	  };
	
	  var tablesString = formatTitle(patient);
	  _lodash2.default.map(tandemData.basalSchedules(settings), function (schedule) {
	    var basal = tandemData.basal(schedule, settings, units, styles);
	    tablesString += buildTextTable(basal.scheduleName, basal.rows, basal.columns);
	  });
	  return tablesString;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getItemField, 'getItemField', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(normalizeColumns, 'normalizeColumns', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(getRow, 'getRow', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(getHeader, 'getHeader', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(getRows, 'getRows', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(toTextTable, 'toTextTable', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(buildTextTable, 'buildTextTable', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(formatTitle, 'formatTitle', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(nonTandemText, 'nonTandemText', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(tandemText, 'tandemText', '/Users/krystophv/tidepool/viz/src/utils/settings/textData.js');
	})();

	;

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = function (rows_, opts) {
	    if (!opts) opts = {};
	    var hsep = opts.hsep === undefined ? '  ' : opts.hsep;
	    var align = opts.align || [];
	    var stringLength = opts.stringLength
	        || function (s) { return String(s).length; }
	    ;
	    
	    var dotsizes = reduce(rows_, function (acc, row) {
	        forEach(row, function (c, ix) {
	            var n = dotindex(c);
	            if (!acc[ix] || n > acc[ix]) acc[ix] = n;
	        });
	        return acc;
	    }, []);
	    
	    var rows = map(rows_, function (row) {
	        return map(row, function (c_, ix) {
	            var c = String(c_);
	            if (align[ix] === '.') {
	                var index = dotindex(c);
	                var size = dotsizes[ix] + (/\./.test(c) ? 1 : 2)
	                    - (stringLength(c) - index)
	                ;
	                return c + Array(size).join(' ');
	            }
	            else return c;
	        });
	    });
	    
	    var sizes = reduce(rows, function (acc, row) {
	        forEach(row, function (c, ix) {
	            var n = stringLength(c);
	            if (!acc[ix] || n > acc[ix]) acc[ix] = n;
	        });
	        return acc;
	    }, []);
	    
	    return map(rows, function (row) {
	        return map(row, function (c, ix) {
	            var n = (sizes[ix] - stringLength(c)) || 0;
	            var s = Array(Math.max(n + 1, 1)).join(' ');
	            if (align[ix] === 'r' || align[ix] === '.') {
	                return s + c;
	            }
	            if (align[ix] === 'c') {
	                return Array(Math.ceil(n / 2 + 1)).join(' ')
	                    + c + Array(Math.floor(n / 2 + 1)).join(' ')
	                ;
	            }
	            
	            return c + s;
	        }).join(hsep).replace(/\s+$/, '');
	    }).join('\n');
	};
	
	function dotindex (c) {
	    var m = /\.[^.]*$/.exec(c);
	    return m ? m.index + 1 : c.length;
	}
	
	function reduce (xs, f, init) {
	    if (xs.reduce) return xs.reduce(f, init);
	    var i = 0;
	    var acc = arguments.length >= 3 ? init : xs[i++];
	    for (; i < xs.length; i++) {
	        f(acc, xs[i], i);
	    }
	    return acc;
	}
	
	function forEach (xs, f) {
	    if (xs.forEach) return xs.forEach(f);
	    for (var i = 0; i < xs.length; i++) {
	        f.call(xs, xs[i], i);
	    }
	}
	
	function map (xs, f) {
	    if (xs.map) return xs.map(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        res.push(f.call(xs, xs[i], i));
	    }
	    return res;
	}


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.basalSchedules = basalSchedules;
	exports.deviceMeta = deviceMeta;
	exports.basal = basal;
	
	var _data = __webpack_require__(92);
	
	var data = _interopRequireWildcard(_data);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * basalSchedules
	 * @param  {Object} settings    object with basal schedule properties
	 *
	 * @return {Array}              array of basal schedule names
	 */
	function basalSchedules(settings) {
	  return data.getTimedSchedules(settings.basalSchedules);
	}
	
	/**
	 * deviceMeta
	 * @param  {Object} settingsData all settings data
	 * @param  {Object} timePrefs    timezone preferences object
	 *
	 * @return {Object}              filtered meta data
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	function deviceMeta(settings, timePrefs) {
	  return data.getDeviceMeta(settings, timePrefs);
	}
	
	/**
	 * scheduleLabel
	 * @private
	 */
	function scheduleLabel(scheduleName, activeScheduleName) {
	  return data.getScheduleLabel(scheduleName, activeScheduleName, 'tandem', true);
	}
	
	/**
	 * basalRows
	 * @private
	 */
	function basalRows(schedule, settings, units) {
	  return data.processTimedSettings(settings, schedule, units);
	}
	
	/**
	 * basalColumns
	 * @private
	 */
	function basalColumns() {
	  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var units = arguments[1];
	
	  return [{ key: 'start',
	    label: 'Start time' }, { key: 'rate',
	    label: {
	      main: 'Basal Rates',
	      secondary: 'U/hr'
	    },
	    className: styles.basalScheduleHeader }, { key: 'bgTarget',
	    label: {
	      main: 'Target BG',
	      secondary: units
	    },
	    className: styles.bolusSettingsHeader }, { key: 'carbRatio',
	    label: {
	      main: 'Carb Ratio',
	      secondary: 'g/U'
	    },
	    className: styles.bolusSettingsHeader }, { key: 'insulinSensitivity',
	    label: {
	      main: 'Correction Factor',
	      secondary: units + '/U'
	    },
	    className: styles.bolusSettingsHeader }];
	}
	
	/**
	 * basal
	 *
	 * @param  {Object} schedule       object schedule to build basal data from
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} units          MGDL_UNITS or MMOLL_UNITS
	 * @param  {String} styles         object with applicable styles
	 * @return {Object}                object with basal title, columns and rows
	 */
	function basal(schedule, settings, units) {
	  var styles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  return {
	    scheduleName: schedule.name,
	    activeAtUpload: schedule.name === settings.activeSchedule,
	    title: scheduleLabel(schedule.name, settings.activeSchedule),
	    columns: basalColumns(styles, units),
	    rows: basalRows(schedule, settings, units)
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(basalSchedules, 'basalSchedules', '/Users/krystophv/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(deviceMeta, 'deviceMeta', '/Users/krystophv/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(scheduleLabel, 'scheduleLabel', '/Users/krystophv/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalRows, 'basalRows', '/Users/krystophv/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalColumns, 'basalColumns', '/Users/krystophv/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(basal, 'basal', '/Users/krystophv/tidepool/viz/src/utils/settings/tandemData.js');
	})();

	;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPatientFullName = getPatientFullName;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * getPatientFullName
	 * @param {Object} patient - Tidepool patient object containing profile
	 *
	 * @return {String} PwD's full name (first & last)
	 */
	function getPatientFullName(patient) {
	  var profile = _lodash2.default.get(patient, ['profile'], {});
	  var patientInfo = profile.patient || {};
	
	  if (patientInfo.isOtherPerson) {
	    return patientInfo.fullName;
	  }
	  return profile.fullName;
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2017, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getPatientFullName, 'getPatientFullName', '/Users/krystophv/tidepool/viz/src/utils/misc.js');
	})();

	;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(98);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./NonTandem.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./NonTandem.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(78), undefined);
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".NonTandem--settingsContainer--2fKe2{align-items:flex-start;display:flex;justify-content:flex-start}.NonTandem--basalSettingsContainer--1Gj53{margin-right:10px}.NonTandem--bolusSettingsContainer--1o-pm{display:flex;flex-wrap:wrap}.NonTandem--categoryTitle--2pdui{width:100%;padding-bottom:10px}.NonTandem--categoryContainer--3Q1L4{max-width:300px;min-width:250px;margin-bottom:10px;margin-right:10px}.NonTandem--basalTable--HXb6D td:first-child,.NonTandem--basalTable--HXb6D th:first-child{padding-left:28px}.NonTandem--settingsTable--12bkW td:first-child,.NonTandem--settingsTable--12bkW th:first-child{padding-left:28px}.NonTandem--singleLineBasalScheduleHeader--1Q1_w{justify-content:space-between}.NonTandem--twoLineBasalScheduleHeader--1JyRt>div:first-child{padding-left:0}.NonTandem--automatedBasalHeaderBackground--1VWcm{text-align:left;padding-left:28px}.NonTandem--automatedBasalHeaderBackground--1VWcm>span{padding-left:5px}@media print{.NonTandem--categoryContainer--3Q1L4{max-width:280px;min-width:250px;width:100%;margin-bottom:10px;margin-right:10px}.NonTandem--settingsContainer--2fKe2{display:block}.NonTandem--basalSettingsContainer--1Gj53{display:flex;flex-flow:row wrap;justify-content:flex-start;page-break-after:auto}.NonTandem--bolusSettingsContainer--1o-pm{display:flex;flex-flow:row wrap;justify-content:flex-start;page-break-inside:avoid}.NonTandem--categoryTitle--2pdui{font-weight:400;font-size:20px;color:var(--text-black);width:100%;padding-bottom:10px}}", ""]);
	
	// exports
	exports.locals = {
		"copyButton": "NonTandem--copyButton--1rRY7 " + __webpack_require__(78).locals["copyButton"] + " " + __webpack_require__(78).locals["copyButton"] + "",
		"copyText": "NonTandem--copyText--3Ez6d " + __webpack_require__(78).locals["copyText"] + "",
		"settingsContainer": "NonTandem--settingsContainer--2fKe2",
		"basalSettingsContainer": "NonTandem--basalSettingsContainer--1Gj53",
		"bolusSettingsContainer": "NonTandem--bolusSettingsContainer--1o-pm",
		"categoryTitle": "NonTandem--categoryTitle--2pdui " + __webpack_require__(10).locals["mediumContrastText"] + "",
		"categoryContainer": "NonTandem--categoryContainer--3Q1L4",
		"basalTable": "NonTandem--basalTable--HXb6D " + __webpack_require__(78).locals["basalTable"] + "",
		"settingsTable": "NonTandem--settingsTable--12bkW " + __webpack_require__(78).locals["settingsTable"] + "",
		"singleLineBasalScheduleHeader": "NonTandem--singleLineBasalScheduleHeader--1Q1_w " + __webpack_require__(78).locals["basalHeaderBackground"] + " " + __webpack_require__(78).locals["settingsHeader"] + "",
		"twoLineBasalScheduleHeader": "NonTandem--twoLineBasalScheduleHeader--1JyRt " + __webpack_require__(78).locals["basalHeaderBackground"] + " " + __webpack_require__(78).locals["settingsHeaderDecoration"] + " " + __webpack_require__(78).locals["settingsHeaderLayout"] + " " + __webpack_require__(78).locals["settingsHeaderText"] + "",
		"bolusSettingsHeader": "NonTandem--bolusSettingsHeader--YxGSG " + __webpack_require__(78).locals["bolusHeaderBackground"] + " " + __webpack_require__(78).locals["settingsHeader"] + "",
		"automatedBasalHeaderBackground": "NonTandem--automatedBasalHeaderBackground--1VWcm " + __webpack_require__(78).locals["automatedBasalHeaderBackground"] + ""
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactClipboard = __webpack_require__(63);
	
	var _reactClipboard2 = _interopRequireDefault(_reactClipboard);
	
	var _Tandem = __webpack_require__(100);
	
	var _Tandem2 = _interopRequireDefault(_Tandem);
	
	var _Header = __webpack_require__(72);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Table = __webpack_require__(75);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _CollapsibleContainer = __webpack_require__(79);
	
	var _CollapsibleContainer2 = _interopRequireDefault(_CollapsibleContainer);
	
	var _constants = __webpack_require__(18);
	
	var _data = __webpack_require__(92);
	
	var _tandemData = __webpack_require__(95);
	
	var tandemData = _interopRequireWildcard(_tandemData);
	
	var _textData = __webpack_require__(93);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tandem = function Tandem(props) {
	  var bgUnits = props.bgUnits,
	      copySettingsClicked = props.copySettingsClicked,
	      openedSections = props.openedSections,
	      pumpSettings = props.pumpSettings,
	      timePrefs = props.timePrefs,
	      toggleProfileExpansion = props.toggleProfileExpansion,
	      user = props.user,
	      deviceDisplayName = props.deviceDisplayName;
	
	
	  function openSection(sectionName) {
	    return _lodash2.default.get(openedSections, sectionName, false);
	  }
	
	  var tables = _lodash2.default.map(tandemData.basalSchedules(pumpSettings), function (schedule) {
	    var basal = tandemData.basal(schedule, pumpSettings, bgUnits, _Tandem2.default);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'settings-table-container', key: basal.scheduleName },
	      _react2.default.createElement(
	        _CollapsibleContainer2.default,
	        {
	          label: basal.title,
	          labelClass: _Tandem2.default.collapsibleLabel,
	          opened: openSection(basal.scheduleName),
	          toggleExpansion: _lodash2.default.partial(toggleProfileExpansion, basal.scheduleName),
	          twoLineLabel: false
	        },
	        _react2.default.createElement(_Table2.default, {
	          rows: basal.rows,
	          columns: basal.columns,
	          tableStyle: _Tandem2.default.profileTable
	        })
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactClipboard2.default,
	      {
	        className: _Tandem2.default.copyButton,
	        'button-title': 'For email or notes',
	        'data-clipboard-target': '#copySettingsText',
	        onSuccess: copySettingsClicked
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Copy as text'
	      )
	    ),
	    _react2.default.createElement(_Header2.default, {
	      deviceDisplayName: deviceDisplayName,
	      deviceMeta: tandemData.deviceMeta(pumpSettings, timePrefs)
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _Tandem2.default.title },
	        'Profile Settings'
	      ),
	      tables
	    ),
	    _react2.default.createElement(
	      'pre',
	      { className: _Tandem2.default.copyText, id: 'copySettingsText' },
	      (0, _textData.tandemText)(user, pumpSettings, bgUnits)
	    )
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	Tandem.propTypes = {
	  bgUnits: _react.PropTypes.oneOf([_constants.MMOLL_UNITS, _constants.MGDL_UNITS]).isRequired,
	  copySettingsClicked: _react.PropTypes.func.isRequired,
	  deviceKey: _react.PropTypes.oneOf(['tandem']).isRequired,
	  deviceDisplayName: _react.PropTypes.string.isRequired,
	  openedSections: _react.PropTypes.object.isRequired,
	  pumpSettings: _react.PropTypes.shape({
	    activeSchedule: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.object.isRequired,
	    deviceId: _react.PropTypes.string.isRequired,
	    basalSchedules: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      name: _react.PropTypes.string.isRequired,
	      value: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        start: _react.PropTypes.number.isRequired,
	        rate: _react.PropTypes.number.isRequired
	      }))
	    }).isRequired).isRequired,
	    bgTargets: _react.PropTypes.objectOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      target: _react.PropTypes.number.isRequired
	    })).isRequired).isRequired,
	    carbRatios: _react.PropTypes.objectOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired).isRequired,
	    insulinSensitivities: _react.PropTypes.objectOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired).isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react.PropTypes.oneOfType([_react.PropTypes.string, null])
	  }).isRequired,
	  toggleProfileExpansion: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired
	};
	
	Tandem.defaultProps = {
	  deviceDisplayName: (0, _data.deviceName)('tandem'),
	  deviceKey: 'tandem'
	};
	
	var _default = Tandem;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Tandem, 'Tandem', '/Users/krystophv/tidepool/viz/src/components/settings/Tandem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/settings/Tandem.js');
	})();

	;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./Tandem.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./Tandem.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(36), "");
	exports.i(__webpack_require__(78), undefined);
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".Tandem--headerCommon--jh5e1{line-height:20px}.Tandem--collapsibleLabel--11wnp{border-top:1px solid var(--collapsible--border);justify-content:flex-start;line-height:40px;margin-left:20px;padding-left:1em}.Tandem--profileTable--zPo8g{padding-bottom:1em;margin-left:40px;width:800px}.Tandem--profileTable--zPo8g td,.Tandem--profileTable--zPo8g th{font-size:14px;text-align:center}.Tandem--profileTable--zPo8g th:first-of-type{font-weight:700}.Tandem--title--3io-V{display:inline-block;padding-bottom:10px}@media print{.Tandem--title--3io-V{font-weight:400;font-size:20px;color:var(--text-black);display:inline-block;padding-bottom:10px}.Tandem--profileTable--zPo8g th{font-weight:400;color:#000}.Tandem--profileTable--zPo8g th:first-of-type{font-weight:400}}", ""]);
	
	// exports
	exports.locals = {
		"copyButton": "Tandem--copyButton--aSN26 " + __webpack_require__(78).locals["copyButton"] + " " + __webpack_require__(78).locals["copyButton"] + "",
		"copyText": "Tandem--copyText--1UIV1 " + __webpack_require__(78).locals["copyText"] + "",
		"headerCommon": "Tandem--headerCommon--jh5e1",
		"basalScheduleHeader": "Tandem--basalScheduleHeader--2FrXF " + __webpack_require__(78).locals["basalHeaderBackground"] + " " + __webpack_require__(78).locals["settingsHeaderText"] + " Tandem--headerCommon--jh5e1",
		"bolusSettingsHeader": "Tandem--bolusSettingsHeader--2LSvh " + __webpack_require__(78).locals["bolusHeaderBackground"] + " " + __webpack_require__(78).locals["settingsHeaderText"] + " Tandem--headerCommon--jh5e1",
		"collapsibleLabel": "Tandem--collapsibleLabel--11wnp",
		"profileTable": "Tandem--profileTable--zPo8g " + __webpack_require__(78).locals["basalTable"] + "",
		"title": "Tandem--title--3io-V " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(10).locals["defaultSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + ""
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TrendsContainer = undefined;
	
	var _PropTypes$shape, _yScaleClampTop;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getAllDatesInRange = getAllDatesInRange;
	exports.getLocalizedNoonBeforeUTC = getLocalizedNoonBeforeUTC;
	exports.getLocalizedOffset = getLocalizedOffset;
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bows = __webpack_require__(103);
	
	var _bows2 = _interopRequireDefault(_bows);
	
	var _d3Array = __webpack_require__(105);
	
	var _d3Scale = __webpack_require__(106);
	
	var _d3Time = __webpack_require__(13);
	
	var _momentTimezone = __webpack_require__(23);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _actions = __webpack_require__(48);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _TrendsSVGContainer = __webpack_require__(107);
	
	var _TrendsSVGContainer2 = _interopRequireDefault(_TrendsSVGContainer);
	
	var _constants = __webpack_require__(18);
	
	var _datetime = __webpack_require__(22);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _bloodglucose = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var _trends$extentSizes = _constants.trends.extentSizes,
	    ONE_WEEK = _trends$extentSizes.ONE_WEEK,
	    TWO_WEEKS = _trends$extentSizes.TWO_WEEKS,
	    FOUR_WEEKS = _trends$extentSizes.FOUR_WEEKS;
	
	/**
	 * getAllDatesInRange
	 * @param {String} start - Zulu timestamp (Integer hammertime also OK)
	 * @param {String} end - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {Array} dates - array of YYYY-MM-DD String dates
	 */
	
	function getAllDatesInRange(start, end, timePrefs) {
	  var timezoneName = datetime.getTimezoneFromTimePrefs(timePrefs);
	  var dates = [];
	  var current = _momentTimezone2.default.utc(start).tz(timezoneName);
	  var excludedBoundary = _momentTimezone2.default.utc(end);
	  while (current.isBefore(excludedBoundary)) {
	    dates.push(current.format('YYYY-MM-DD'));
	    current.add(1, 'day');
	  }
	  return dates;
	}
	
	/**
	 * getLocalizedNoonBeforeUTC
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {JavaScript Date} the closet noon before the input datetime in the given timezone
	 */
	function getLocalizedNoonBeforeUTC(utc, timePrefs) {
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = datetime.getTimezoneFromTimePrefs(timePrefs);
	  var ceil = datetime.getLocalizedCeiling(utc, timePrefs);
	  return _momentTimezone2.default.utc(ceil.valueOf()).tz(timezone).subtract(1, 'day').hours(12).toDate();
	}
	
	/**
	 * getLocalizedOffset
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} offset - { amount: integer (+/-), units: 'hour', 'day', &c }
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {JavaScript Date} datetime at the specified +/- offset from the input datetime
	 *                           inspired by d3-time's offset function: https://github.com/d3/d3-time#interval_offset
	 *                           but able to work with an arbitrary timezone
	 */
	function getLocalizedOffset(utc, offset, timePrefs) {
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = datetime.getTimezoneFromTimePrefs(timePrefs);
	  return _momentTimezone2.default.utc(utc).tz(timezone).add(offset.amount, offset.units).toDate();
	}
	
	var TrendsContainer = exports.TrendsContainer = function (_PureComponent) {
	  _inherits(TrendsContainer, _PureComponent);
	
	  function TrendsContainer(props) {
	    _classCallCheck(this, TrendsContainer);
	
	    var _this = _possibleConstructorReturn(this, (TrendsContainer.__proto__ || Object.getPrototypeOf(TrendsContainer)).call(this, props));
	
	    _this.log = (0, _bows2.default)('TrendsContainer');
	    _this.state = {
	      currentCbgData: [],
	      currentSmbgData: [],
	      dateDomain: null,
	      mostRecent: null,
	      previousDateDomain: null,
	      xScale: null,
	      yScale: null
	    };
	
	    _this.selectDate = _this.selectDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(TrendsContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.mountData();
	    }
	
	    /*
	     * NB: we don't do as much here as one might expect
	     * because we're using the "expose component functions"
	     * strategy of communicating between components
	     * (https://facebook.github.io/react/tips/expose-component-functions.html)
	     * this is the legacy of blip's interface with the d3.chart-architected
	     * smbg version of trends view and thus only remains
	     * as a temporary compatibility interface
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newDataLoaded = this.props.loading && !nextProps.loading;
	
	      if (newDataLoaded) {
	        this.mountData(nextProps);
	      }
	
	      if (!_lodash2.default.isEqual(nextProps.activeDays, this.props.activeDays)) {
	        var cbgByDayOfWeek = nextProps.cbgByDayOfWeek,
	            smbgByDayOfWeek = nextProps.smbgByDayOfWeek,
	            smbgByDate = nextProps.smbgByDate,
	            cbgByDate = nextProps.cbgByDate;
	
	        this.refilterByDayOfWeek(cbgByDayOfWeek, nextProps.activeDays);
	        this.refilterByDayOfWeek(smbgByDayOfWeek, nextProps.activeDays);
	        this.setState({
	          currentCbgData: cbgByDate.top(Infinity).reverse(),
	          currentSmbgData: smbgByDate.top(Infinity).reverse()
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props = this.props,
	          currentPatientInViewId = _props.currentPatientInViewId,
	          trendsState = _props.trendsState,
	          unfocusCbgSlice = _props.unfocusCbgSlice,
	          unfocusSmbg = _props.unfocusSmbg,
	          unfocusSmbgRangeAvg = _props.unfocusSmbgRangeAvg;
	
	      if (_lodash2.default.get(trendsState, 'focusedCbgSlice') !== null) {
	        unfocusCbgSlice(currentPatientInViewId);
	      }
	      if (_lodash2.default.get(trendsState, 'focusedSmbg') !== null) {
	        unfocusSmbg(currentPatientInViewId);
	      }
	      if (_lodash2.default.get(trendsState, 'focusedSmbgRangeAvg') !== null) {
	        unfocusSmbgRangeAvg(currentPatientInViewId);
	      }
	    }
	  }, {
	    key: 'mountData',
	    value: function mountData() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      // find BG domain (for yScale construction)
	      var cbgByDate = props.cbgByDate,
	          cbgByDayOfWeek = props.cbgByDayOfWeek,
	          smbgByDate = props.smbgByDate,
	          smbgByDayOfWeek = props.smbgByDayOfWeek;
	
	      var allBg = cbgByDate.filterAll().top(Infinity).concat(smbgByDate.filterAll().top(Infinity));
	      var bgDomain = (0, _d3Array.extent)(allBg, function (d) {
	        return d.value;
	      });
	
	      var _props$bgPrefs = props.bgPrefs,
	          bgBounds = _props$bgPrefs.bgBounds,
	          bgUnits = _props$bgPrefs.bgUnits,
	          yScaleClampTop = props.yScaleClampTop;
	
	      var upperBound = yScaleClampTop[bgUnits];
	      var yScaleDomain = [bgDomain[0], upperBound];
	      if (bgDomain[0] > bgBounds.targetLowerBound) {
	        yScaleDomain[0] = bgBounds.targetLowerBound;
	      }
	      var yScale = (0, _d3Scale.scaleLinear)().domain(yScaleDomain).clamp(true);
	
	      // find initial date domain (based on initialDatetimeLocation or current time)
	      var extentSize = props.extentSize,
	          initialDatetimeLocation = props.initialDatetimeLocation,
	          timePrefs = props.timePrefs;
	
	      var timezone = datetime.getTimezoneFromTimePrefs(timePrefs);
	      var mostRecent = datetime.getLocalizedCeiling(new Date().valueOf(), timezone);
	      var end = initialDatetimeLocation ? datetime.getLocalizedCeiling(initialDatetimeLocation, timezone) : mostRecent;
	      var start = _d3Time.utcDay.offset(end, -extentSize);
	      var dateDomain = [start.toISOString(), end.toISOString()];
	
	      // filter data according to current activeDays and dateDomain
	      this.initialFiltering(cbgByDate, cbgByDayOfWeek, dateDomain);
	      this.initialFiltering(smbgByDate, smbgByDayOfWeek, dateDomain);
	
	      var state = {
	        bgDomain: { lo: bgDomain[0], hi: bgDomain[1] },
	        currentCbgData: cbgByDate.top(Infinity).reverse(),
	        currentSmbgData: smbgByDate.top(Infinity).reverse(),
	        dateDomain: { start: dateDomain[0], end: dateDomain[1] },
	        mostRecent: mostRecent.toISOString(),
	        xScale: (0, _d3Scale.scaleLinear)().domain([0, 864e5]),
	        yScale: yScale
	      };
	
	      this.setState(state, this.determineDataToShow);
	      props.onDatetimeLocationChange(dateDomain, end === mostRecent);
	    }
	  }, {
	    key: 'getCurrentDay',
	    value: function getCurrentDay() {
	      var end = this.state.dateDomain.end;
	
	      return getLocalizedNoonBeforeUTC(end, this.props.timePrefs).toISOString();
	    }
	  }, {
	    key: 'setExtent',
	    value: function setExtent(newDomain, oldDomain) {
	      var _props2 = this.props,
	          cbgByDate = _props2.cbgByDate,
	          smbgByDate = _props2.smbgByDate;
	      var mostRecent = this.state.mostRecent;
	
	      this.refilterByDate(cbgByDate, newDomain);
	      this.refilterByDate(smbgByDate, newDomain);
	      this.setState({
	        currentCbgData: cbgByDate.top(Infinity).reverse(),
	        currentSmbgData: smbgByDate.top(Infinity).reverse(),
	        dateDomain: { start: newDomain[0], end: newDomain[1] },
	        previousDateDomain: oldDomain ? { start: oldDomain[0], end: oldDomain[1] } : null
	      });
	      this.props.onDatetimeLocationChange(newDomain, newDomain[1] >= mostRecent);
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate() {
	      var _this2 = this;
	
	      var timePrefs = this.props.timePrefs;
	
	      return function (date) {
	        var noonOnDate = _momentTimezone2.default.tz(date, datetime.getTimezoneFromTimePrefs(timePrefs)).startOf('day').add(12, 'hours').toISOString();
	        _this2.props.onSelectDate(noonOnDate);
	      };
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      var oldDomain = _lodash2.default.clone(this.state.dateDomain);
	      var newEnd = this.state.dateDomain.start;
	
	      var start = getLocalizedOffset(newEnd, {
	        // negative because we are moving backward in time
	        amount: -this.props.extentSize,
	        units: 'days'
	      }, this.props.timePrefs).toISOString();
	      var newDomain = [start, newEnd];
	      this.setExtent(newDomain, [oldDomain.start, oldDomain.end]);
	    }
	  }, {
	    key: 'goForward',
	    value: function goForward() {
	      var oldDomain = _lodash2.default.clone(this.state.dateDomain);
	      var newStart = this.state.dateDomain.end;
	
	      var end = _d3Time.utcDay.offset(new Date(newStart), this.props.extentSize).toISOString();
	      var newDomain = [newStart, end];
	      this.setExtent(newDomain, [oldDomain.start, oldDomain.end]);
	    }
	  }, {
	    key: 'goToMostRecent',
	    value: function goToMostRecent() {
	      var end = this.state.mostRecent;
	
	      var start = _d3Time.utcDay.offset(new Date(end), -this.props.extentSize).toISOString();
	      var newDomain = [start, end];
	      this.setExtent(newDomain);
	    }
	  }, {
	    key: 'refilterByDate',
	    value: function refilterByDate(dataByDate, dateDomain) {
	      // eslint-disable-next-line lodash/prefer-lodash-method
	      dataByDate.filter(dateDomain);
	    }
	  }, {
	    key: 'refilterByDayOfWeek',
	    value: function refilterByDayOfWeek(dataByDayOfWeek, activeDays) {
	      dataByDayOfWeek.filterFunction(this.filterActiveDaysFn(activeDays));
	    }
	  }, {
	    key: 'initialFiltering',
	    value: function initialFiltering(dataByDate, dataByDayOfWeek, dateDomain) {
	      var activeDays = this.props.activeDays;
	      // clear old filters
	
	      dataByDayOfWeek.filterAll();
	
	      // filter by day of week (Monday, Tuesday, etc.)
	      dataByDayOfWeek.filterFunction(this.filterActiveDaysFn(activeDays));
	
	      // filter within date domain
	      // eslint-disable-next-line lodash/prefer-lodash-method
	      dataByDate.filter(dateDomain);
	    }
	  }, {
	    key: 'filterActiveDaysFn',
	    value: function filterActiveDaysFn(activeDays) {
	      return function (d) {
	        return activeDays[d];
	      };
	    }
	  }, {
	    key: 'determineDataToShow',
	    value: function determineDataToShow() {
	      var _props3 = this.props,
	          currentPatientInViewId = _props3.currentPatientInViewId,
	          touched = _props3.trendsState.touched;
	
	      if (touched) {
	        return;
	      }
	      var currentCbgData = this.state.currentCbgData;
	      var _props4 = this.props,
	          extentSize = _props4.extentSize,
	          showingCbg = _props4.showingCbg;
	
	      var minimumCbgs = extentSize * _constants.CGM_READINGS_ONE_DAY / 2;
	      if (showingCbg && (0, _bloodglucose.weightedCGMCount)(currentCbgData) < minimumCbgs) {
	        this.props.onSwitchBgDataSource();
	      }
	      this.props.markTrendsViewed(currentPatientInViewId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dateDomain = this.state.dateDomain,
	          currentStart = _state$dateDomain.start,
	          currentEnd = _state$dateDomain.end;
	
	      var prevStart = _lodash2.default.get(this.state, ['previousDateDomain', 'start']);
	      var prevEnd = _lodash2.default.get(this.state, ['previousDateDomain', 'end']);
	      var start = currentStart;
	      var end = currentEnd;
	      if (prevStart && prevEnd) {
	        if (currentStart < prevStart) {
	          end = prevEnd;
	        } else if (prevStart < currentStart) {
	          start = prevStart;
	        }
	      }
	      return _react2.default.createElement(_TrendsSVGContainer2.default, {
	        activeDays: this.props.activeDays,
	        bgPrefs: this.props.bgPrefs,
	        smbgData: this.state.currentSmbgData,
	        cbgData: this.state.currentCbgData,
	        dates: getAllDatesInRange(start, end, this.props.timePrefs),
	        focusedSlice: this.props.trendsState.focusedCbgSlice,
	        focusedSliceKeys: this.props.trendsState.focusedCbgSliceKeys,
	        focusedSmbgRangeAvgKey: _lodash2.default.get(this.props, ['trendsState', 'focusedSmbgRangeAvg', 'data', 'id'], null),
	        focusedSmbg: this.props.trendsState.focusedSmbg,
	        displayFlags: this.props.trendsState.cbgFlags,
	        showingCbg: this.props.showingCbg,
	        showingCbgDateTraces: _lodash2.default.get(this.props, ['trendsState', 'showingCbgDateTraces'], false),
	        showingSmbg: this.props.showingSmbg,
	        smbgGrouped: this.props.smbgGrouped,
	        smbgLines: this.props.smbgLines,
	        smbgRangeOverlay: this.props.smbgRangeOverlay,
	        onSelectDate: this.selectDate(),
	        xScale: this.state.xScale,
	        yScale: this.state.yScale
	      });
	    }
	  }]);
	
	  return TrendsContainer;
	}(_react.PureComponent);
	
	TrendsContainer.propTypes = {
	  activeDays: _react.PropTypes.shape({
	    monday: _react.PropTypes.bool.isRequired,
	    tuesday: _react.PropTypes.bool.isRequired,
	    wednesday: _react.PropTypes.bool.isRequired,
	    thursday: _react.PropTypes.bool.isRequired,
	    friday: _react.PropTypes.bool.isRequired,
	    saturday: _react.PropTypes.bool.isRequired,
	    sunday: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  bgPrefs: _react.PropTypes.shape({
	    bgBounds: _react.PropTypes.shape({
	      veryHighThreshold: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired,
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      veryLowThreshold: _react.PropTypes.number.isRequired
	    }).isRequired,
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  currentPatientInViewId: _react.PropTypes.string.isRequired,
	  extentSize: _react.PropTypes.oneOf([ONE_WEEK, TWO_WEEKS, FOUR_WEEKS]).isRequired,
	  initialDatetimeLocation: _react.PropTypes.string,
	  loading: _react.PropTypes.bool.isRequired,
	  showingSmbg: _react.PropTypes.bool.isRequired,
	  showingCbg: _react.PropTypes.bool.isRequired,
	  smbgRangeOverlay: _react.PropTypes.bool.isRequired,
	  smbgGrouped: _react.PropTypes.bool.isRequired,
	  smbgLines: _react.PropTypes.bool.isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, null])
	  }).isRequired,
	  yScaleClampTop: _react.PropTypes.shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, _constants.MGDL_UNITS, _react.PropTypes.number.isRequired), _defineProperty(_PropTypes$shape, _constants.MMOLL_UNITS, _react.PropTypes.number.isRequired), _PropTypes$shape)).isRequired,
	  // data (crossfilter dimensions)
	  cbgByDate: _react.PropTypes.object.isRequired,
	  cbgByDayOfWeek: _react.PropTypes.object.isRequired,
	  smbgByDate: _react.PropTypes.object.isRequired,
	  smbgByDayOfWeek: _react.PropTypes.object.isRequired,
	  // handlers
	  markTrendsViewed: _react.PropTypes.func.isRequired,
	  onDatetimeLocationChange: _react.PropTypes.func.isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  onSwitchBgDataSource: _react.PropTypes.func.isRequired,
	  // viz state
	  trendsState: _react.PropTypes.shape({
	    cbgFlags: _react.PropTypes.shape({
	      cbg100Enabled: _react.PropTypes.bool.isRequired,
	      cbg80Enabled: _react.PropTypes.bool.isRequired,
	      cbg50Enabled: _react.PropTypes.bool.isRequired,
	      cbgMedianEnabled: _react.PropTypes.bool.isRequired
	    }).isRequired,
	    focusedCbgSlice: _react.PropTypes.shape({
	      data: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        id: _react.PropTypes.string.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        msFrom: _react.PropTypes.number.isRequired,
	        msTo: _react.PropTypes.number.isRequired,
	        msX: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired
	      }),
	      position: _react.PropTypes.shape({
	        left: _react.PropTypes.number.isRequired,
	        tooltipLeft: _react.PropTypes.bool.isRequired,
	        topOptions: _react.PropTypes.shape({
	          firstQuartile: _react.PropTypes.number.isRequired,
	          max: _react.PropTypes.number.isRequired,
	          median: _react.PropTypes.number.isRequired,
	          min: _react.PropTypes.number.isRequired,
	          ninetiethQuantile: _react.PropTypes.number.isRequired,
	          tenthQuantile: _react.PropTypes.number.isRequired,
	          thirdQuartile: _react.PropTypes.number.isRequired
	        })
	      })
	    }),
	    focusedCbgSliceKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	    focusedSmbg: _react.PropTypes.shape({
	      allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        top: _react.PropTypes.number.isRequired,
	        left: _react.PropTypes.number.isRequired
	      })),
	      allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        value: _react.PropTypes.number.isRequired
	      })),
	      date: _react.PropTypes.string.isRequired,
	      datum: _react.PropTypes.shape({
	        value: _react.PropTypes.number.isRequired
	      }),
	      position: _react.PropTypes.shape({
	        top: _react.PropTypes.number.isRequired,
	        left: _react.PropTypes.number.isRequired
	      })
	    }),
	    focusedSmbgRangeAvg: _react.PropTypes.shape({
	      data: _react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        mean: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        msX: _react.PropTypes.number.isRequired,
	        msFrom: _react.PropTypes.number.isRequired,
	        msTo: _react.PropTypes.number.isRequired
	      }).isRequired,
	      position: _react.PropTypes.shape({
	        left: _react.PropTypes.number.isRequired,
	        tooltipLeft: _react.PropTypes.bool.isRequired,
	        yPositions: _react.PropTypes.shape({
	          max: _react.PropTypes.number.isRequired,
	          mean: _react.PropTypes.number.isRequired,
	          min: _react.PropTypes.number.isRequired
	        }).isRequired
	      }).isRequired
	    }),
	    touched: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  unfocusCbgSlice: _react.PropTypes.func.isRequired,
	  unfocusSmbg: _react.PropTypes.func.isRequired,
	  unfocusSmbgRangeAvg: _react.PropTypes.func.isRequired
	};
	TrendsContainer.defaultProps = {
	  yScaleClampTop: (_yScaleClampTop = {}, _defineProperty(_yScaleClampTop, _constants.MGDL_UNITS, _constants.MGDL_CLAMP_TOP), _defineProperty(_yScaleClampTop, _constants.MMOLL_UNITS, _constants.MMOLL_CLAMP_TOP), _yScaleClampTop)
	};
	function mapStateToProps(state, ownProps) {
	  var userId = _lodash2.default.get(ownProps, 'currentPatientInViewId');
	  return {
	    trendsState: _lodash2.default.get(state, ['viz', 'trends', userId], {})
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    markTrendsViewed: actions.markTrendsViewed,
	    unfocusCbgSlice: actions.unfocusTrendsCbgSlice,
	    unfocusSmbg: actions.unfocusTrendsSmbg,
	    unfocusSmbgRangeAvg: actions.unfocusTrendsSmbgRangeAvg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, function (stateProps, dispatchProps, ownProps) {
	  return _lodash2.default.assign({}, ownProps, stateProps, dispatchProps);
	}, { withRef: true })(TrendsContainer);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ONE_WEEK, 'ONE_WEEK', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(TWO_WEEKS, 'TWO_WEEKS', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(FOUR_WEEKS, 'FOUR_WEEKS', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(getAllDatesInRange, 'getAllDatesInRange', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(getLocalizedNoonBeforeUTC, 'getLocalizedNoonBeforeUTC', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(getLocalizedOffset, 'getLocalizedOffset', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(TrendsContainer, 'TrendsContainer', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	})();

	;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {(function() {
	  function checkColorSupport() {
	    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
	      return false;
	    }
	
	    var chrome = !!window.chrome,
	        firefox = /firefox/i.test(navigator.userAgent),
	        firefoxVersion,
	        electron = process && process.versions && process.versions.electron;
	
	    if (firefox) {
	        var match = navigator.userAgent.match(/Firefox\/(\d+\.\d+)/);
	        if (match && match[1] && Number(match[1])) {
	            firefoxVersion = Number(match[1]);
	        }
	    }
	    return chrome || firefoxVersion >= 31.0 || electron;
	  }
	
	  var yieldColor = function() {
	    var goldenRatio = 0.618033988749895;
	    hue += goldenRatio;
	    hue = hue % 1;
	    return hue * 360;
	  };
	
	  var inNode = typeof window === 'undefined',
	      ls = !inNode && window.localStorage,
	      debugKey = ls.andlogKey || 'debug',
	      debug = ls[debugKey],
	      logger = __webpack_require__(104),
	      bind = Function.prototype.bind,
	      hue = 0,
	      padLength = 15,
	      noop = function() {},
	      // if ls.debugColors is set, use that, otherwise check for support
	      colorsSupported = ls.debugColors ? (ls.debugColors !== "false") : checkColorSupport(),
	      bows = null,
	      debugRegex = null,
	      invertRegex = false,
	      moduleColorsMap = {};
	
	  if (debug && debug[0] === '!' && debug[1] === '/') {
	    invertRegex = true;
	    debug = debug.slice(1);
	  }
	  debugRegex = debug && debug[0]==='/' && new RegExp(debug.substring(1,debug.length-1));
	
	  var logLevels = ['log', 'debug', 'warn', 'error', 'info'];
	
	  //Noop should noop
	  for (var i = 0, ii = logLevels.length; i < ii; i++) {
	      noop[ logLevels[i] ] = noop;
	  }
	
	  bows = function(str) {
	    var msg, colorString, logfn;
	    msg = (str.slice(0, padLength));
	    msg += Array(padLength + 3 - msg.length).join(' ') + '|';
	
	    if (debugRegex) {
	        var matches = str.match(debugRegex);
	        if (
	            (!invertRegex && !matches) ||
	            (invertRegex && matches)
	        ) return noop;
	    }
	
	    if (!bind) return noop;
	
	    var logArgs = [logger];
	    if (colorsSupported) {
	      if(!moduleColorsMap[str]){
	        moduleColorsMap[str]= yieldColor();
	      }
	      var color = moduleColorsMap[str];
	      msg = "%c" + msg;
	      colorString = "color: hsl(" + (color) + ",99%,40%); font-weight: bold";
	
	      logArgs.push(msg, colorString);
	    }else{
	      logArgs.push(msg);
	    }
	
	    if(arguments.length>1){
	        var args = Array.prototype.slice.call(arguments, 1);
	        logArgs = logArgs.concat(args);
	    }
	
	    logfn = bind.apply(logger.log, logArgs);
	
	    logLevels.forEach(function (f) {
	      logfn[f] = bind.apply(logger[f] || logfn, logArgs);
	    });
	    return logfn;
	  };
	
	  bows.config = function(config) {
	    if (config.padLength) {
	      padLength = config.padLength;
	    }
	  };
	
	  if (true) {
	    module.exports = bows;
	  } else {
	    window.bows = bows;
	  }
	}).call();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// follow @HenrikJoreteg and @andyet if you like this ;)
	(function () {
	    var inNode = typeof window === 'undefined',
	        ls = !inNode && window.localStorage,
	        out = {};
	
	    if (inNode) {
	        module.exports = console;
	        return;
	    }
	
	    var andlogKey = ls.andlogKey || 'debug'
	    if (ls && ls[andlogKey] && window.console) {
	        out = window.console;
	    } else {
	        var methods = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),
	            l = methods.length,
	            fn = function () {};
	
	        while (l--) {
	            out[methods[l]] = fn;
	        }
	    }
	    if (true) {
	        module.exports = out;
	    } else {
	        window.console = out;
	    }
	})();


/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = require("d3-array");

/***/ },
/* 106 */
/***/ function(module, exports) {

	module.exports = require("d3-scale");

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TrendsSVGContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDimensions = __webpack_require__(108);
	
	var _reactDimensions2 = _interopRequireDefault(_reactDimensions);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(18);
	
	var _datetime = __webpack_require__(22);
	
	var _data = __webpack_require__(109);
	
	var _Background = __webpack_require__(110);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _CBGDateTracesAnimationContainer = __webpack_require__(113);
	
	var _CBGDateTracesAnimationContainer2 = _interopRequireDefault(_CBGDateTracesAnimationContainer);
	
	var _CBGSlicesContainer = __webpack_require__(136);
	
	var _CBGSlicesContainer2 = _interopRequireDefault(_CBGSlicesContainer);
	
	var _FocusedCBGSliceSegment = __webpack_require__(146);
	
	var _FocusedCBGSliceSegment2 = _interopRequireDefault(_FocusedCBGSliceSegment);
	
	var _SMBGsByDateContainer = __webpack_require__(149);
	
	var _SMBGsByDateContainer2 = _interopRequireDefault(_SMBGsByDateContainer);
	
	var _SMBGRangeAvgContainer = __webpack_require__(157);
	
	var _SMBGRangeAvgContainer2 = _interopRequireDefault(_SMBGRangeAvgContainer);
	
	var _SMBGRangeAnimated = __webpack_require__(158);
	
	var _SMBGRangeAnimated2 = _interopRequireDefault(_SMBGRangeAnimated);
	
	var _SMBGMeanAnimated = __webpack_require__(162);
	
	var _SMBGMeanAnimated2 = _interopRequireDefault(_SMBGMeanAnimated);
	
	var _NoData = __webpack_require__(166);
	
	var _NoData2 = _interopRequireDefault(_NoData);
	
	var _TargetRangeLines = __webpack_require__(169);
	
	var _TargetRangeLines2 = _interopRequireDefault(_TargetRangeLines);
	
	var _XAxisLabels = __webpack_require__(172);
	
	var _XAxisLabels2 = _interopRequireDefault(_XAxisLabels);
	
	var _XAxisTicks = __webpack_require__(175);
	
	var _XAxisTicks2 = _interopRequireDefault(_XAxisTicks);
	
	var _YAxisLabelsAndTicks = __webpack_require__(178);
	
	var _YAxisLabelsAndTicks2 = _interopRequireDefault(_YAxisLabelsAndTicks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	/*
	 * TODO: DISCUSS
	 * Is this how we want to approach defaults/constants in the Reactified viz components?
	 * Here, the approach is to use global constants. Then, the options that are required
	 * in child components as well are assigned to default props, but those that are only used
	 * in this parent/container component are just used directly as constants.
	 */
	var BUMPERS = {
	  top: 50,
	  bottom: 30
	};
	
	var MARGINS = {
	  top: 30,
	  right: 10,
	  bottom: 10,
	  left: 40
	};
	
	var SMBG_OPTS = {
	  maxR: 7.5,
	  r: 6
	};
	
	var TrendsSVGContainer = exports.TrendsSVGContainer = function (_PureComponent) {
	  _inherits(TrendsSVGContainer, _PureComponent);
	
	  function TrendsSVGContainer(props) {
	    _classCallCheck(this, TrendsSVGContainer);
	
	    var _this = _possibleConstructorReturn(this, (TrendsSVGContainer.__proto__ || Object.getPrototypeOf(TrendsSVGContainer)).call(this, props));
	
	    _this.state = {
	      focusedSegmentDataGroupedByDate: null
	    };
	    return _this;
	  }
	
	  _createClass(TrendsSVGContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setScales();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.yScale !== this.props.yScale) {
	        this.setScales(nextProps);
	      }
	
	      var showingCbgDateTraces = nextProps.showingCbgDateTraces;
	
	      if (!showingCbgDateTraces) {
	        // if we just flipped the showingCbgDateTraces flag from true to false
	        // then we need to reset the focusedSegmentDataGroupedByDate to `null`
	        if (this.props.showingCbgDateTraces) {
	          this.setState({
	            focusedSegmentDataGroupedByDate: null
	          });
	        }
	        return;
	      }
	      var cbgData = nextProps.cbgData,
	          focusedSlice = nextProps.focusedSlice,
	          focusedSliceKeys = nextProps.focusedSliceKeys;
	
	      if (focusedSlice) {
	        var intersectingDates = (0, _data.findDatesIntersectingWithCbgSliceSegment)(cbgData, focusedSlice, focusedSliceKeys);
	        var focusedSegmentDataGroupedByDate = _lodash2.default.groupBy(_lodash2.default.filter(cbgData, function (d) {
	          return _lodash2.default.includes(intersectingDates, d.localDate);
	        }), function (d) {
	          return d.localDate;
	        });
	        this.setState({
	          focusedSegmentDataGroupedByDate: focusedSegmentDataGroupedByDate
	        });
	      } else {
	        // only reset focusedSegmentDataGroupedByDate to null if previous props had a focused slice
	        // but nextProps do not! (i.e., you've just rolled off a segment and not onto another one)
	        if (this.props.focusedSlice) {
	          this.setState({
	            focusedSegmentDataGroupedByDate: null
	          });
	        }
	      }
	    }
	  }, {
	    key: 'setScales',
	    value: function setScales() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var height = props.containerHeight,
	          width = props.containerWidth;
	      var margins = props.margins,
	          smbgOpts = props.smbgOpts,
	          xScale = props.xScale,
	          yScale = props.yScale;
	
	      xScale.range([margins.left + Math.round(smbgOpts.maxR), width - margins.right - Math.round(smbgOpts.maxR)]);
	      yScale.range([height - margins.bottom - BUMPERS.bottom, margins.top + BUMPERS.top]);
	    }
	  }, {
	    key: 'renderNoDataMessage',
	    value: function renderNoDataMessage(dataType) {
	      var _props = this.props,
	          activeDays = _props.activeDays,
	          height = _props.containerHeight,
	          width = _props.containerWidth,
	          margins = _props.margins;
	
	      var xPos = width / 2 + margins.right;
	      var yPos = height / 2 + margins.bottom;
	      var messagePosition = { x: xPos, y: yPos };
	      var unselectedAll = _lodash2.default.every(activeDays, function (flag) {
	        return !flag;
	      });
	      if (this.props.showingCbg && _lodash2.default.isEmpty(this.props.cbgData) || this.props.showingSmbg && _lodash2.default.isEmpty(this.props.smbgData)) {
	        return _react2.default.createElement(_NoData2.default, {
	          dataType: dataType,
	          position: messagePosition,
	          unselectedAllData: unselectedAll
	        });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay(smbgComponent, componentKey) {
	      var data = this.props.smbgRangeOverlay ? this.props.smbgData : [];
	      return _react2.default.createElement(_SMBGRangeAvgContainer2.default, {
	        bgBounds: this.props.bgPrefs.bgBounds,
	        data: data,
	        key: componentKey,
	        smbgComponent: smbgComponent,
	        someSmbgDataIsFocused: this.props.focusedSmbg !== null,
	        tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	        xScale: this.props.xScale,
	        yScale: this.props.yScale
	      });
	    }
	  }, {
	    key: 'renderCbg',
	    value: function renderCbg() {
	      if (this.props.showingCbg) {
	        var slices = _react2.default.createElement(_CBGSlicesContainer2.default, {
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: this.props.cbgData,
	          displayFlags: this.props.displayFlags,
	          showingCbgDateTraces: this.props.showingCbgDateTraces,
	          tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	          topMargin: this.props.margins.top,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        });
	
	        var focusedSegmentDataGroupedByDate = this.state.focusedSegmentDataGroupedByDate;
	
	        var dateTraces = _react2.default.createElement(_CBGDateTracesAnimationContainer2.default, {
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: focusedSegmentDataGroupedByDate,
	          dates: _lodash2.default.keys(focusedSegmentDataGroupedByDate) || [],
	          onSelectDate: this.props.onSelectDate,
	          topMargin: this.props.margins.top,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        });
	
	        var focused = null;
	        var _props2 = this.props,
	            focusedSlice = _props2.focusedSlice,
	            focusedSliceKeys = _props2.focusedSliceKeys;
	
	        if (!_lodash2.default.isEmpty(focusedSlice) && !_lodash2.default.isEmpty(focusedSliceKeys)) {
	          focused = _react2.default.createElement(_FocusedCBGSliceSegment2.default, {
	            focusedSlice: focusedSlice,
	            focusedSliceKeys: focusedSliceKeys
	          });
	        }
	
	        return _react2.default.createElement(
	          'g',
	          { id: 'cbgTrends' },
	          slices,
	          dateTraces,
	          focused
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderSmbg',
	    value: function renderSmbg() {
	      if (this.props.showingSmbg) {
	        var allSmbgsByDate = _react2.default.createElement(_SMBGsByDateContainer2.default, {
	          anSmbgRangeAvgIsFocused: this.props.focusedSmbgRangeAvgKey !== null,
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: this.props.smbgData,
	          dates: this.props.dates,
	          grouped: this.props.smbgGrouped,
	          key: 'smbgDaysContainer',
	          lines: this.props.smbgLines,
	          onSelectDate: this.props.onSelectDate,
	          smbgOpts: this.props.smbgOpts,
	          someSmbgDataIsFocused: this.props.focusedSmbg !== null,
	          tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        });
	        // Focused date will be rendered last, on top of everything else but flagged
	        // as nonInteractive to allow mouse events to be handled exclusively by normally
	        // rendered points and lines
	        var focusedSmbgDate = this.props.focusedSmbg ? _react2.default.createElement(_SMBGsByDateContainer2.default, {
	          anSmbgRangeAvgIsFocused: false,
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: this.props.focusedSmbg.allSmbgsOnDate,
	          dates: [this.props.focusedSmbg.date],
	          focusedSmbg: this.props.focusedSmbg,
	          grouped: this.props.smbgGrouped,
	          key: 'focusedSmbgDayContainer',
	          lines: this.props.smbgLines,
	          nonInteractive: true,
	          onSelectDate: this.props.onSelectDate,
	          smbgOpts: this.props.smbgOpts,
	          someSmbgDataIsFocused: false,
	          tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        }) : null;
	
	        return _react2.default.createElement(
	          'g',
	          { id: 'smbgTrends' },
	          this.renderOverlay(_SMBGRangeAnimated2.default, 'SMBGRangeContainer'),
	          allSmbgsByDate,
	          this.renderOverlay(_SMBGMeanAnimated2.default, 'SMBGMeanContainer'),
	          focusedSmbgDate
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          height = _props3.containerHeight,
	          width = _props3.containerWidth;
	
	      return _react2.default.createElement(
	        'svg',
	        { height: height, width: width },
	        _react2.default.createElement(_Background2.default, {
	          linesAtThreeHrs: true,
	          margins: this.props.margins,
	          smbgOpts: this.props.smbgOpts,
	          svgDimensions: { height: height, width: width },
	          xScale: this.props.xScale
	        }),
	        _react2.default.createElement(_XAxisLabels2.default, {
	          margins: this.props.margins,
	          useRangeLabels: false,
	          xScale: this.props.xScale
	        }),
	        _react2.default.createElement(_XAxisTicks2.default, {
	          margins: this.props.margins,
	          xScale: this.props.xScale
	        }),
	        _react2.default.createElement(_YAxisLabelsAndTicks2.default, {
	          bgPrefs: this.props.bgPrefs,
	          bgUnits: this.props.bgUnits,
	          margins: this.props.margins,
	          yScale: this.props.yScale
	        }),
	        this.renderCbg(),
	        this.renderSmbg(),
	        _react2.default.createElement(_TargetRangeLines2.default, {
	          bgBounds: this.props.bgPrefs.bgBounds,
	          smbgOpts: this.props.smbgOpts,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        }),
	        this.renderNoDataMessage(this.props.showingCbg ? 'cbg' : 'smbg')
	      );
	    }
	  }]);
	
	  return TrendsSVGContainer;
	}(_react.PureComponent);
	
	TrendsSVGContainer.defaultProps = {
	  margins: MARGINS,
	  smbgOpts: SMBG_OPTS,
	  // for time values after 6 p.m. (1800), float the tooltips left instead of right
	  tooltipLeftThreshold: 6 * _datetime.THREE_HRS
	};
	
	TrendsSVGContainer.propTypes = {
	  activeDays: _react.PropTypes.shape({
	    monday: _react.PropTypes.bool.isRequired,
	    tuesday: _react.PropTypes.bool.isRequired,
	    wednesday: _react.PropTypes.bool.isRequired,
	    thursday: _react.PropTypes.bool.isRequired,
	    friday: _react.PropTypes.bool.isRequired,
	    saturday: _react.PropTypes.bool.isRequired,
	    sunday: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  bgPrefs: _react.PropTypes.shape({
	    bgBounds: _react.PropTypes.shape({
	      veryHighThreshold: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired,
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      veryLowThreshold: _react.PropTypes.number.isRequired
	    }).isRequired,
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  containerHeight: _react.PropTypes.number.isRequired,
	  containerWidth: _react.PropTypes.number.isRequired,
	  smbgData: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    localDate: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  cbgData: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    localDate: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  dates: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  focusedSlice: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  focusedSliceKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	  focusedSmbg: _react.PropTypes.shape({
	    allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })),
	    allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    })),
	    date: _react.PropTypes.string.isRequired,
	    datum: _react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })
	  }),
	  focusedSmbgRangeAvgKey: _react.PropTypes.string,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  showingCbg: _react.PropTypes.bool.isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  showingSmbg: _react.PropTypes.bool.isRequired,
	  smbgGrouped: _react.PropTypes.bool.isRequired,
	  smbgLines: _react.PropTypes.bool.isRequired,
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  smbgRangeOverlay: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _reactDimensions2.default)()(TrendsSVGContainer);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BUMPERS, 'BUMPERS', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(MARGINS, 'MARGINS', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(SMBG_OPTS, 'SMBG_OPTS', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(TrendsSVGContainer, 'TrendsSVGContainer', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	})();

	;

/***/ },
/* 108 */
/***/ function(module, exports) {

	module.exports = require("react-dimensions");

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.determineRangeBoundaries = determineRangeBoundaries;
	exports.findBinForTimeOfDay = findBinForTimeOfDay;
	exports.findDatesIntersectingWithCbgSliceSegment = findDatesIntersectingWithCbgSliceSegment;
	exports.findOutOfRangeAnnotations = findOutOfRangeAnnotations;
	exports.calculateCbgStatsForBin = calculateCbgStatsForBin;
	exports.calculateSmbgStatsForBin = calculateSmbgStatsForBin;
	exports.categorizeSmbgSubtype = categorizeSmbgSubtype;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(105);
	
	var _datetime = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * determineRangeBoundaries
	 * @param {Array} outOfRange - Array of out-of-range objects w/threshold and value
	 *
	 * @return {Object} highAndLowThresholds - Object with high and low keys
	 */
	function determineRangeBoundaries(outOfRange) {
	  var lowThresholds = _lodash2.default.filter(outOfRange, { value: 'low' });
	  var highThresholds = _lodash2.default.filter(outOfRange, { value: 'high' });
	  var boundaries = {};
	  if (!_lodash2.default.isEmpty(lowThresholds)) {
	    // if there is data from multiple devices present with different thresholds
	    // we want to use the more conservative (= higher) threshold for lows
	    boundaries.low = (0, _d3Array.max)(lowThresholds, function (d) {
	      return d.threshold;
	    });
	  }
	  if (!_lodash2.default.isEmpty(highThresholds)) {
	    // if there is data from multiple devices present with different thresholds
	    // we want to use the more conservative (= lower) threshold for highs
	    boundaries.high = (0, _d3Array.min)(highThresholds, function (d) {
	      return d.threshold;
	    });
	  }
	  return boundaries;
	}
	
	/**
	 * findBinForTimeOfDay
	 * @param {Number} binSize - natural number duration in milliseconds
	 * @param {Number} msPer24 - natural number milliseconds into a twenty-four hour day
	 *
	 * @return {Number} bin
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function findBinForTimeOfDay(binSize, msPer24) {
	  if (msPer24 < 0 || msPer24 >= _datetime.TWENTY_FOUR_HRS) {
	    throw new Error('`msPer24` < 0 or >= 86400000 is invalid!');
	  }
	
	  return Math.floor(msPer24 / binSize) * binSize + binSize / 2;
	}
	/**
	 * findDatesIntersectingWithCbgSliceSegment
	 * @param {Array} cbgData - Array of Tidepool cbg events
	 * @param {Object} focusedSlice - the current focused cbg slice/segment
	 * @param {Array} focusedSliceKeys - Array of 2 keys representing
	 *                                   the top & bottom of focused slice segment
	 *
	 * @return {Array} dates - Array of String dates in YYYY-MM-DD format
	 */
	function findDatesIntersectingWithCbgSliceSegment(cbgData, focusedSlice, focusedSliceKeys) {
	  var data = focusedSlice.data;
	
	  return _lodash2.default.uniq(_lodash2.default.pluck(_lodash2.default.filter(cbgData, function (d) {
	    if (d.msPer24 >= data.msFrom && d.msPer24 < data.msTo) {
	      return d.value >= data[focusedSliceKeys[0]] && d.value <= data[focusedSliceKeys[1]];
	    }
	    return false;
	  }), 'localDate')).sort();
	}
	
	/**
	 * findOutOfRangeAnnotations
	 * @param {Array} data - Array of `cbg` or `smbg` events
	 *
	 * @return {Array} thresholds - Array of objects with unique `threshold`
	 *                              (and `value` of 'low' or 'high')
	 */
	function findOutOfRangeAnnotations(data) {
	  var isOutOfRangeAnnotation = function isOutOfRangeAnnotation(annotation) {
	    return annotation.code === 'bg/out-of-range';
	  };
	  var eventsAnnotatedAsOutOfRange = _lodash2.default.filter(data, function (d) {
	    return _lodash2.default.some(d.annotations || [], isOutOfRangeAnnotation);
	  });
	  var annotations = _lodash2.default.map(eventsAnnotatedAsOutOfRange, function (d) {
	    return _lodash2.default.pick(_lodash2.default.find(d.annotations || [], isOutOfRangeAnnotation), ['threshold', 'value']);
	  });
	  // the numerical `threshold` is our determiner of uniqueness
	  return _lodash2.default.uniq(annotations, function (d) {
	    return d.threshold;
	  });
	}
	
	/**
	 * calculateCbgStatsForBin
	 * @param {String} binKey - String of natural number milliseconds bin
	 * @param {Number} binSize - natural number duration in milliseconds
	 * @param {Array} data - Array of cbg values in mg/dL or mmol/L
	 * @param {Array} outOfRange - Array of out-of-range objects w/threshold and value
	 *
	 * @return {Object} calculatedCbgStats
	 */
	function calculateCbgStatsForBin(binKey, binSize, data, outOfRange) {
	  var sorted = _lodash2.default.sortBy(data, function (d) {
	    return d;
	  });
	  var centerOfBinMs = parseInt(binKey, 10);
	  var stats = {
	    id: binKey,
	    min: (0, _d3Array.min)(sorted),
	    tenthQuantile: (0, _d3Array.quantile)(sorted, 0.1),
	    firstQuartile: (0, _d3Array.quantile)(sorted, 0.25),
	    median: (0, _d3Array.median)(sorted),
	    thirdQuartile: (0, _d3Array.quantile)(sorted, 0.75),
	    ninetiethQuantile: (0, _d3Array.quantile)(sorted, 0.9),
	    max: (0, _d3Array.max)(sorted),
	    msX: centerOfBinMs,
	    msFrom: centerOfBinMs - binSize / 2,
	    msTo: centerOfBinMs + binSize / 2
	  };
	  if (!_lodash2.default.isEmpty(outOfRange)) {
	    var thresholds = determineRangeBoundaries(outOfRange);
	    stats.outOfRangeThresholds = thresholds;
	  }
	  return stats;
	}
	
	/**
	 * calculateSmbgStatsForBin
	 * @param {String} binKey - String of natural number milliseconds bin
	 * @param {Number} binSize - natural number duration in milliseconds
	 * @param {Array} data - Array of smbg values in mg/dL or mmol/L
	 * @param {Array} outOfRange - Array of out-of-range objects w/threshold and value
	 *
	 * @return {Object} calculatedSmbgStats
	 */
	function calculateSmbgStatsForBin(binKey, binSize, data, outOfRange) {
	  var centerOfBinMs = parseInt(binKey, 10);
	  var stats = {
	    id: binKey,
	    min: (0, _d3Array.min)(data),
	    mean: (0, _d3Array.mean)(data),
	    max: (0, _d3Array.max)(data),
	    msX: centerOfBinMs,
	    msFrom: centerOfBinMs - binSize / 2,
	    msTo: centerOfBinMs + binSize / 2
	  };
	  if (!_lodash2.default.isEmpty(outOfRange)) {
	    var thresholds = determineRangeBoundaries(outOfRange);
	    stats.outOfRangeThresholds = thresholds;
	  }
	  return stats;
	}
	
	/**
	 * Returns a category based on SMBG subType
	 * @param  {Object} data smbg
	 * @return {String}      category name for subType
	 */
	function categorizeSmbgSubtype(data) {
	  var category = void 0;
	  if (data.subType && data.subType === 'manual') {
	    category = data.subType;
	  } else {
	    category = 'meter';
	  }
	  return category;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(determineRangeBoundaries, 'determineRangeBoundaries', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(findBinForTimeOfDay, 'findBinForTimeOfDay', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(findDatesIntersectingWithCbgSliceSegment, 'findDatesIntersectingWithCbgSliceSegment', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(findOutOfRangeAnnotations, 'findOutOfRangeAnnotations', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(calculateCbgStatsForBin, 'calculateCbgStatsForBin', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(calculateSmbgStatsForBin, 'calculateSmbgStatsForBin', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(categorizeSmbgSubtype, 'categorizeSmbgSubtype', '/Users/krystophv/tidepool/viz/src/utils/trends/data.js');
	})();

	;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(105);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datetime = __webpack_require__(22);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _Background = __webpack_require__(111);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Background = function Background(props) {
	  var data = props.data,
	      margins = props.margins,
	      svgDimensions = props.svgDimensions,
	      xScale = props.xScale;
	
	
	  var width = svgDimensions.width - margins.left - margins.right;
	  var height = svgDimensions.height - margins.top - margins.bottom;
	
	  var lines = props.linesAtThreeHrs ? _lodash2.default.map(data, function (val, i) {
	    return _react2.default.createElement('line', {
	      className: _Background2.default.threeHrLine,
	      key: 'threeHrLine-' + i,
	      x1: xScale(val),
	      x2: xScale(val),
	      y1: margins.top,
	      y2: svgDimensions.height - margins.bottom
	    });
	  }) : null;
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'background' },
	    _react2.default.createElement('rect', {
	      className: _Background2.default.background,
	      x: margins.left,
	      y: margins.top,
	      width: width,
	      height: height
	    }),
	    lines
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	Background.defaultProps = {
	  data: _lodash2.default.map((0, _d3Array.range)(1, 8), function (i) {
	    return i * datetime.THREE_HRS;
	  }),
	  linesAtThreeHrs: false
	};
	
	Background.propTypes = {
	  data: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired,
	  linesAtThreeHrs: _react.PropTypes.bool.isRequired,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  svgDimensions: _react.PropTypes.shape({
	    width: _react.PropTypes.number.isRequired,
	    height: _react.PropTypes.number.isRequired
	  }).isRequired,
	  xScale: _react.PropTypes.func.isRequired
	};
	
	var _default = Background;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Background, 'Background', '/Users/krystophv/tidepool/viz/src/components/trends/common/Background.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/Background.js');
	})();

	;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(112);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Background.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Background.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".Background--background--3QmVr{fill:var(--bkgrnd)}.Background--background--3QmVr,.Background--threeHrLine--3tNeU{stroke:var(--bkgrnd-lines);stroke-width:1px}", ""]);
	
	// exports
	exports.locals = {
		"background": "Background--background--3QmVr",
		"threeHrLine": "Background--threeHrLine--3tNeU"
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroupPlus = __webpack_require__(114);
	
	var _reactTransitionGroupPlus2 = _interopRequireDefault(_reactTransitionGroupPlus);
	
	var _CBGDateTraceAnimated = __webpack_require__(129);
	
	var _CBGDateTraceAnimated2 = _interopRequireDefault(_CBGDateTraceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CBGDateTracesAnimationContainer = function CBGDateTracesAnimationContainer(props) {
	  var bgBounds = props.bgBounds,
	      data = props.data,
	      dates = props.dates,
	      topMargin = props.topMargin,
	      xScale = props.xScale,
	      yScale = props.yScale;
	
	  return _react2.default.createElement(
	    _reactTransitionGroupPlus2.default,
	    { component: 'g', id: 'cbgDateTraces', transitionMode: 'simultaneous' },
	    _lodash2.default.map(dates, function (localDate) {
	      return _react2.default.createElement(_CBGDateTraceAnimated2.default, {
	        bgBounds: bgBounds,
	        data: data[localDate],
	        date: localDate,
	        key: localDate,
	        onSelectDate: props.onSelectDate,
	        topMargin: topMargin,
	        xScale: xScale,
	        yScale: yScale
	      });
	    })
	  );
	};
	
	CBGDateTracesAnimationContainer.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.object,
	  dates: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  onSelectDate: _react.PropTypes.func.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = CBGDateTracesAnimationContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGDateTracesAnimationContainer, 'CBGDateTracesAnimationContainer', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTracesAnimationContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTracesAnimationContainer.js');
	})();

	;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(3);
	var difference = __webpack_require__(115);
	var ReactTransitionChildMapping = __webpack_require__(116);
	
	var assign = __webpack_require__(128);
	
	var ReactTransitionGroupPlus = React.createClass({
	  displayName: 'ReactTransitionGroupPlus',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func,
	    transitionMode: React.PropTypes.oneOf(['in-out', 'out-in', 'simultaneous']),
	    deferLeavingComponentRemoval: React.PropTypes.bool,
	  },
	
	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: function (arg) {
	        return arg;
	      },
	      transitionMode: 'simultaneous',
	      deferLeavingComponentRemoval: false,
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children),
	    };
	  },
	
	  componentWillMount: function() {
	    this.currentlyEnteringOrEnteredKeys = {};
	    this.currentlyEnteringKeys = {};
	    this.currentlyEnteringPromises = {};
	    this.currentlyLeavingKeys = {};
	    this.currentlyLeavingPromises = {};
	    this.pendingEnterCallbacks = {};
	    this.pendingLeaveCallbacks = {};
	    this.deferredLeaveRemovalCallbacks = [];
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	    this.cancel = null;
	  },
	
	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      ),
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && ( !hasPrev || this.currentlyLeavingKeys[key])) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext ) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    if (this.props.transitionMode === 'out-in') {
	      this.keysToEnter = difference(this.keysToEnter, this.keysToLeave);
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    var keysToLeave = this.keysToLeave;
	
	    switch (this.props.transitionMode) {
	      case 'out-in':
	        this.keysToLeave = [];
	        if (keysToLeave.length) {
	          keysToLeave.forEach(this.performLeave)
	        } else {
	          this.keysToEnter = [];
	          keysToEnter.forEach(this.performEnter)
	        }
	        break;
	      case 'in-out':
	        this.keysToEnter = [];
	        this.keysToLeave = [];
	
	        if (keysToEnter.length) {
	          Promise.all(keysToEnter.map(this.performEnter))
	            .then(function () {
	              keysToLeave.forEach(this.performLeave)
	            }.bind(this))
	        } else {
	          keysToLeave.forEach(this.performLeave)
	        }
	        break;
	      default:
	        this.keysToEnter = [];
	        this.keysToLeave = [];
	        keysToEnter.forEach(this.performEnter);
	        keysToLeave.forEach(this.performLeave);
	        break;
	    }
	  },
	
	  performAppear: function(key) {
	    this.currentlyEnteringOrEnteredKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function(key) {
	
	    if (this.currentlyEnteringKeys[key]) {
	      return this.currentlyEnteringPromises[key];
	    }
	
	    this.cancelPendingLeave(key);
	
	
	    var component = this.refs[key];
	
	    if (!component) {
	      return Promise.resolve();
	    }
	
	    this.currentlyEnteringOrEnteredKeys[key] = true;
	    this.currentlyEnteringKeys[key] = true;
	
	    var callback = this._handleDoneEntering.bind(this, key);
	    this.pendingEnterCallbacks[key] = callback;
	
	    var enterPromise = new Promise(function (resolve) {
	      if (component.componentWillEnter) {
	        component.componentWillEnter(resolve);
	      } else {
	        resolve();
	      }
	    }).then(callback);
	
	    this.currentlyEnteringPromises[key] = enterPromise;
	
	    return enterPromise;
	  },
	
	  _handleDoneEntering: function(key) {
	    delete this.pendingEnterCallbacks[key];
	    delete this.currentlyEnteringPromises[key];
	    delete this.currentlyEnteringKeys[key];
	
	    this.deferredLeaveRemovalCallbacks.forEach(function(fn) { fn(); });
	    this.deferredLeaveRemovalCallbacks = [];
	
	    var component = this.refs[key];
	    if (component && component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key) && this.currentlyEnteringOrEnteredKeys[key]) {
	      // This was removed before it had fully entered. Remove it.
	
	      if (this.props.transitionMode !== 'in-out') {
	        this.performLeave(key);
	      }
	    }
	  },
	
	  performLeave: function(key) {
	    if (this.currentlyLeavingKeys[key]) {
	      //already leaving, let it finish
	      return this.currentlyLeavingPromises[key];
	    }
	
	    this.cancelPendingEnter(key);
	
	    var component = this.refs[key];
	
	    if (!component) {
	      return Promise.resolve();
	    }
	
	    this.currentlyLeavingKeys[key] = true;
	
	    var callback = this._handleDoneLeaving.bind(this, key);
	    this.pendingLeaveCallbacks[key] = callback;
	
	    var leavePromise = new Promise(function (resolve) {
	      if (component.componentWillLeave) {
	        component.componentWillLeave(resolve);
	      } else {
	        resolve();
	      }
	    })
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      .then(callback);
	
	    this.currentlyLeavingPromises[key] = leavePromise;
	    return leavePromise;
	  },
	
	  _handleDoneLeaving: function(key) {
	    delete this.pendingLeaveCallbacks[key];
	    delete this.currentlyLeavingKeys[key];
	    delete this.currentlyLeavingPromises[key];
	
	    var component = this.refs[key];
	
	    if (component && component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    var updateChildren = function updateChildren () {
	      this.setState(function(state) {
	        var newChildren = assign({}, state.children);
	        delete newChildren[key];
	        return {children: newChildren};
	      });
	    }.bind(this);
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      // but only perform enter if currently animating out, not already animated out
	      if (this.props.transitionMode !== 'in-out') {
	        this.performEnter(key);
	      }
	    } else {
	      delete this.currentlyEnteringOrEnteredKeys[key];
	
	      if (this.props.deferLeavingComponentRemoval && this.props.transitionMode !== 'in-out') {
	        this.deferredLeaveRemovalCallbacks.push(updateChildren);
	        this.forceUpdate();
	      } else {
	        updateChildren();
	      }
	    }
	  },
	
	  cancelPendingLeave: function (key) {
	    if (this.pendingLeaveCallbacks[key]) {
	      this.pendingLeaveCallbacks[key]();
	      delete this.pendingLeaveCallbacks[key];
	    }
	  },
	
	  cancelPendingEnter: function (key) {
	    if (this.pendingEnterCallbacks[key]) {
	      this.pendingEnterCallbacks[key]();
	      delete this.pendingEnterCallbacks[key];
	    }
	  },
	
	  cleanProps: function(props) {
	    delete props.component;
	    delete props.transitionMode;
	    delete props.childFactory;
	    delete props.deferLeavingComponentRemoval;
	    return props;
	  },
	
	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.cleanProps(assign({},this.props)),
	      childrenToRender
	    );
	  },
	});
	
	module.exports = ReactTransitionGroupPlus;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order of result values is determined by the
	 * order they occur in the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = difference;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(117);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(118);
	var traverseAllChildren = __webpack_require__(119);
	var warning = __webpack_require__(125);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(127);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (process.env.NODE_ENV !== 'production') {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = __webpack_require__(127);
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (process.env.NODE_ENV !== 'production') {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactCurrentOwner = __webpack_require__(121);
	var REACT_ELEMENT_TYPE = __webpack_require__(122);
	
	var getIteratorFn = __webpack_require__(123);
	var invariant = __webpack_require__(124);
	var KeyEscapeUtils = __webpack_require__(118);
	var warning = __webpack_require__(125);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(126);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactCurrentOwner = __webpack_require__(121);
	
	var invariant = __webpack_require__(124);
	var warning = __webpack_require__(125);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ },
/* 128 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGDateTraceAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gsap = __webpack_require__(130);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _connectWithTransitionGroup = __webpack_require__(132);
	
	var _connectWithTransitionGroup2 = _interopRequireDefault(_connectWithTransitionGroup);
	
	var _trends = __webpack_require__(50);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _CBGDateTraceAnimated = __webpack_require__(133);
	
	var _CBGDateTraceAnimated2 = _interopRequireDefault(_CBGDateTraceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGDateTraceAnimated = exports.CBGDateTraceAnimated = function (_PureComponent) {
	  _inherits(CBGDateTraceAnimated, _PureComponent);
	
	  function CBGDateTraceAnimated(props) {
	    _classCallCheck(this, CBGDateTraceAnimated);
	
	    var _this = _possibleConstructorReturn(this, (CBGDateTraceAnimated.__proto__ || Object.getPrototypeOf(CBGDateTraceAnimated)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGDateTraceAnimated, [{
	    key: 'componentWillEnter',
	    value: function componentWillEnter(cb) {
	      var _this2 = this;
	
	      var _props = this.props,
	          animationDuration = _props.animationDuration,
	          data = _props.data;
	
	      var targets = _lodash2.default.map(data, function (d) {
	        return _this2[d.id];
	      });
	      _gsap.TweenMax.staggerTo(targets, animationDuration, { opacity: 1, onComplete: cb }, animationDuration / targets.length);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(cb) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          animationDuration = _props2.animationDuration,
	          data = _props2.data;
	
	      var targets = _lodash2.default.map(data, function (d) {
	        return _this3[d.id];
	      });
	      _gsap.TweenMax.staggerTo(targets, animationDuration, { opacity: 0, onComplete: cb }, animationDuration / targets.length);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props3 = this.props,
	          date = _props3.date,
	          onSelectDate = _props3.onSelectDate;
	
	      onSelectDate(date);
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props4 = this.props,
	          unfocusDateTrace = _props4.unfocusDateTrace,
	          userId = _props4.userId;
	
	      unfocusDateTrace(userId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props5 = this.props,
	          bgBounds = _props5.bgBounds,
	          cbgRadius = _props5.cbgRadius,
	          data = _props5.data,
	          date = _props5.date,
	          topMargin = _props5.topMargin,
	          userId = _props5.userId,
	          xScale = _props5.xScale,
	          yScale = _props5.yScale;
	
	      return _react2.default.createElement(
	        'g',
	        { id: 'cbgDateTrace-' + date },
	        _lodash2.default.map(data, function (d) {
	          return _react2.default.createElement('circle', {
	            className: _CBGDateTraceAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, d.value)],
	            cx: xScale(d.msPer24),
	            cy: yScale(d.value),
	            id: 'cbgCircle-' + d.id,
	            key: d.id,
	            onClick: _this4.handleClick,
	            onMouseOver: function onMouseOver() {
	              _this4.props.focusDateTrace(userId, d, {
	                left: xScale(d.msPer24),
	                yPositions: {
	                  top: yScale(d.value),
	                  topMargin: topMargin
	                }
	              });
	            },
	            onMouseOut: _this4.handleMouseOut,
	            opacity: 0,
	            r: cbgRadius,
	            ref: function ref(node) {
	              _this4[d.id] = node;
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return CBGDateTraceAnimated;
	}(_react.PureComponent);
	
	CBGDateTraceAnimated.defaultProps = {
	  animationDuration: 0.2,
	  cbgRadius: 2.5
	};
	CBGDateTraceAnimated.propTypes = {
	  animationDuration: _react.PropTypes.number.isRequired,
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  cbgRadius: _react.PropTypes.number.isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  date: _react.PropTypes.string.isRequired,
	  focusDateTrace: _react.PropTypes.func.isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  unfocusDateTrace: _react.PropTypes.func.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusDateTrace: _trends.focusTrendsCbgDateTrace,
	    unfocusDateTrace: _trends.unfocusTrendsCbgDateTrace
	  }, dispatch);
	}
	
	var _default = (0, _connectWithTransitionGroup2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { withRef: true })(CBGDateTraceAnimated));
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGDateTraceAnimated, 'CBGDateTraceAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	})();

	;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.19.0
	 * DATE: 2016-07-14
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._dirty = true; //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.19.0";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
	
					if (this._easeType) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val.call(targets[i], i) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.19.0";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						tl.add(tween, tween._startTime - tween._delay);
					}
					tween = next;
				}
				root.add(tl, 0);
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > last._startTime + last._totalDuration / last._timeScale) {
					this._time = this.duration();
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - this.duration() : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = this.duration() + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : this.duration();
				} else if (timeOrLabel == null) {
					timeOrLabel = this.duration();
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this.add(tween, tween._startTime - tween._delay);
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function() {
				return this._paused ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.19.0";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration()) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale );
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						t._callback("onStart");
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTime = this._time,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						time = this._time;
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[(l < -1) ? 0 : 1][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.7",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.19.0";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_doc = document,
				_createElement = function(type) {
					return _doc.createElementNS ? _doc.createElementNS("http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = navigator.userAgent,
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || Number(_agent.substr(i+8, 1)) > 3));
					_isSafariLT6 = (_isSafari && (Number(_agent.substr(_agent.indexOf("Version/")+8, 1)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (window.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || !sfx) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getBBox && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(v[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = colors.length ? "" : s,
						i, color, temp;
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = Math.round(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod(proxy.rotation, this.t) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = r; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i];
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1), true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra((hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra((hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", true, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", true)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), true);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px"), (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = _isSafari || _isFirefox; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = window.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement,
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !window.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
						y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
						xOrigin = decoratee.xOrigin = v[0] = x;
						yOrigin = decoratee.yOrigin = v[1] = y;
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_canGetBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (e) {}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getBBox && e.getCTM && _canGetBBox(e) && (!e.parentNode || (e.parentNode.getBBox && e.parentNode.getCTM)));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (isDefault && _transformProp && ((none = (_getComputedStyle(e).display === "none")) || !e.parentNode)) {
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none".
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getBBox && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							if (m.indexOf("matrix") !== -1) { //just in case there's a "transform" value specified as an attribute instead of CSS style. Accept either a matrix() or simple translate() value though.
								s = m;
								isDefault = 0;
							} else if (m.indexOf("translate") !== -1) {
								s = "matrix(1,0,0,1," + m.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")";
								isDefault = 0;
							}
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getBBox && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
	
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								a11 = a11*cos+a12*sin;
								t2 = a21*cos+a22*sin;
								a22 = a21*-sin+a22*cos;
								a32 = a31*-sin+a32*cos;
								a21 = t2;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a23 * a23) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a32 * a32 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							if (tm.rotationX || tm.rotationY) {
								tm.skewX = 0;
							} else {
								tm.skewX = (a12 || a22) ? Math.atan2(a12, a22) * _RAD2DEG + tm.rotation : tm.skewX || 0;
								if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
									if (invX) {
										tm.scaleX *= -1;
										tm.skewX += (tm.rotation <= 0) ? 180 : -180;
										tm.rotation += (tm.rotation <= 0) ? 180 : -180;
									} else {
										tm.scaleY *= -1;
										tm.skewX += (tm.skewX <= 0) ? 180 : -180;
									}
								}
							}
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
								if (invX) {
									scaleX *= -1;
									skewX += (rotation <= 0) ? 180 : -180;
									rotation += (rotation <= 0) ? 180 : -180;
								} else {
									scaleY *= -1;
									skewX += (skewX <= 0) ? 180 : -180;
								}
							}
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t1, t2, transform, comma, zero, skew, rnd;
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || t.skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = t.skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - t.skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (t.skewY) {
									t1 = Math.tan(t.skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || t.skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (t.skewX) {
							angle -= t.skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((t.skewX - t.skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(t.skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation - m1.skewY, m1.rotation - m1.skewY, "rotation", endRotations); //see notes below about skewY for why we subtract it from rotation here
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX - m1.skewY); //see notes below about skewY and why we subtract it from skewX here
	
					//note: for performance reasons, we combine all skewing into the skewX and rotation values, ignoring skewY but we must still record it so that we can discern how much of the overall skew is attributed to skewX vs. skewY. Otherwise, if the skewY would always act relative (tween skewY to 10deg, for example, multiple times and if we always combine things into skewX, we can't remember that skewY was 10 from last time). Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of -10 degrees.
					if ((m2.skewY = _parseAngle(v.skewY, m1.skewY))) {
						m2.skewX += m2.skewY;
						m2.rotation += m2.skewY;
					}
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = _useSVGTransformAttr ? null : "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong).
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
	
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
	
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = Math.round(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = Math.round(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function" && lookup[pt.p] === Math.round) { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally..
						pt.r = 1;
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.6.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_roundLinkedList = function(node) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = (tween.vars.roundProps.join) ? tween.vars.roundProps : tween.vars.roundProps.split(","),
					i = rp.length,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					prop, pt, next;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
				i = rp.length;
				while (--i > -1) {
					prop = rp[i];
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === prop) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT);
							} else {
								this._add(pt.t, prop, pt.s, pt.c);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[prop] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c) {
				this._addTween(target, p, s, s + c, p, Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.0",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.0",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? 1 - (p = (p - this._p3) / this._p1) * p : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p);
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + 1;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return ((this._p2 * p) >> 0) * this._p1;
			};
			p.config = SteppedEase.config = function(steps) {
				return new SteppedEase(steps);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl, hasModule;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								hasModule = (typeof(module) !== "undefined" && module.exports);
								if (!hasModule && "function" === "function" && __webpack_require__(131)){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								} else if (hasModule){ //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				_blankArray = [],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && document.visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000) {
						_ticker.wake();
					}
					setTimeout(_checkTimeout, 2000);
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime()) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					var pauseTime = this._pauseTime,
						t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				return this._uncache(false);
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.19.0";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				return (typeof(document) === "undefined") ? e : (document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m(val, this._target || pt.t);
						} else if (val < min) if (val > -min) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [start, end],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var s = (start === "get") ? target[prop] : start,
						type = typeof(target[prop]),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob, getterName;
					if (type !== "number") {
						if (type === "function" && start === "get") {
							getterName = ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3));
							pt.s = s = funcParam ? target[getterName](funcParam) : target[getterName]();
						}
						if (typeof(s) === "string" && (funcParam || isNaN(s))) {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, end, stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t:blob, p:"setRatio", s:0, c:1, f:2, pg:0, n:overwriteProp || prop, pr:0, m:0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else if (!isRelative) {
							pt.s = parseFloat(s);
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					this._startAt = TweenLite.to(this.target, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a;
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 131 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = connectWithTransitionGroup;
	/**
	 * Copied from https://github.com/esayemm/connect-with-transition-group (ISC license)
	 * Cannot use dist from npm because `const` is not available yet under node v0.12.x
	 */
	
	/* eslint-disable func-names, lodash/prefer-lodash-method, no-param-reassign */
	
	/**
	 * Must have called react-redux/connect with the 'withRef' flag
	 * ex:
	 * connectWithTransitionGroup(connect(mapStateToProps, null, null, {
	 *   withRef: true,
	 * }));
	 *
	 * @param {*} connect - return from react-redux/connect
	 * @returns {*} component monkey patched with special lifecycle functions
	 */
	function connectWithTransitionGroup(connect) {
	  var willFunctions = ['componentWillAppear', 'componentWillEnter', 'componentWillLeave'];
	
	  var didFunctions = ['componentDidAppear', 'componentDidEnter', 'componentDidLeave'];
	
	  willFunctions.forEach(function (key) {
	    connect.prototype[key] = function (cb) {
	      if (this.refs.wrappedInstance[key]) {
	        this.refs.wrappedInstance[key](cb);
	      } else {
	        cb();
	      }
	    };
	  });
	
	  didFunctions.forEach(function (key) {
	    connect.prototype[key] = function () {
	      if (this.refs.wrappedInstance[key]) {
	        this.refs.wrappedInstance[key]();
	      }
	    };
	  });
	
	  return connect;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(connectWithTransitionGroup, 'connectWithTransitionGroup', '/Users/krystophv/tidepool/viz/src/components/common/connectWithTransitionGroup.js');
	})();

	;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(134);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(135), undefined);
	
	// module
	exports.push([module.id, ".CBGDateTraceAnimated--border--3Kyho{stroke:#fff;stroke-width:.5px}", ""]);
	
	// exports
	exports.locals = {
		"border": "CBGDateTraceAnimated--border--3Kyho",
		"low": "CBGDateTraceAnimated--low--2Tj8C CBGDateTraceAnimated--border--3Kyho " + __webpack_require__(135).locals["bgLow"] + "",
		"target": "CBGDateTraceAnimated--target--Az1fN CBGDateTraceAnimated--border--3Kyho " + __webpack_require__(135).locals["bgTarget"] + "",
		"high": "CBGDateTraceAnimated--high--38Sss CBGDateTraceAnimated--border--3Kyho " + __webpack_require__(135).locals["bgHigh"] + ""
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--bolus-stroke:1}.diabetes--basalScheduledFill--1fJlr{fill:var(--basal);fill-opacity:.4}.diabetes--basalAutomatedFill--377gw{fill:var(--basal-automated);fill-opacity:.4}.diabetes--basalTempFill--3zEDj{fill:var(--basal);fill-opacity:.2}.diabetes--basalScheduledPath--1iW1-{stroke:var(--basal)}.diabetes--basalAutomatedPath--Bss3R{stroke:var(--basal-automated)}.diabetes--basalUndeliveredPath--2V6wR{stroke-dasharray:1.5,3}.diabetes--bgLow---sH-f{color:var(--bg-low);fill:var(--bg-low)}.diabetes--bgTarget--3eoZO{color:var(--bg-target);fill:var(--bg-target)}.diabetes--bgHigh--33Mni{color:var(--bg-high);fill:var(--bg-high)}.diabetes--bolusDelivered--3czCX{color:var(--bolus);fill:var(--bolus)}.diabetes--bolusInterrupted--165Yp{color:var(--bolus--interrupted);fill:var(--bolus--interrupted)}.diabetes--bolusProgrammed--1f3B_{fill:none;stroke:var(--bolus);stroke-dasharray:3,2;stroke-width:var(--bolus-stroke)}.diabetes--bolusRideTriangle--11jMx{fill:var(--bolus--ride)}.diabetes--bolusUndelivered--3KfBW,.diabetes--bolusUnderride--h-R0D{color:var(--bolus--undelivered);fill:var(--bolus--undelivered)}.diabetes--carbs--3fKj2{color:var(--carbs);fill:var(--carbs)}", ""]);
	
	// exports
	exports.locals = {
		"basalScheduledFill": "diabetes--basalScheduledFill--1fJlr",
		"basalAutomatedFill": "diabetes--basalAutomatedFill--377gw",
		"basalTempFill": "diabetes--basalTempFill--3zEDj",
		"basalScheduledPath": "diabetes--basalScheduledPath--1iW1-",
		"basalAutomatedPath": "diabetes--basalAutomatedPath--Bss3R",
		"basalUndeliveredPath": "diabetes--basalUndeliveredPath--2V6wR diabetes--basalScheduledPath--1iW1-",
		"bgLow": "diabetes--bgLow---sH-f",
		"bgTarget": "diabetes--bgTarget--3eoZO",
		"bgHigh": "diabetes--bgHigh--33Mni",
		"bolusDelivered": "diabetes--bolusDelivered--3czCX",
		"bolusInterrupted": "diabetes--bolusInterrupted--165Yp",
		"bolusProgrammed": "diabetes--bolusProgrammed--1f3B_",
		"bolusRideTriangle": "diabetes--bolusRideTriangle--11jMx",
		"bolusUndelivered": "diabetes--bolusUndelivered--3KfBW",
		"bolusUnderride": "diabetes--bolusUnderride--h-R0D",
		"carbs": "diabetes--carbs--3fKj2"
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(105);
	
	var _datetime = __webpack_require__(22);
	
	var _data = __webpack_require__(109);
	
	var _CBGMedianAnimated = __webpack_require__(137);
	
	var _CBGMedianAnimated2 = _interopRequireDefault(_CBGMedianAnimated);
	
	var _CBGSliceAnimated = __webpack_require__(142);
	
	var _CBGSliceAnimated2 = _interopRequireDefault(_CBGSliceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGSlicesContainer = function (_PureComponent) {
	  _inherits(CBGSlicesContainer, _PureComponent);
	
	  function CBGSlicesContainer(props) {
	    _classCallCheck(this, CBGSlicesContainer);
	
	    var _this = _possibleConstructorReturn(this, (CBGSlicesContainer.__proto__ || Object.getPrototypeOf(CBGSlicesContainer)).call(this, props));
	
	    _this.state = {
	      mungedData: []
	    };
	    return _this;
	  }
	
	  _createClass(CBGSlicesContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          binSize = _props.binSize,
	          data = _props.data;
	
	      this.setState({ mungedData: this.mungeData(binSize, data) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var binSize = nextProps.binSize,
	          data = nextProps.data;
	
	      if (binSize !== this.props.binSize || data !== this.props.data) {
	        this.setState({ mungedData: this.mungeData(binSize, data) });
	      }
	    }
	  }, {
	    key: 'mungeData',
	    value: function mungeData(binSize, data) {
	      var binned = _lodash2.default.groupBy(data, function (d) {
	        return (0, _data.findBinForTimeOfDay)(binSize, d.msPer24);
	      });
	      var outOfRanges = (0, _data.findOutOfRangeAnnotations)(data);
	      // we need *all* possible keys for TransitionMotion to work on enter/exit
	      // and the range starts with binSize/2 because the keys are centered in each bin
	      var binKeys = _lodash2.default.map((0, _d3Array.range)(binSize / 2, _datetime.TWENTY_FOUR_HRS, binSize), function (d) {
	        return String(d);
	      });
	
	      var valueExtractor = function valueExtractor(d) {
	        return d.value;
	      };
	      var mungedData = [];
	      for (var i = 0; i < binKeys.length; ++i) {
	        var values = _lodash2.default.map(_lodash2.default.get(binned, binKeys[i], []), valueExtractor);
	        mungedData.push((0, _data.calculateCbgStatsForBin)(binKeys[i], binSize, values, outOfRanges));
	      }
	      return mungedData;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mungedData = this.state.mungedData;
	      var _props2 = this.props,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	
	      return _react2.default.createElement(
	        'g',
	        { id: 'cbgSlices' },
	        _lodash2.default.map(mungedData, function (bin) {
	          return _react2.default.createElement(
	            'g',
	            { id: 'cbgBin-' + bin.id, key: bin.id },
	            _react2.default.createElement(_CBGSliceAnimated2.default, {
	              bgBounds: _this2.props.bgBounds,
	              datum: bin,
	              displayFlags: _this2.props.displayFlags,
	              focusSlice: _this2.props.focusSlice,
	              showingCbgDateTraces: _this2.props.showingCbgDateTraces,
	              tooltipLeftThreshold: _this2.props.tooltipLeftThreshold,
	              topMargin: _this2.props.topMargin,
	              unfocusSlice: _this2.props.unfocusSlice,
	              xScale: xScale,
	              yScale: yScale
	            }),
	            _react2.default.createElement(_CBGMedianAnimated2.default, {
	              bgBounds: _this2.props.bgBounds,
	              datum: bin,
	              displayingMedian: _this2.props.displayFlags.cbgMedianEnabled,
	              showingCbgDateTraces: _this2.props.showingCbgDateTraces,
	              xScale: xScale,
	              yScale: yScale
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return CBGSlicesContainer;
	}(_react.PureComponent);
	
	CBGSlicesContainer.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  binSize: _react.PropTypes.number.isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	CBGSlicesContainer.defaultProps = {
	  binSize: _datetime.THIRTY_MINS
	};
	var _default = CBGSlicesContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGSlicesContainer, 'CBGSlicesContainer', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSlicesContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSlicesContainer.js');
	})();

	;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGMedianAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(138);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _constants = __webpack_require__(18);
	
	var _withDefaultYPosition = __webpack_require__(139);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _CBGMedianAnimated = __webpack_require__(140);
	
	var _CBGMedianAnimated2 = _interopRequireDefault(_CBGMedianAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGMedianAnimated = exports.CBGMedianAnimated = function (_PureComponent) {
	  _inherits(CBGMedianAnimated, _PureComponent);
	
	  function CBGMedianAnimated(props) {
	    _classCallCheck(this, CBGMedianAnimated);
	
	    var _this = _possibleConstructorReturn(this, (CBGMedianAnimated.__proto__ || Object.getPrototypeOf(CBGMedianAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGMedianAnimated, [{
	    key: 'willEnter',
	    value: function willEnter() {
	      var defaultY = this.props.defaultY;
	
	
	      return {
	        height: 0,
	        median: defaultY,
	        opacity: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave() {
	      var defaultY = this.props.defaultY;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return {
	        height: shrinkOut,
	        median: (0, _reactMotion.spring)(defaultY, _constants.springConfig),
	        opacity: shrinkOut
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx, _cx2;
	
	      var _props = this.props,
	          bgBounds = _props.bgBounds,
	          datum = _props.datum,
	          defaultY = _props.defaultY,
	          displayingMedian = _props.displayingMedian,
	          medianHeight = _props.medianHeight,
	          medianWidth = _props.medianWidth,
	          showingCbgDateTraces = _props.showingCbgDateTraces,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	
	      var medianClasses = datum.median ? (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _CBGMedianAnimated2.default.median, true), _defineProperty(_cx, _CBGMedianAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.median) + 'FadeIn'], !showingCbgDateTraces), _defineProperty(_cx, _CBGMedianAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.median) + 'FadeOut'], showingCbgDateTraces), _cx)) : (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _CBGMedianAnimated2.default.median, true), _defineProperty(_cx2, _CBGMedianAnimated2.default.transparent, true), _cx2));
	
	      var binLeftX = xScale(datum.msX) - medianWidth / 2 + _CBGMedianAnimated2.default.stroke / 2;
	      var width = medianWidth - _CBGMedianAnimated2.default.stroke;
	
	      var shouldRender = displayingMedian && _lodash2.default.get(datum, 'median') !== undefined;
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: shouldRender ? [{
	            key: 'median',
	            style: {
	              height: 0,
	              median: defaultY,
	              opacity: 0
	            }
	          }] : [],
	          styles: shouldRender ? [{
	            key: 'median',
	            style: {
	              height: (0, _reactMotion.spring)(medianHeight, _constants.springConfig),
	              median: (0, _reactMotion.spring)(yScale(datum.median) - medianHeight / 2, _constants.springConfig),
	              opacity: (0, _reactMotion.spring)(1.0, _constants.springConfig)
	            }
	          }] : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolateds) {
	          if (interpolateds.length === 0) {
	            return null;
	          }
	          var _interpolateds$ = interpolateds[0],
	              key = _interpolateds$.key,
	              style = _interpolateds$.style;
	
	          return _react2.default.createElement('rect', {
	            className: medianClasses,
	            id: 'cbgMedian-' + key,
	            width: width,
	            height: style.height,
	            x: binLeftX,
	            y: style.median,
	            opacity: style.opacity
	          });
	        }
	      );
	    }
	  }]);
	
	  return CBGMedianAnimated;
	}(_react.PureComponent);
	
	CBGMedianAnimated.defaultProps = {
	  medianHeight: 10,
	  medianWidth: 14
	};
	CBGMedianAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    firstQuartile: _react.PropTypes.number,
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    median: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired,
	    msX: _react.PropTypes.number.isRequired,
	    ninetiethQuantile: _react.PropTypes.number,
	    tenthQuantile: _react.PropTypes.number,
	    thirdQuartile: _react.PropTypes.number
	  }).isRequired,
	  defaultY: _react.PropTypes.number.isRequired,
	  displayingMedian: _react.PropTypes.bool.isRequired,
	  medianHeight: _react.PropTypes.number.isRequired,
	  medianWidth: _react.PropTypes.number.isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(CBGMedianAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGMedianAnimated, 'CBGMedianAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGMedianAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGMedianAnimated.js');
	})();

	;

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = require("react-motion");

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                   * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withDefaultYPosition = function withDefaultYPosition(WrappedComponent) {
	  var WithDefault = function WithDefault(props) {
	    var _props$bgBounds = props.bgBounds,
	        targetLowerBound = _props$bgBounds.targetLowerBound,
	        targetUpperBound = _props$bgBounds.targetUpperBound,
	        yScale = props.yScale;
	
	    // default Y position is the center of the target range
	    // i.e., 100 mg/dL if target range is 80-120 mg/dL
	
	    var defaultY = yScale(targetUpperBound - (targetUpperBound - targetLowerBound) / 2);
	
	    return _react2.default.createElement(WrappedComponent, _extends({ defaultY: defaultY }, props));
	  };
	
	  WithDefault.propTypes = {
	    bgBounds: _react.PropTypes.shape({
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired
	    }).isRequired,
	    yScale: _react.PropTypes.func.isRequired
	  };
	
	  return WithDefault;
	};
	
	var _default = withDefaultYPosition;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(withDefaultYPosition, 'withDefaultYPosition', '/Users/krystophv/tidepool/viz/src/components/trends/common/withDefaultYPosition.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/withDefaultYPosition.js');
	})();

	;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(141);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGMedianAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGMedianAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(135), undefined);
	
	// module
	exports.push([module.id, ".CBGMedianAnimated--thickStroke--1kNsm{stroke-width:2}.CBGMedianAnimated--median--9lVxT{stroke:#fff;pointer-events:none}.CBGMedianAnimated--transparent--3FBcm{fill:transparent}@keyframes CBGMedianAnimated--fadein--2SSo3{0%{fill-opacity:0}to{fill-opacity:1}}@keyframes CBGMedianAnimated--fadeout--2O0kI{0%{fill-opacity:1}to{fill-opacity:0}}.CBGMedianAnimated--fadeinAnimation--1_d7J{animation:CBGMedianAnimated--fadein--2SSo3 .25s forwards ease-in-out}.CBGMedianAnimated--fadeoutAnimation--3N5Z1{animation:CBGMedianAnimated--fadeout--2O0kI .25s forwards ease-in-out}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"thickStroke": "CBGMedianAnimated--thickStroke--1kNsm",
		"median": "CBGMedianAnimated--median--9lVxT CBGMedianAnimated--thickStroke--1kNsm",
		"transparent": "CBGMedianAnimated--transparent--3FBcm",
		"fadeinAnimation": "CBGMedianAnimated--fadeinAnimation--1_d7J",
		"fadein": "CBGMedianAnimated--fadein--2SSo3",
		"fadeoutAnimation": "CBGMedianAnimated--fadeoutAnimation--3N5Z1",
		"fadeout": "CBGMedianAnimated--fadeout--2O0kI",
		"lowFadeIn": "CBGMedianAnimated--lowFadeIn--1OV-G " + __webpack_require__(135).locals["bgLow"] + " CBGMedianAnimated--fadeinAnimation--1_d7J",
		"lowFadeOut": "CBGMedianAnimated--lowFadeOut--26emZ " + __webpack_require__(135).locals["bgLow"] + " CBGMedianAnimated--fadeoutAnimation--3N5Z1",
		"targetFadeIn": "CBGMedianAnimated--targetFadeIn--2AHgv " + __webpack_require__(135).locals["bgTarget"] + " CBGMedianAnimated--fadeinAnimation--1_d7J",
		"targetFadeOut": "CBGMedianAnimated--targetFadeOut--18g51 " + __webpack_require__(135).locals["bgTarget"] + " CBGMedianAnimated--fadeoutAnimation--3N5Z1",
		"highFadeIn": "CBGMedianAnimated--highFadeIn--r3_uQ " + __webpack_require__(135).locals["bgHigh"] + " CBGMedianAnimated--fadeinAnimation--1_d7J",
		"highFadeOut": "CBGMedianAnimated--highFadeOut--3fum2 " + __webpack_require__(135).locals["bgHigh"] + " CBGMedianAnimated--fadeoutAnimation--3N5Z1"
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGSliceAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(138);
	
	var _constants = __webpack_require__(18);
	
	var _withDefaultYPosition = __webpack_require__(139);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _CBGSliceSegment = __webpack_require__(143);
	
	var _CBGSliceSegment2 = _interopRequireDefault(_CBGSliceSegment);
	
	var _CBGSliceAnimated = __webpack_require__(144);
	
	var _CBGSliceAnimated2 = _interopRequireDefault(_CBGSliceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGSliceAnimated = exports.CBGSliceAnimated = function (_PureComponent) {
	  _inherits(CBGSliceAnimated, _PureComponent);
	
	  function CBGSliceAnimated(props) {
	    _classCallCheck(this, CBGSliceAnimated);
	
	    var _this = _possibleConstructorReturn(this, (CBGSliceAnimated.__proto__ || Object.getPrototypeOf(CBGSliceAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGSliceAnimated, [{
	    key: 'willEnter',
	    value: function willEnter(entered) {
	      var style = entered.style;
	      var defaultY = this.props.defaultY;
	
	
	      return _lodash2.default.mapValues(style, function (val, key) {
	        if (key === 'opacity') {
	          return 0;
	        } else if (key.search('Height') !== -1) {
	          return 0;
	        }
	        return defaultY;
	      });
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave(exited) {
	      var style = exited.style;
	      var defaultY = this.props.defaultY;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return _lodash2.default.mapValues(style, function (val, key) {
	        if (key === 'opacity') {
	          return shrinkOut;
	        } else if (key.search('Height') !== -1) {
	          return shrinkOut;
	        }
	        return (0, _reactMotion.spring)(defaultY, _constants.springConfig);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          datum = _props.datum,
	          defaultY = _props.defaultY,
	          displayFlags = _props.displayFlags,
	          sliceWidth = _props.sliceWidth,
	          showingCbgDateTraces = _props.showingCbgDateTraces,
	          tooltipLeftThreshold = _props.tooltipLeftThreshold,
	          topMargin = _props.topMargin,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	
	      var renderPieces = {
	        top10: {
	          classKey: 'rangeSegment',
	          displayFlag: 'cbg100Enabled',
	          height: 'top10Height',
	          heightKeys: ['ninetiethQuantile', 'max'],
	          key: 'top10',
	          y: 'max'
	        },
	        bottom10: {
	          classKey: 'rangeSegment',
	          displayFlag: 'cbg100Enabled',
	          height: 'bottom10Height',
	          heightKeys: ['min', 'tenthQuantile'],
	          key: 'bottom10',
	          y: 'tenthQuantile'
	        },
	        upper15: {
	          classKey: 'outerSegment',
	          displayFlag: 'cbg80Enabled',
	          height: 'upper15Height',
	          heightKeys: ['thirdQuartile', 'ninetiethQuantile'],
	          key: 'upper15',
	          y: 'ninetiethQuantile'
	        },
	        lower15: {
	          classKey: 'outerSegment',
	          displayFlag: 'cbg80Enabled',
	          height: 'lower15Height',
	          heightKeys: ['tenthQuantile', 'firstQuartile'],
	          key: 'lower15',
	          y: 'firstQuartile'
	        },
	        innerQuartiles: {
	          classKey: 'innerQuartilesSegment',
	          displayFlag: 'cbg50Enabled',
	          height: 'innerQuartilesHeight',
	          heightKeys: ['firstQuartile', 'thirdQuartile'],
	          key: 'innerQuartiles',
	          y: 'thirdQuartile'
	        }
	      };
	      var toRender = _lodash2.default.filter(renderPieces, function (piece) {
	        return displayFlags[piece.displayFlag];
	      });
	      var yPositions = {
	        firstQuartile: yScale(datum.firstQuartile),
	        max: yScale(datum.max),
	        median: yScale(datum.median),
	        min: yScale(datum.min),
	        ninetiethQuantile: yScale(datum.ninetiethQuantile),
	        tenthQuantile: yScale(datum.tenthQuantile),
	        thirdQuartile: yScale(datum.thirdQuartile),
	        topMargin: topMargin
	      };
	
	      var binLeftX = xScale(datum.msX) - sliceWidth / 2 + _CBGSliceAnimated2.default.stroke / 2;
	      var width = sliceWidth - _CBGSliceAnimated2.default.stroke;
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: _lodash2.default.get(datum, 'min') !== undefined ? _lodash2.default.map(toRender, function (segment) {
	            var _style;
	
	            return {
	              key: segment.key,
	              style: (_style = {}, _defineProperty(_style, segment.y, defaultY), _defineProperty(_style, segment.height, 0), _defineProperty(_style, 'opacity', 0), _style)
	            };
	          }) : [],
	          styles: _lodash2.default.get(datum, 'min') !== undefined ? _lodash2.default.map(toRender, function (segment) {
	            var _style2;
	
	            return {
	              key: segment.key,
	              style: (_style2 = {}, _defineProperty(_style2, segment.y, (0, _reactMotion.spring)(yScale(datum[segment.y]), _constants.springConfig)), _defineProperty(_style2, segment.height, (0, _reactMotion.spring)(yScale(datum[segment.heightKeys[0]]) - yScale(datum[segment.heightKeys[1]]), _constants.springConfig)), _defineProperty(_style2, 'opacity', (0, _reactMotion.spring)(1.0, _constants.springConfig)), _style2)
	            };
	          }) : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolateds) {
	          if (interpolateds.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'g',
	            { id: 'cbgSlice-' + datum.id },
	            _lodash2.default.map(interpolateds, function (interpolated) {
	              var _cx;
	
	              var segment = renderPieces[interpolated.key];
	              var classes = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _CBGSliceAnimated2.default.segment, true), _defineProperty(_cx, _CBGSliceAnimated2.default[segment.classKey], !showingCbgDateTraces), _defineProperty(_cx, _CBGSliceAnimated2.default[segment.classKey + 'Faded'], showingCbgDateTraces), _cx));
	              return _react2.default.createElement(_CBGSliceSegment2.default, {
	                classes: classes,
	                datum: datum,
	                interpolated: interpolated,
	                key: interpolated.key,
	                positionData: {
	                  left: xScale(datum.msX),
	                  tooltipLeft: datum.msX > tooltipLeftThreshold,
	                  yPositions: yPositions
	                },
	                segment: segment,
	                width: width,
	                x: binLeftX
	              });
	            })
	          );
	        }
	      );
	    }
	  }]);
	
	  return CBGSliceAnimated;
	}(_react.PureComponent);
	
	CBGSliceAnimated.defaultProps = {
	  sliceWidth: 16
	};
	CBGSliceAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    firstQuartile: _react.PropTypes.number,
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    median: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired,
	    msX: _react.PropTypes.number.isRequired,
	    ninetiethQuantile: _react.PropTypes.number,
	    tenthQuantile: _react.PropTypes.number,
	    thirdQuartile: _react.PropTypes.number
	  }).isRequired,
	  defaultY: _react.PropTypes.number.isRequired,
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  sliceWidth: _react.PropTypes.number.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(CBGSliceAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGSliceAnimated, 'CBGSliceAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSliceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSliceAnimated.js');
	})();

	;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGSliceSegment = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _thunks = __webpack_require__(49);
	
	var _trends = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGSliceSegment = exports.CBGSliceSegment = function (_PureComponent) {
	  _inherits(CBGSliceSegment, _PureComponent);
	
	  function CBGSliceSegment(props) {
	    _classCallCheck(this, CBGSliceSegment);
	
	    var _this = _possibleConstructorReturn(this, (CBGSliceSegment.__proto__ || Object.getPrototypeOf(CBGSliceSegment)).call(this, props));
	
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGSliceSegment, [{
	    key: 'handleMouseOut',
	    value: function handleMouseOut(e) {
	      // we don't want to unfocus the slice if the user just rolled over a cbg inside it
	      if (e.relatedTarget && e.relatedTarget.id.search('cbgCircle') !== -1) {
	        return;
	      }
	      this.props.unfocusSlice(this.props.userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props = this.props,
	          datum = _props.datum,
	          focusSlice = _props.focusSlice,
	          positionData = _props.positionData,
	          focusedKeys = _props.segment.heightKeys,
	          userId = _props.userId;
	
	
	      focusSlice(userId, datum, positionData, focusedKeys);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          classes = _props2.classes,
	          datum = _props2.datum,
	          _props2$interpolated = _props2.interpolated,
	          key = _props2$interpolated.key,
	          style = _props2$interpolated.style,
	          segment = _props2.segment,
	          width = _props2.width,
	          x = _props2.x;
	
	      return _react2.default.createElement('rect', {
	        className: classes,
	        key: key,
	        id: 'cbgSlice-' + datum.id + '-' + key,
	        width: width,
	        height: style[segment.height],
	        x: x,
	        y: style[segment.y],
	        opacity: style.opacity,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      });
	    }
	  }]);
	
	  return CBGSliceSegment;
	}(_react.PureComponent);
	
	CBGSliceSegment.propTypes = {
	  classes: _react.PropTypes.string.isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired
	  }),
	  focusSlice: _react.PropTypes.func.isRequired,
	  interpolated: _react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    style: _react.PropTypes.object.isRequired
	  }),
	  positionData: _react.PropTypes.shape({
	    left: _react.PropTypes.number.isRequired,
	    tooltipLeft: _react.PropTypes.bool.isRequired,
	    yPositions: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired,
	      topMargin: _react.PropTypes.number.isRequired
	    }).isRequired
	  }),
	  segment: _react.PropTypes.shape({
	    height: _react.PropTypes.string.isRequired,
	    heightKeys: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	    y: _react.PropTypes.string.isRequired
	  }),
	  unfocusSlice: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  x: _react.PropTypes.number.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusSlice: _thunks.delayShowCbgTracesOnFocus,
	    unfocusSlice: _trends.unfocusTrendsCbgSlice
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CBGSliceSegment);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGSliceSegment, 'CBGSliceSegment', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	})();

	;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(145);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGSliceAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGSliceAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".CBGSliceAnimated--segment--R3_GL{stroke-width:2;pointer-events:all}@keyframes CBGSliceAnimated--fadeRangeOut--3koNl{0%{stroke:var(--trends--light)}to{stroke:var(--trends--light--faded)}}@keyframes CBGSliceAnimated--fadeRangeIn--1Tg9W{0%{stroke:var(--trends--light--faded)}to{stroke:var(--trends--light)}}.CBGSliceAnimated--rangeSegment--hC3rL{animation:CBGSliceAnimated--fadeRangeIn--1Tg9W .25s forwards ease-in-out;fill:transparent}.CBGSliceAnimated--rangeSegmentFaded--2MJRj{animation:CBGSliceAnimated--fadeRangeOut--3koNl .25s forwards ease-in-out;fill:transparent}.CBGSliceAnimated--rangeSegment--hC3rL:hover,.CBGSliceAnimated--rangeSegmentFaded--2MJRj:hover{opacity:0}@keyframes CBGSliceAnimated--fadeOuterOut--awtzV{0%{fill:var(--trends--light);stroke:var(--trends--light)}to{fill:var(--trends--light--faded);stroke:var(--trends--light--faded)}}@keyframes CBGSliceAnimated--fadeOuterIn--g2T_t{0%{fill:var(--trends--light--faded);stroke:var(--trends--light--faded)}to{fill:var(--trends--light);stroke:var(--trends--light)}}.CBGSliceAnimated--outerSegment--23iy1{animation:CBGSliceAnimated--fadeOuterIn--g2T_t .25s forwards ease-in-out}.CBGSliceAnimated--outerSegmentFaded--1CrLu{animation:CBGSliceAnimated--fadeOuterOut--awtzV .25s forwards ease-in-out}.CBGSliceAnimated--outerSegment--23iy1:hover,.CBGSliceAnimated--outerSegmentFaded--1CrLu:hover{opacity:0}@keyframes CBGSliceAnimated--fadeInnerOut--1uLrJ{0%{fill:var(--trends--dark);stroke:var(--trends--dark)}to{fill:var(--trends--dark--faded);stroke:var(--trends--dark--faded)}}@keyframes CBGSliceAnimated--fadeInnerIn--2yMaD{0%{fill:var(--trends--dark--faded);stroke:var(--trends--dark--faded)}to{fill:var(--trends--dark);stroke:var(--trends--dark)}}.CBGSliceAnimated--innerQuartilesSegment--3C9dQ{animation:CBGSliceAnimated--fadeInnerIn--2yMaD .25s forwards ease-in-out}.CBGSliceAnimated--innerQuartilesSegmentFaded--3bXPA{animation:CBGSliceAnimated--fadeInnerOut--1uLrJ .25s forwards ease-in-out}.CBGSliceAnimated--innerQuartilesSegment--3C9dQ:hover,.CBGSliceAnimated--innerQuartilesSegmentFaded--3bXPA:hover{opacity:0}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"segment": "CBGSliceAnimated--segment--R3_GL",
		"rangeSegment": "CBGSliceAnimated--rangeSegment--hC3rL",
		"fadeRangeIn": "CBGSliceAnimated--fadeRangeIn--1Tg9W",
		"rangeSegmentFaded": "CBGSliceAnimated--rangeSegmentFaded--2MJRj",
		"fadeRangeOut": "CBGSliceAnimated--fadeRangeOut--3koNl",
		"outerSegment": "CBGSliceAnimated--outerSegment--23iy1",
		"fadeOuterIn": "CBGSliceAnimated--fadeOuterIn--g2T_t",
		"outerSegmentFaded": "CBGSliceAnimated--outerSegmentFaded--1CrLu",
		"fadeOuterOut": "CBGSliceAnimated--fadeOuterOut--awtzV",
		"innerQuartilesSegment": "CBGSliceAnimated--innerQuartilesSegment--3C9dQ",
		"fadeInnerIn": "CBGSliceAnimated--fadeInnerIn--2yMaD",
		"innerQuartilesSegmentFaded": "CBGSliceAnimated--innerQuartilesSegmentFaded--3bXPA",
		"fadeInnerOut": "CBGSliceAnimated--fadeInnerOut--1uLrJ"
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FocusedCBGSliceSegment = __webpack_require__(147);
	
	var _FocusedCBGSliceSegment2 = _interopRequireDefault(_FocusedCBGSliceSegment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var FocusedCBGSliceSegment = function FocusedCBGSliceSegment(props) {
	  if (!props.focusedSlice || !props.focusedSliceKeys) {
	    return null;
	  }
	  var position = props.focusedSlice.position,
	      focusedSliceKeys = props.focusedSliceKeys,
	      sliceWidth = props.sliceWidth;
	
	  return _react2.default.createElement('rect', {
	    className: _FocusedCBGSliceSegment2.default.segment,
	    x: position.left - sliceWidth / 2 + _FocusedCBGSliceSegment2.default.stroke / 2,
	    y: position.yPositions[focusedSliceKeys[1]],
	    width: sliceWidth - _FocusedCBGSliceSegment2.default.stroke,
	    height: position.yPositions[focusedSliceKeys[0]] - position.yPositions[focusedSliceKeys[1]]
	  });
	};
	
	FocusedCBGSliceSegment.defaultProps = {
	  sliceWidth: 16
	};
	
	FocusedCBGSliceSegment.propTypes = {
	  focusedSlice: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  focusedSliceKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	  sliceWidth: _react.PropTypes.number.isRequired
	};
	
	var _default = FocusedCBGSliceSegment;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FocusedCBGSliceSegment, 'FocusedCBGSliceSegment', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/FocusedCBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/cbg/FocusedCBGSliceSegment.js');
	})();

	;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedCBGSliceSegment.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedCBGSliceSegment.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".FocusedCBGSliceSegment--segment--3hWTM{stroke:#000;stroke-width:2;pointer-events:none;fill:transparent}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"segment": "FocusedCBGSliceSegment--segment--3hWTM"
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SMBGDatePointsAnimated = __webpack_require__(150);
	
	var _SMBGDatePointsAnimated2 = _interopRequireDefault(_SMBGDatePointsAnimated);
	
	var _SMBGDateLineAnimated = __webpack_require__(153);
	
	var _SMBGDateLineAnimated2 = _interopRequireDefault(_SMBGDateLineAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var SMBGsByDateContainer = function SMBGsByDateContainer(props) {
	  var data = props.data;
	
	  if (!data) {
	    return null;
	  }
	
	  var anSmbgRangeAvgIsFocused = props.anSmbgRangeAvgIsFocused,
	      bgBounds = props.bgBounds,
	      dates = props.dates,
	      focusedSmbg = props.focusedSmbg,
	      grouped = props.grouped,
	      lines = props.lines,
	      nonInteractive = props.nonInteractive,
	      onSelectDate = props.onSelectDate,
	      smbgOpts = props.smbgOpts,
	      someSmbgDataIsFocused = props.someSmbgDataIsFocused,
	      tooltipLeftThreshold = props.tooltipLeftThreshold,
	      xScale = props.xScale,
	      yScale = props.yScale;
	
	
	  var focusedDay = focusedSmbg ? focusedSmbg.date : '';
	  var smbgsByDate = _lodash2.default.groupBy(data, 'localDate');
	  _lodash2.default.each(dates, function (date) {
	    if (!smbgsByDate[date]) {
	      smbgsByDate[date] = [];
	    }
	  });
	
	  function getLines() {
	    var allDateLines = [];
	    _lodash2.default.each(smbgsByDate, function (smbgs, date) {
	      var dateData = lines ? smbgs : [];
	      allDateLines.push(_react2.default.createElement(_SMBGDateLineAnimated2.default, {
	        bgBounds: bgBounds,
	        data: dateData,
	        date: date,
	        focusedDay: focusedDay,
	        grouped: grouped,
	        key: date,
	        onSelectDate: onSelectDate,
	        nonInteractive: nonInteractive,
	        tooltipLeftThreshold: tooltipLeftThreshold,
	        xScale: xScale,
	        yScale: yScale
	      }));
	    });
	    if (focusedDay) {
	      allDateLines.push(_react2.default.createElement(_SMBGDateLineAnimated2.default, {
	        bgBounds: bgBounds,
	        data: focusedSmbg.allSmbgsOnDate,
	        date: focusedDay,
	        key: focusedDay + '-focused',
	        focusedDay: focusedDay,
	        grouped: grouped,
	        onSelectDate: onSelectDate,
	        nonInteractive: nonInteractive,
	        tooltipLeftThreshold: tooltipLeftThreshold,
	        xScale: xScale,
	        yScale: yScale
	      }));
	    }
	    return allDateLines;
	  }
	
	  function getPoints() {
	    return _lodash2.default.map(smbgsByDate, function (smbgs, date) {
	      return _react2.default.createElement(_SMBGDatePointsAnimated2.default, {
	        anSmbgRangeAvgIsFocused: anSmbgRangeAvgIsFocused,
	        bgBounds: bgBounds,
	        data: smbgs,
	        date: date,
	        grouped: grouped,
	        isFocused: focusedDay === date,
	        key: date,
	        nonInteractive: nonInteractive,
	        onSelectDate: onSelectDate,
	        smbgOpts: smbgOpts,
	        someSmbgDataIsFocused: someSmbgDataIsFocused,
	        tooltipLeftThreshold: tooltipLeftThreshold,
	        xScale: xScale,
	        yScale: yScale
	      });
	    });
	  }
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'smbgsByDateContainer' },
	    getLines(),
	    getPoints()
	  );
	};
	
	SMBGsByDateContainer.propTypes = {
	  anSmbgRangeAvgIsFocused: _react.PropTypes.bool.isRequired,
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    localDate: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  dates: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  focusedSmbg: _react.PropTypes.shape({
	    allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })),
	    allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    })),
	    date: _react.PropTypes.string.isRequired,
	    datum: _react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })
	  }),
	  grouped: _react.PropTypes.bool.isRequired,
	  lines: _react.PropTypes.bool.isRequired,
	  nonInteractive: _react.PropTypes.bool,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = SMBGsByDateContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGsByDateContainer, 'SMBGsByDateContainer', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGsByDateContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGsByDateContainer.js');
	})();

	;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGDatePointsAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _reactMotion = __webpack_require__(138);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _constants = __webpack_require__(18);
	
	var _datetime = __webpack_require__(22);
	
	var _data = __webpack_require__(109);
	
	var _trends = __webpack_require__(50);
	
	var _SMBGDatePointsAnimated = __webpack_require__(151);
	
	var _SMBGDatePointsAnimated2 = _interopRequireDefault(_SMBGDatePointsAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGDatePointsAnimated = exports.SMBGDatePointsAnimated = function (_PureComponent) {
	  _inherits(SMBGDatePointsAnimated, _PureComponent);
	
	  function SMBGDatePointsAnimated(props) {
	    _classCallCheck(this, SMBGDatePointsAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGDatePointsAnimated.__proto__ || Object.getPrototypeOf(SMBGDatePointsAnimated)).call(this, props));
	
	    _this.getPositions = _this.getPositions.bind(_this);
	    _this.getXPosition = _this.getXPosition.bind(_this);
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGDatePointsAnimated, [{
	    key: 'getPositions',
	    value: function getPositions() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          tooltipLeftThreshold = _props.tooltipLeftThreshold,
	          yScale = _props.yScale;
	
	      return _lodash2.default.map(data, function (d) {
	        return {
	          left: _this2.getXPosition(d.msPer24),
	          top: yScale(d.value),
	          tooltipLeft: d.msPer24 > tooltipLeftThreshold
	        };
	      });
	    }
	  }, {
	    key: 'getXPosition',
	    value: function getXPosition(msPer24) {
	      var _props2 = this.props,
	          grouped = _props2.grouped,
	          xScale = _props2.xScale;
	
	      if (grouped) {
	        return xScale((0, _data.findBinForTimeOfDay)(_datetime.THREE_HRS, msPer24));
	      }
	      return xScale(msPer24);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props3 = this.props,
	          date = _props3.date,
	          onSelectDate = _props3.onSelectDate;
	
	      onSelectDate(date);
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props4 = this.props,
	          unfocusSmbg = _props4.unfocusSmbg,
	          userId = _props4.userId;
	
	      unfocusSmbg(userId);
	    }
	  }, {
	    key: 'willEnter',
	    value: function willEnter(entered) {
	      var data = entered.data;
	      var xScale = this.props.xScale;
	
	      return {
	        cx: xScale(data.smbg.msPer24),
	        opacity: 0.5,
	        r: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave(exited) {
	      var data = exited.data;
	      var _props5 = this.props,
	          anSmbgRangeAvgIsFocused = _props5.anSmbgRangeAvgIsFocused,
	          someSmbgDataIsFocused = _props5.someSmbgDataIsFocused,
	          xScale = _props5.xScale;
	
	      return {
	        cx: (0, _reactMotion.spring)(xScale(data.smbg.msPer24), _constants.springConfig),
	        opacity: anSmbgRangeAvgIsFocused || someSmbgDataIsFocused ? (0, _reactMotion.spring)(0.35, _constants.springConfig) : (0, _reactMotion.spring)(0.8, _constants.springConfig),
	        r: (0, _reactMotion.spring)(0, _constants.springConfig)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props6 = this.props,
	          anSmbgRangeAvgIsFocused = _props6.anSmbgRangeAvgIsFocused,
	          bgBounds = _props6.bgBounds,
	          data = _props6.data,
	          date = _props6.date,
	          focusSmbg = _props6.focusSmbg,
	          isFocused = _props6.isFocused,
	          nonInteractive = _props6.nonInteractive,
	          smbgOpts = _props6.smbgOpts,
	          someSmbgDataIsFocused = _props6.someSmbgDataIsFocused,
	          userId = _props6.userId;
	
	      var radius = isFocused ? smbgOpts.maxR : smbgOpts.r;
	      var positions = this.getPositions();
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: data.length || !nonInteractive ? _lodash2.default.map(data, function (smbg, i) {
	            var position = positions[i];
	            return {
	              key: smbg.id,
	              style: {
	                cx: position.left,
	                opacity: 0.5,
	                r: 0
	              }
	            };
	          }) : [],
	          styles: data.length ? _lodash2.default.map(data, function (smbg, i) {
	            var position = positions[i];
	            return {
	              key: smbg.id,
	              data: {
	                classes: _SMBGDatePointsAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, smbg.value)],
	                position: position,
	                smbg: smbg
	              },
	              style: {
	                cx: (0, _reactMotion.spring)(position.left, _constants.springConfig),
	                opacity: anSmbgRangeAvgIsFocused || someSmbgDataIsFocused ? (0, _reactMotion.spring)(0.35, _constants.springConfig) : (0, _reactMotion.spring)(0.8, _constants.springConfig),
	                r: (0, _reactMotion.spring)(radius, _constants.springConfig)
	              }
	            };
	          }) : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolateds) {
	          if (interpolateds.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'g',
	            { id: 'smbgDatePoints-' + date },
	            _lodash2.default.map(interpolateds, function (smbg) {
	              var key = smbg.key,
	                  style = smbg.style;
	
	              return _react2.default.createElement('circle', {
	                className: smbg.data.classes,
	                id: 'smbg-' + key,
	                key: key,
	                onMouseOver: function onMouseOver() {
	                  return focusSmbg(userId, smbg.data.smbg, smbg.data.position, data, positions, date);
	                },
	                onMouseOut: _this3.handleMouseOut,
	                onClick: _this3.handleClick,
	                cx: style.cx,
	                cy: smbg.data.position.top,
	                r: style.r,
	                fillOpacity: style.opacity,
	                pointerEvents: nonInteractive ? 'none' : 'all'
	              });
	            })
	          );
	        }
	      );
	    }
	  }]);
	
	  return SMBGDatePointsAnimated;
	}(_react.PureComponent);
	
	SMBGDatePointsAnimated.propTypes = {
	  anSmbgRangeAvgIsFocused: _react.PropTypes.bool.isRequired,
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  date: _react.PropTypes.string.isRequired,
	  focusSmbg: _react.PropTypes.func.isRequired,
	  grouped: _react.PropTypes.bool.isRequired,
	  isFocused: _react.PropTypes.bool.isRequired,
	  nonInteractive: _react.PropTypes.bool,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  unfocusSmbg: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusSmbg: _trends.focusTrendsSmbg,
	    unfocusSmbg: _trends.unfocusTrendsSmbg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGDatePointsAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGDatePointsAnimated, 'SMBGDatePointsAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	})();

	;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(152);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDatePointsAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDatePointsAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(135), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"low": "SMBGDatePointsAnimated--low--2QXpz " + __webpack_require__(135).locals["bgLow"] + "",
		"target": "SMBGDatePointsAnimated--target--1a27- " + __webpack_require__(135).locals["bgTarget"] + "",
		"high": "SMBGDatePointsAnimated--high--1tgZk " + __webpack_require__(135).locals["bgHigh"] + ""
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGDateLineAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _reactMotion = __webpack_require__(138);
	
	var _d3Shape = __webpack_require__(154);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(18);
	
	var _datetime = __webpack_require__(22);
	
	var _data = __webpack_require__(109);
	
	var _trends = __webpack_require__(50);
	
	var _SMBGDateLineAnimated = __webpack_require__(155);
	
	var _SMBGDateLineAnimated2 = _interopRequireDefault(_SMBGDateLineAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// this component renders a line connecting the smbgs from a single date
	// it has two or three potential states:
	// - grouping on: the y-position of each point on the line segment
	//   is the average of all the smbgs in the group
	//   NB: when grouping is on, no line hover interaction
	// - grouping off: just connect the dots!
	//   but also include a 2nd, fatter invisible line with onMouseOver & onMouseOut handlers
	//   for the line to "focus" the whole date
	//   (there seems to be a regression on prod re: the rendering of the fatter invisible lines)
	// - date is focused (through hover) fatter & solid line connecting the dots
	//   this style also applies when a single smbg is focused
	
	var SMBGDateLineAnimated = exports.SMBGDateLineAnimated = function (_PureComponent) {
	  _inherits(SMBGDateLineAnimated, _PureComponent);
	
	  function SMBGDateLineAnimated(props) {
	    _classCallCheck(this, SMBGDateLineAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGDateLineAnimated.__proto__ || Object.getPrototypeOf(SMBGDateLineAnimated)).call(this, props));
	
	    _this.getDefaultPoints = _this.getDefaultPoints.bind(_this);
	    _this.getPoints = _this.getPoints.bind(_this);
	
	    _this.getPositions = _this.getPositions.bind(_this);
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGDateLineAnimated, [{
	    key: 'getDefaultPoints',
	    value: function getDefaultPoints() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          grouped = _props.grouped,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	      var points = [];
	      _lodash2.default.map(data, function (d) {
	        points.push({
	          key: d.id,
	          style: {
	            opacity: 0,
	            x: xScale(_this2.getXPosition(d.msPer24, grouped)),
	            y: yScale(d.value)
	          } });
	      });
	      return points;
	    }
	  }, {
	    key: 'getPoints',
	    value: function getPoints() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          grouped = _props2.grouped,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	      var points = [];
	      _lodash2.default.map(data, function (d) {
	        points.push({
	          key: d.id,
	          style: {
	            opacity: (0, _reactMotion.spring)(1, _constants.springConfig),
	            x: (0, _reactMotion.spring)(xScale(_this3.getXPosition(d.msPer24, grouped)), _constants.springConfig),
	            // basically a no-op animation but the data reshaping below for the d3 line() fn
	            // seems to require us to animate all properties we want to reshape there
	            y: (0, _reactMotion.spring)(yScale(d.value), _constants.springConfig)
	          } });
	      });
	      return points;
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          data = _props3.data,
	          grouped = _props3.grouped,
	          tooltipLeftThreshold = _props3.tooltipLeftThreshold,
	          xScale = _props3.xScale,
	          yScale = _props3.yScale;
	
	      return _lodash2.default.map(data, function (d) {
	        return {
	          tooltipLeft: d.msPer24 > tooltipLeftThreshold,
	          left: xScale(_this4.getXPosition(d.msPer24, grouped)),
	          top: yScale(d.value)
	        };
	      });
	    }
	  }, {
	    key: 'getXPosition',
	    value: function getXPosition(msPer24, grouped) {
	      if (grouped) {
	        return (0, _data.findBinForTimeOfDay)(_datetime.THREE_HRS, msPer24);
	      }
	      return msPer24;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props4 = this.props,
	          date = _props4.date,
	          onSelectDate = _props4.onSelectDate;
	
	      onSelectDate(date);
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props5 = this.props,
	          unfocusLine = _props5.unfocusLine,
	          userId = _props5.userId;
	
	      unfocusLine(userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props6 = this.props,
	          data = _props6.data,
	          date = _props6.date,
	          focusLine = _props6.focusLine,
	          userId = _props6.userId;
	
	      var positions = this.getPositions();
	      focusLine(userId, data[0], positions[0], data, positions, date);
	    }
	  }, {
	    key: 'willEnter',
	    value: function willEnter(entered) {
	      var style = entered.style;
	
	      return {
	        opacity: 0,
	        x: _lodash2.default.get(style, ['x', 'val'], style.x),
	        y: _lodash2.default.get(style, ['y', 'val'], style.y)
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave(exited) {
	      var style = exited.style;
	
	      return {
	        opacity: (0, _reactMotion.spring)(0, _constants.springConfig),
	        x: (0, _reactMotion.spring)(_lodash2.default.get(style, ['x', 'val'], style.x), _constants.springConfig),
	        y: (0, _reactMotion.spring)(_lodash2.default.get(style, ['y', 'val'], style.y), _constants.springConfig)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx,
	          _this5 = this;
	
	      var _props7 = this.props,
	          data = _props7.data,
	          date = _props7.date,
	          focusedDay = _props7.focusedDay,
	          nonInteractive = _props7.nonInteractive;
	
	
	      var classes = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _SMBGDateLineAnimated2.default.smbgPath, true), _defineProperty(_cx, _SMBGDateLineAnimated2.default.highlightPath, focusedDay === date), _cx));
	
	      return _react2.default.createElement(
	        'g',
	        { id: 'smbgDateLine-' + date },
	        _react2.default.createElement(
	          _reactMotion.TransitionMotion,
	          {
	            defaultStyles: this.getDefaultPoints(data),
	            styles: this.getPoints(data),
	            willEnter: this.willEnter,
	            willLeave: this.willLeave
	          },
	          function (interpolated) {
	            if (interpolated.length === 0) {
	              return null;
	            }
	            return _react2.default.createElement('path', {
	              // d3 line() expects an array of 2-member arrays of x, y coordinates
	              d: (0, _d3Shape.line)()(_lodash2.default.map(_lodash2.default.pluck(interpolated, 'style'), function (style) {
	                return [_lodash2.default.get(style, ['x', 'val'], style.x), _lodash2.default.get(style, ['y', 'val'], style.y)];
	              })),
	              className: classes,
	              onMouseOver: _this5.handleMouseOver,
	              onMouseOut: _this5.handleMouseOut,
	              onClick: _this5.handleClick,
	              pointerEvents: nonInteractive ? 'none' : 'stroke',
	              strokeOpacity: _lodash2.default.get(interpolated[0], ['style', 'opacity'])
	            });
	          }
	        )
	      );
	    }
	  }]);
	
	  return SMBGDateLineAnimated;
	}(_react.PureComponent);
	
	SMBGDateLineAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  date: _react.PropTypes.string.isRequired,
	  focusedDay: _react.PropTypes.string.isRequired,
	  focusLine: _react.PropTypes.func.isRequired,
	  grouped: _react.PropTypes.bool.isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  nonInteractive: _react.PropTypes.bool,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  unfocusLine: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusLine: _trends.focusTrendsSmbg,
	    unfocusLine: _trends.unfocusTrendsSmbg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGDateLineAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGDateLineAnimated, 'SMBGDateLineAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	})();

	;

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = require("d3-shape");

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(156);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDateLineAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDateLineAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".SMBGDateLineAnimated--smbgPath--W8OdK{fill:none;stroke:var(--trends--dark);stroke-dasharray:4,4}.SMBGDateLineAnimated--highlightPath--1aPEd{stroke-width:2px;stroke-dasharray:4,0}", ""]);
	
	// exports
	exports.locals = {
		"smbgPath": "SMBGDateLineAnimated--smbgPath--W8OdK",
		"highlightPath": "SMBGDateLineAnimated--highlightPath--1aPEd"
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(105);
	
	var _datetime = __webpack_require__(22);
	
	var _data = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGRangeAvgContainer = function (_PureComponent) {
	  _inherits(SMBGRangeAvgContainer, _PureComponent);
	
	  function SMBGRangeAvgContainer() {
	    _classCallCheck(this, SMBGRangeAvgContainer);
	
	    return _possibleConstructorReturn(this, (SMBGRangeAvgContainer.__proto__ || Object.getPrototypeOf(SMBGRangeAvgContainer)).apply(this, arguments));
	  }
	
	  _createClass(SMBGRangeAvgContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          binSize = _props.binSize,
	          data = _props.data;
	
	      this.setState({ mungedData: this.mungeData(binSize, data) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var binSize = nextProps.binSize,
	          data = nextProps.data;
	
	      if (binSize !== this.props.binSize || data !== this.props.data) {
	        this.setState({ mungedData: this.mungeData(binSize, data) });
	      }
	    }
	  }, {
	    key: 'mungeData',
	    value: function mungeData(binSize, data) {
	      var binned = _lodash2.default.groupBy(data, function (d) {
	        return (0, _data.findBinForTimeOfDay)(binSize, d.msPer24);
	      });
	      var outOfRanges = (0, _data.findOutOfRangeAnnotations)(data);
	      // we need *all* possible keys for TransitionMotion to work on enter/exit
	      // and the range starts with binSize/2 because the keys are centered in each bin
	      var binKeys = _lodash2.default.map((0, _d3Array.range)(binSize / 2, _datetime.TWENTY_FOUR_HRS, binSize), function (d) {
	        return String(d);
	      });
	
	      var valueExtractor = function valueExtractor(d) {
	        return d.value;
	      };
	      var mungedData = [];
	      for (var i = 0; i < binKeys.length; ++i) {
	        var values = _lodash2.default.map(binned[binKeys[i]], valueExtractor);
	        mungedData.push((0, _data.calculateSmbgStatsForBin)(binKeys[i], binSize, values, outOfRanges));
	      }
	      return mungedData;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mungedData = this.state.mungedData;
	      var SMBGComponent = this.props.smbgComponent;
	
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'smbgAggContainer' },
	        _lodash2.default.map(mungedData, function (datum) {
	          return _react2.default.createElement(SMBGComponent, {
	            bgBounds: _this2.props.bgBounds,
	            datum: datum,
	            key: datum.id,
	            someSmbgDataIsFocused: _this2.props.someSmbgDataIsFocused,
	            tooltipLeftThreshold: _this2.props.tooltipLeftThreshold,
	            xScale: _this2.props.xScale,
	            yScale: _this2.props.yScale
	          });
	        })
	      );
	    }
	  }]);
	
	  return SMBGRangeAvgContainer;
	}(_react.PureComponent);
	
	SMBGRangeAvgContainer.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  binSize: _react.PropTypes.number.isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  smbgComponent: _react.PropTypes.func.isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	SMBGRangeAvgContainer.defaultProps = {
	  binSize: _datetime.THREE_HRS
	};
	var _default = SMBGRangeAvgContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGRangeAvgContainer, 'SMBGRangeAvgContainer', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRangeAvgContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRangeAvgContainer.js');
	})();

	;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGRangeAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(138);
	
	var _constants = __webpack_require__(18);
	
	var _withDefaultYPosition = __webpack_require__(139);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _SMBGRange = __webpack_require__(159);
	
	var _SMBGRange2 = _interopRequireDefault(_SMBGRange);
	
	var _SMBGRangeAnimated = __webpack_require__(160);
	
	var _SMBGRangeAnimated2 = _interopRequireDefault(_SMBGRangeAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGRangeAnimated = exports.SMBGRangeAnimated = function (_PureComponent) {
	  _inherits(SMBGRangeAnimated, _PureComponent);
	
	  function SMBGRangeAnimated(props) {
	    _classCallCheck(this, SMBGRangeAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGRangeAnimated.__proto__ || Object.getPrototypeOf(SMBGRangeAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGRangeAnimated, [{
	    key: 'willEnter',
	    value: function willEnter() {
	      var defaultY = this.props.defaultY;
	
	      return {
	        y: defaultY,
	        height: 0,
	        opacity: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave() {
	      var defaultY = this.props.defaultY;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return {
	        y: (0, _reactMotion.spring)(defaultY, _constants.springConfig),
	        height: shrinkOut,
	        opacity: shrinkOut
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx,
	          _this2 = this;
	
	      var _props = this.props,
	          datum = _props.datum,
	          defaultY = _props.defaultY,
	          someSmbgDataIsFocused = _props.someSmbgDataIsFocused,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	
	      var xPos = xScale(datum.msX);
	      var yPositions = {
	        min: yScale(datum.min),
	        mean: yScale(datum.mean),
	        max: yScale(datum.max)
	      };
	
	      var rangeClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _SMBGRangeAnimated2.default.smbgRange, true), _defineProperty(_cx, _SMBGRangeAnimated2.default.fadeIn, !someSmbgDataIsFocused), _defineProperty(_cx, _SMBGRangeAnimated2.default.fadeOut, someSmbgDataIsFocused), _cx));
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: [{
	            key: datum.id,
	            style: {
	              y: defaultY,
	              height: 0,
	              opacity: 0
	            }
	          }],
	          styles: datum.min ? [{
	            key: datum.id,
	            style: {
	              y: (0, _reactMotion.spring)(yPositions.max, _constants.springConfig),
	              height: (0, _reactMotion.spring)(yPositions.min - yPositions.max, _constants.springConfig),
	              opacity: (0, _reactMotion.spring)(1.0, _constants.springConfig)
	            }
	          }] : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolated) {
	          if (interpolated.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(_SMBGRange2.default, {
	            classes: rangeClasses,
	            datum: datum,
	            interpolated: interpolated[0],
	            positionData: {
	              left: xPos,
	              tooltipLeft: datum.msX > _this2.props.tooltipLeftThreshold,
	              yPositions: yPositions
	            }
	          });
	        }
	      );
	    }
	  }]);
	
	  return SMBGRangeAnimated;
	}(_react.PureComponent);
	
	SMBGRangeAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  defaultY: _react.PropTypes.number.isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(SMBGRangeAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGRangeAnimated, 'SMBGRangeAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRangeAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRangeAnimated.js');
	})();

	;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGRange = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _trends = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGRange = exports.SMBGRange = function (_PureComponent) {
	  _inherits(SMBGRange, _PureComponent);
	
	  function SMBGRange(props) {
	    _classCallCheck(this, SMBGRange);
	
	    var _this = _possibleConstructorReturn(this, (SMBGRange.__proto__ || Object.getPrototypeOf(SMBGRange)).call(this, props));
	
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGRange, [{
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props = this.props,
	          unfocusRange = _props.unfocusRange,
	          userId = _props.userId;
	
	      unfocusRange(userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props2 = this.props,
	          datum = _props2.datum,
	          focusRange = _props2.focusRange,
	          positionData = _props2.positionData,
	          userId = _props2.userId;
	
	      focusRange(userId, datum, positionData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          classes = _props3.classes,
	          _props3$interpolated = _props3.interpolated,
	          key = _props3$interpolated.key,
	          style = _props3$interpolated.style,
	          positionData = _props3.positionData,
	          rectWidth = _props3.rectWidth;
	
	      return _react2.default.createElement('rect', {
	        className: classes,
	        id: 'smbgRange-' + key,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        x: positionData.left - rectWidth / 2,
	        y: style.y,
	        width: rectWidth,
	        height: style.height,
	        opacity: style.opacity
	      });
	    }
	  }]);
	
	  return SMBGRange;
	}(_react.PureComponent);
	
	SMBGRange.defaultProps = {
	  rectWidth: 108
	};
	SMBGRange.propTypes = {
	  classes: _react.PropTypes.string.isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  focusRange: _react.PropTypes.func.isRequired,
	  interpolated: _react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    style: _react.PropTypes.shape({
	      height: _react.PropTypes.number.isRequired,
	      opacity: _react.PropTypes.number.isRequired,
	      y: _react.PropTypes.number.isRequired
	    }).isRequired
	  }).isRequired,
	  positionData: _react.PropTypes.shape({
	    left: _react.PropTypes.number.isRequired,
	    tooltipLeft: _react.PropTypes.bool.isRequired,
	    yPositions: _react.PropTypes.shape({
	      max: _react.PropTypes.number.isRequired,
	      mean: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired
	    }).isRequired
	  }),
	  rectWidth: _react.PropTypes.number.isRequired,
	  unfocusRange: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusRange: _trends.focusTrendsSmbgRangeAvg,
	    unfocusRange: _trends.unfocusTrendsSmbgRangeAvg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGRange);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGRange, 'SMBGRange', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	})();

	;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(161);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGRangeAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGRangeAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes SMBGRangeAnimated--fadein--1Nr5V{0%{fill-opacity:.3}to{fill-opacity:.4}}@keyframes SMBGRangeAnimated--fadeout--2huim{0%{fill-opacity:.4}to{fill-opacity:.3}}.SMBGRangeAnimated--smbgRange--14DpS{fill:var(--trends--light);stroke:none}.SMBGRangeAnimated--fadeIn--3XbzN{animation:SMBGRangeAnimated--fadein--1Nr5V .25s forwards ease-in-out}.SMBGRangeAnimated--fadeOut--2Evdt{animation:SMBGRangeAnimated--fadeout--2huim .25s forwards ease-in-out}", ""]);
	
	// exports
	exports.locals = {
		"smbgRange": "SMBGRangeAnimated--smbgRange--14DpS",
		"fadeIn": "SMBGRangeAnimated--fadeIn--3XbzN",
		"fadein": "SMBGRangeAnimated--fadein--1Nr5V",
		"fadeOut": "SMBGRangeAnimated--fadeOut--2Evdt",
		"fadeout": "SMBGRangeAnimated--fadeout--2huim"
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGMeanAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(42);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(138);
	
	var _bloodglucose = __webpack_require__(21);
	
	var _constants = __webpack_require__(18);
	
	var _withDefaultYPosition = __webpack_require__(139);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _SMBGMean = __webpack_require__(163);
	
	var _SMBGMean2 = _interopRequireDefault(_SMBGMean);
	
	var _SMBGMeanAnimated = __webpack_require__(164);
	
	var _SMBGMeanAnimated2 = _interopRequireDefault(_SMBGMeanAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGMeanAnimated = exports.SMBGMeanAnimated = function (_PureComponent) {
	  _inherits(SMBGMeanAnimated, _PureComponent);
	
	  function SMBGMeanAnimated(props) {
	    _classCallCheck(this, SMBGMeanAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGMeanAnimated.__proto__ || Object.getPrototypeOf(SMBGMeanAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGMeanAnimated, [{
	    key: 'willEnter',
	    value: function willEnter() {
	      var defaultY = this.props.defaultY;
	
	      return {
	        y: defaultY,
	        height: 0,
	        opacity: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave() {
	      var _props = this.props,
	          defaultY = _props.defaultY,
	          meanHeight = _props.meanHeight;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return {
	        y: (0, _reactMotion.spring)(defaultY, _constants.springConfig),
	        height: (0, _reactMotion.spring)(meanHeight, _constants.springConfig),
	        opacity: shrinkOut
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx,
	          _cx2,
	          _this2 = this;
	
	      var _props2 = this.props,
	          bgBounds = _props2.bgBounds,
	          datum = _props2.datum,
	          defaultY = _props2.defaultY,
	          meanHeight = _props2.meanHeight,
	          meanWidth = _props2.meanWidth,
	          someSmbgDataIsFocused = _props2.someSmbgDataIsFocused,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	
	      var xPos = xScale(datum.msX);
	      var yPositions = {
	        min: yScale(datum.min),
	        mean: yScale(datum.mean),
	        max: yScale(datum.max)
	      };
	
	      var meanClasses = datum.mean ? (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _SMBGMeanAnimated2.default.smbgMean, true), _defineProperty(_cx, _SMBGMeanAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.mean) + 'FadeIn'], !someSmbgDataIsFocused), _defineProperty(_cx, _SMBGMeanAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.mean) + 'FadeOut'], someSmbgDataIsFocused), _cx)) : (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _SMBGMeanAnimated2.default.smbgMean, true), _defineProperty(_cx2, _SMBGMeanAnimated2.default.transparent, true), _cx2));
	
	      var binLeftX = xScale(datum.msX) - meanWidth / 2 + _SMBGMeanAnimated2.default.stroke / 2;
	      var width = meanWidth - _SMBGMeanAnimated2.default.stroke;
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: [{
	            key: datum.id,
	            style: {
	              y: defaultY,
	              height: 0,
	              opacity: 0
	            }
	          }],
	          styles: datum.min ? [{
	            key: datum.id,
	            style: {
	              y: (0, _reactMotion.spring)(yPositions.mean - meanHeight / 2, _constants.springConfig),
	              height: (0, _reactMotion.spring)(meanHeight, _constants.springConfig),
	              opacity: (0, _reactMotion.spring)(1.0, _constants.springConfig)
	            }
	          }] : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolated) {
	          if (interpolated.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(_SMBGMean2.default, {
	            classes: meanClasses,
	            datum: datum,
	            interpolated: interpolated[0],
	            positionData: {
	              left: xPos,
	              tooltipLeft: datum.msX > _this2.props.tooltipLeftThreshold,
	              yPositions: yPositions
	            },
	            width: width,
	            x: binLeftX
	          });
	        }
	      );
	    }
	  }]);
	
	  return SMBGMeanAnimated;
	}(_react.PureComponent);
	
	SMBGMeanAnimated.defaultProps = {
	  meanHeight: 10,
	  meanWidth: 108
	};
	SMBGMeanAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  defaultY: _react.PropTypes.number.isRequired,
	  meanHeight: _react.PropTypes.number.isRequired,
	  meanWidth: _react.PropTypes.number.isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(SMBGMeanAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGMeanAnimated, 'SMBGMeanAnimated', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGMeanAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGMeanAnimated.js');
	})();

	;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGMean = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(46);
	
	var _redux = __webpack_require__(47);
	
	var _trends = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGMean = exports.SMBGMean = function (_PureComponent) {
	  _inherits(SMBGMean, _PureComponent);
	
	  function SMBGMean(props) {
	    _classCallCheck(this, SMBGMean);
	
	    var _this = _possibleConstructorReturn(this, (SMBGMean.__proto__ || Object.getPrototypeOf(SMBGMean)).call(this, props));
	
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGMean, [{
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props = this.props,
	          unfocusRange = _props.unfocusRange,
	          userId = _props.userId;
	
	      unfocusRange(userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props2 = this.props,
	          datum = _props2.datum,
	          focusRange = _props2.focusRange,
	          positionData = _props2.positionData,
	          userId = _props2.userId;
	
	      focusRange(userId, datum, positionData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          classes = _props3.classes,
	          _props3$interpolated = _props3.interpolated,
	          key = _props3$interpolated.key,
	          style = _props3$interpolated.style,
	          width = _props3.width,
	          x = _props3.x;
	
	
	      return _react2.default.createElement('rect', {
	        className: classes,
	        id: 'smbgRange-' + key,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        x: x,
	        y: style.y,
	        width: width,
	        height: style.height,
	        opacity: style.opacity
	      });
	    }
	  }]);
	
	  return SMBGMean;
	}(_react.PureComponent);
	
	SMBGMean.propTypes = {
	  classes: _react.PropTypes.string.isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  focusRange: _react.PropTypes.func.isRequired,
	  interpolated: _react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    style: _react.PropTypes.shape({
	      height: _react.PropTypes.number.isRequired,
	      opacity: _react.PropTypes.number.isRequired,
	      y: _react.PropTypes.number.isRequired
	    }).isRequired
	  }).isRequired,
	  positionData: _react.PropTypes.shape({
	    left: _react.PropTypes.number.isRequired,
	    tooltipLeft: _react.PropTypes.bool.isRequired,
	    yPositions: _react.PropTypes.shape({
	      max: _react.PropTypes.number.isRequired,
	      mean: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired
	    }).isRequired
	  }),
	  unfocusRange: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  x: _react.PropTypes.number.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusRange: _trends.focusTrendsSmbgRangeAvg,
	    unfocusRange: _trends.unfocusTrendsSmbgRangeAvg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGMean);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGMean, 'SMBGMean', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	})();

	;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(165);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGMeanAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGMeanAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(135), undefined);
	
	// module
	exports.push([module.id, ".SMBGMeanAnimated--thickStroke--34Vjn{stroke-width:2}.SMBGMeanAnimated--smbgMean--3F9uQ{stroke:#fff;pointer-events:all}.SMBGMeanAnimated--transparent--1DUTa{fill:transparent}@keyframes SMBGMeanAnimated--fadein--3QUQa{0%{fill-opacity:0}to{fill-opacity:1}}@keyframes SMBGMeanAnimated--fadeout--3R_-Y{0%{fill-opacity:1}to{fill-opacity:0}}.SMBGMeanAnimated--fadeinAnimation--1M4bj{animation:SMBGMeanAnimated--fadein--3QUQa .25s forwards ease-in-out}.SMBGMeanAnimated--fadeoutAnimation--3Y-QY{animation:SMBGMeanAnimated--fadeout--3R_-Y .25s forwards ease-in-out}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"thickStroke": "SMBGMeanAnimated--thickStroke--34Vjn",
		"smbgMean": "SMBGMeanAnimated--smbgMean--3F9uQ SMBGMeanAnimated--thickStroke--34Vjn",
		"transparent": "SMBGMeanAnimated--transparent--1DUTa",
		"fadeinAnimation": "SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"fadein": "SMBGMeanAnimated--fadein--3QUQa",
		"fadeoutAnimation": "SMBGMeanAnimated--fadeoutAnimation--3Y-QY",
		"fadeout": "SMBGMeanAnimated--fadeout--3R_-Y",
		"lowFadeIn": "SMBGMeanAnimated--lowFadeIn--2s5jp " + __webpack_require__(135).locals["bgLow"] + " SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"lowFadeOut": "SMBGMeanAnimated--lowFadeOut--zZ69H " + __webpack_require__(135).locals["bgLow"] + " SMBGMeanAnimated--fadeoutAnimation--3Y-QY",
		"targetFadeIn": "SMBGMeanAnimated--targetFadeIn--2p_H9 " + __webpack_require__(135).locals["bgTarget"] + " SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"targetFadeOut": "SMBGMeanAnimated--targetFadeOut--36SuY " + __webpack_require__(135).locals["bgTarget"] + " SMBGMeanAnimated--fadeoutAnimation--3Y-QY",
		"highFadeIn": "SMBGMeanAnimated--highFadeIn--3oq9e " + __webpack_require__(135).locals["bgHigh"] + " SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"highFadeOut": "SMBGMeanAnimated--highFadeOut--15_FM " + __webpack_require__(135).locals["bgHigh"] + " SMBGMeanAnimated--fadeoutAnimation--3Y-QY"
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _NoData = __webpack_require__(167);
	
	var _NoData2 = _interopRequireDefault(_NoData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoData = function NoData(props) {
	  var dataType = props.dataType,
	      displayTypes = props.displayTypes,
	      messageString = props.messageString,
	      position = props.position,
	      unselectedAllData = props.unselectedAllData,
	      unselectedAllDataString = props.unselectedAllDataString;
	
	  var noDataMessage = _lodash2.default.template(unselectedAllData ? unselectedAllDataString : messageString);
	
	  if (!position) {
	    return null;
	  }
	
	  var displayType = '';
	  if (dataType) {
	    displayType = displayTypes[dataType];
	  }
	
	  return _react2.default.createElement(
	    'text',
	    { className: _NoData2.default.noDataMsg, id: 'noDataMsg', x: position.x, y: position.y },
	    noDataMessage({ displayType: displayType })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	NoData.defaultProps = {
	  displayTypes: { cbg: 'CGM', smbg: 'fingerstick' },
	  messageString: 'There is no <%= displayType %> data for this time period :(',
	  unselectedAllDataString: 'Hang on there, skippy! You unselected all of the data!'
	};
	
	NoData.propTypes = {
	  messageString: _react.PropTypes.string.isRequired,
	  dataType: _react2.default.PropTypes.oneOf(['cbg', 'smbg']).isRequired,
	  displayTypes: _react.PropTypes.object.isRequired,
	  position: _react.PropTypes.shape({
	    x: _react.PropTypes.number.isRequired,
	    y: _react.PropTypes.number.isRequired
	  }).isRequired,
	  unselectedAllData: _react.PropTypes.bool.isRequired,
	  unselectedAllDataString: _react.PropTypes.string.isRequired
	};
	
	var _default = NoData;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NoData, 'NoData', '/Users/krystophv/tidepool/viz/src/components/trends/common/NoData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/NoData.js');
	})();

	;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(168);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./NoData.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./NoData.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"noDataMsg": "NoData--noDataMsg--1dln7 " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["svgMiddleAnchored"] + ""
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TargetRangeLines = __webpack_require__(170);
	
	var _TargetRangeLines2 = _interopRequireDefault(_TargetRangeLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var TargetRangeLines = function TargetRangeLines(props) {
	  var bgBounds = props.bgBounds,
	      smbgOpts = props.smbgOpts,
	      xScale = props.xScale,
	      yScale = props.yScale;
	
	  var x1 = xScale.range()[0] - smbgOpts.maxR;
	  var x2 = xScale.range()[1] + smbgOpts.maxR;
	  return _react2.default.createElement(
	    'g',
	    { id: 'targetRange' },
	    _react2.default.createElement('line', {
	      id: 'highThreshold',
	      className: _TargetRangeLines2.default.targetRangeLine,
	      x1: x1,
	      x2: x2,
	      y1: yScale(bgBounds.targetUpperBound),
	      y2: yScale(bgBounds.targetUpperBound)
	    }),
	    _react2.default.createElement('line', {
	      id: 'lowThreshold',
	      className: _TargetRangeLines2.default.targetRangeLine,
	      x1: x1,
	      x2: x2,
	      y1: yScale(bgBounds.targetLowerBound),
	      y2: yScale(bgBounds.targetLowerBound)
	    })
	  );
	};
	
	TargetRangeLines.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }),
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = TargetRangeLines;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TargetRangeLines, 'TargetRangeLines', '/Users/krystophv/tidepool/viz/src/components/trends/common/TargetRangeLines.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/TargetRangeLines.js');
	})();

	;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(171);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TargetRangeLines.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TargetRangeLines.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".TargetRangeLines--targetRangeLine--3kXJD{pointer-events:none;stroke:#fff;stroke-dasharray:9,9;stroke-width:2px}", ""]);
	
	// exports
	exports.locals = {
		"targetRangeLine": "TargetRangeLines--targetRangeLine--3kXJD"
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(105);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datetime = __webpack_require__(22);
	
	var _XAxisLabels = __webpack_require__(173);
	
	var _XAxisLabels2 = _interopRequireDefault(_XAxisLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XAxisLabels = function XAxisLabels(props) {
	  var data = props.data,
	      margins = props.margins,
	      xOffset = props.xOffset,
	      xScale = props.xScale,
	      yOffset = props.yOffset;
	
	  var yPos = margins.top - yOffset;
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'xAxisLabels' },
	    _lodash2.default.map(data, function (msInDay) {
	      var displayTime = (0, _datetime.formatClocktimeFromMsPer24)(msInDay, 'h a');
	      return _react2.default.createElement(
	        'text',
	        {
	          className: _XAxisLabels2.default.text,
	          key: msInDay,
	          x: xScale(msInDay) + xOffset,
	          y: yPos
	        },
	        displayTime
	      );
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	XAxisLabels.defaultProps = {
	  data: _lodash2.default.map((0, _d3Array.range)(0, 8), function (i) {
	    return i * _datetime.THREE_HRS;
	  }),
	  xOffset: 5,
	  yOffset: 5
	};
	
	XAxisLabels.propTypes = {
	  data: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  xOffset: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yOffset: _react.PropTypes.number.isRequired
	};
	
	var _default = XAxisLabels;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(XAxisLabels, 'XAxisLabels', '/Users/krystophv/tidepool/viz/src/components/trends/common/XAxisLabels.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/XAxisLabels.js');
	})();

	;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(174);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisLabels.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisLabels.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"text": "XAxisLabels--text--3kSBO " + __webpack_require__(10).locals["axisSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["svgStartAnchored"] + "",
		"focusedRange": "XAxisLabels--focusedRange--181Td " + __webpack_require__(10).locals["axisSize"] + " " + __webpack_require__(10).locals["boldText"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["svgStartAnchored"] + ""
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(105);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datetime = __webpack_require__(22);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _XAxisTicks = __webpack_require__(176);
	
	var _XAxisTicks2 = _interopRequireDefault(_XAxisTicks);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XAxisTicks = function XAxisTicks(props) {
	  var data = props.data,
	      margins = props.margins,
	      tickLength = props.tickLength,
	      xScale = props.xScale;
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'xAxisTicks' },
	    _lodash2.default.map(data, function (msInDay) {
	      return _react2.default.createElement('line', {
	        className: _XAxisTicks2.default.tick,
	        key: msInDay,
	        x1: xScale(msInDay),
	        x2: xScale(msInDay),
	        y1: margins.top,
	        y2: margins.top - tickLength
	      });
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	XAxisTicks.defaultProps = {
	  data: _lodash2.default.map((0, _d3Array.range)(0, 9), function (i) {
	    return i * datetime.THREE_HRS;
	  }),
	  tickLength: 15
	};
	
	XAxisTicks.propTypes = {
	  data: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  tickLength: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired
	};
	
	var _default = XAxisTicks;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(XAxisTicks, 'XAxisTicks', '/Users/krystophv/tidepool/viz/src/components/trends/common/XAxisTicks.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/XAxisTicks.js');
	})();

	;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(177);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisTicks.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisTicks.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	
	
	// module
	exports.push([module.id, ".XAxisTicks--tick--OEdi5{stroke:var(--axis-tick)}", ""]);
	
	// exports
	exports.locals = {
		"tick": "XAxisTicks--tick--OEdi5"
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(18);
	
	var _format = __webpack_require__(19);
	
	var _YAxisLabelsAndTicks = __webpack_require__(179);
	
	var _YAxisLabelsAndTicks2 = _interopRequireDefault(_YAxisLabelsAndTicks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YAxisLabels = function YAxisLabels(props) {
	  var bgPrefs = props.bgPrefs,
	      margins = props.margins,
	      textToTickGap = props.textToTickGap,
	      tickWidth = props.tickWidth,
	      yScale = props.yScale;
	  var bgBounds = bgPrefs.bgBounds;
	
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'yAxisLabels' },
	    _lodash2.default.map(['targetLowerBound', 'targetUpperBound', 'veryHighThreshold', 'veryLowThreshold'], function (boundKey) {
	      return _react2.default.createElement(
	        'g',
	        { id: 'yAxisLabel', key: boundKey },
	        _react2.default.createElement(
	          'text',
	          {
	            className: _YAxisLabelsAndTicks2.default.text,
	            x: margins.left - tickWidth - textToTickGap,
	            y: yScale(bgBounds[boundKey])
	          },
	          (0, _format.formatBgValue)(bgBounds[boundKey], bgPrefs)
	        ),
	        _react2.default.createElement('line', {
	          className: _YAxisLabelsAndTicks2.default.tick,
	          x1: margins.left - tickWidth,
	          x2: margins.left,
	          y1: yScale(bgBounds[boundKey]),
	          y2: yScale(bgBounds[boundKey])
	        })
	      );
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	YAxisLabels.defaultProps = {
	  textToTickGap: 2,
	  tickWidth: 8
	};
	
	YAxisLabels.propTypes = {
	  bgPrefs: _react.PropTypes.shape({
	    bgBounds: _react.PropTypes.shape({
	      veryHighThreshold: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired,
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      veryLowThreshold: _react.PropTypes.number.isRequired
	    }),
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }),
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  textToTickGap: _react.PropTypes.number.isRequired,
	  tickWidth: _react.PropTypes.number.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = YAxisLabels;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(YAxisLabels, 'YAxisLabels', '/Users/krystophv/tidepool/viz/src/components/trends/common/YAxisLabelsAndTicks.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/trends/common/YAxisLabelsAndTicks.js');
	})();

	;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(180);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./YAxisLabelsAndTicks.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./YAxisLabelsAndTicks.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".YAxisLabelsAndTicks--tick--2lY4A{stroke:var(--axis-tick)}", ""]);
	
	// exports
	exports.locals = {
		"text": "YAxisLabelsAndTicks--text--1KdFh " + __webpack_require__(10).locals["axisSize"] + " " + __webpack_require__(10).locals["mediumContrastText"] + " " + __webpack_require__(10).locals["svgRightAnchored"] + " " + __webpack_require__(10).locals["svgVerticalCentered"] + "",
		"tick": "YAxisLabelsAndTicks--tick--2lY4A"
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bolus = __webpack_require__(182);
	
	var bolusUtils = _interopRequireWildcard(_bolus);
	
	var _datetime = __webpack_require__(22);
	
	var _format = __webpack_require__(19);
	
	var _annotations = __webpack_require__(34);
	
	var _Tooltip = __webpack_require__(4);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _colors = __webpack_require__(35);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _BolusTooltip = __webpack_require__(183);
	
	var _BolusTooltip2 = _interopRequireDefault(_BolusTooltip);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var BolusTooltip = function (_PureComponent) {
	  _inherits(BolusTooltip, _PureComponent);
	
	  function BolusTooltip() {
	    _classCallCheck(this, BolusTooltip);
	
	    return _possibleConstructorReturn(this, (BolusTooltip.__proto__ || Object.getPrototypeOf(BolusTooltip)).apply(this, arguments));
	  }
	
	  _createClass(BolusTooltip, [{
	    key: 'formatBgValue',
	    value: function formatBgValue(val) {
	      return (0, _format.formatBgValue)(val, this.props.bgPrefs);
	    }
	  }, {
	    key: 'isAnimasExtended',
	    value: function isAnimasExtended() {
	      var annotations = bolusUtils.getAnnotations(this.props.bolus);
	      var isAnimasExtended = _lodash2.default.findIndex(annotations, { code: 'animas/bolus/extended-equal-split' }) !== -1;
	      return isAnimasExtended;
	    }
	  }, {
	    key: 'animasExtendedAnnotationMessage',
	    value: function animasExtendedAnnotationMessage() {
	      var content = null;
	      if (this.isAnimasExtended()) {
	        var messages = (0, _annotations.getAnnotationMessages)(bolusUtils.getBolusFromInsulinEvent(this.props.bolus));
	        content = _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.annotation },
	          _lodash2.default.find(messages, { code: 'animas/bolus/extended-equal-split' }).message.value
	        );
	      }
	      return content;
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var wizardTarget = _lodash2.default.get(this.props.bolus, 'bgTarget');
	      var target = _lodash2.default.get(wizardTarget, 'target', null);
	      var targetLow = _lodash2.default.get(wizardTarget, 'low', null);
	      var targetHigh = _lodash2.default.get(wizardTarget, 'high', null);
	      var targetRange = _lodash2.default.get(wizardTarget, 'range', null);
	      var isAutomatedTarget = _lodash2.default.findIndex(_lodash2.default.get(this.props.bolus, 'annotations', []), {
	        code: 'wizard/target-automated'
	      }) !== -1;
	      if (isAutomatedTarget) {
	        return _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.target },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Target'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            'Auto'
	          ),
	          _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	        );
	      }
	      if (targetLow) {
	        // medtronic
	        var value = void 0;
	        if (targetLow === targetHigh) {
	          value = '' + this.formatBgValue(targetLow);
	        } else {
	          value = this.formatBgValue(targetLow) + '-' + this.formatBgValue(targetHigh);
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.target },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Target'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            value
	          ),
	          _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	        );
	      }
	      if (targetRange) {
	        // animas
	        return [_react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.target, key: 'target' },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Target'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            '' + this.formatBgValue(target)
	          ),
	          _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	        ), _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.target, key: 'range' },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Range'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            '' + this.formatBgValue(targetRange)
	          ),
	          _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	        )];
	      }
	      if (targetHigh) {
	        // insulet
	        return [_react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.target, key: 'target' },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Target'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            '' + this.formatBgValue(target)
	          ),
	          _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	        ), _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.target, key: 'high' },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'High'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            '' + this.formatBgValue(targetHigh)
	          ),
	          _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	        )];
	      }
	      // tandem
	      return _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.target },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Target'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '' + this.formatBgValue(target)
	        ),
	        _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	      );
	    }
	  }, {
	    key: 'getExtended',
	    value: function getExtended() {
	      var bolus = bolusUtils.getBolusFromInsulinEvent(this.props.bolus);
	      var hasExtended = bolusUtils.hasExtended(bolus);
	      var normalPercentage = bolusUtils.getNormalPercentage(bolus);
	      var normal = _lodash2.default.get(bolus, 'normal', NaN);
	      var isAnimasExtended = this.isAnimasExtended();
	      var extendedPercentage = _lodash2.default.isNaN(bolusUtils.getExtendedPercentage(bolus)) ? '' : '(' + bolusUtils.getExtendedPercentage(bolus) + ')';
	      var extendedLine = null;
	      if (hasExtended) {
	        if (isAnimasExtended) {
	          extendedLine = _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.extended },
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.label },
	              'Extended Over*'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.value },
	              (0, _datetime.formatDuration)(bolusUtils.getDuration(bolus))
	            )
	          );
	        } else {
	          extendedLine = [!!normal && _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.normal, key: 'normal' },
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.label },
	              'Up Front (' + normalPercentage + ')'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.value },
	              '' + (0, _format.formatInsulin)(normal)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.units },
	              'U'
	            )
	          ), _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.extended, key: 'extended' },
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.label },
	              'Over ' + (0, _datetime.formatDuration)(bolusUtils.getDuration(bolus)) + ' ' + extendedPercentage
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.value },
	              '' + (0, _format.formatInsulin)(bolusUtils.getExtended(bolus))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BolusTooltip2.default.units },
	              'U'
	            )
	          )];
	        }
	      }
	      return extendedLine;
	    }
	  }, {
	    key: 'renderWizard',
	    value: function renderWizard() {
	      var wizard = this.props.bolus;
	      var recommended = bolusUtils.getRecommended(wizard);
	      var suggested = _lodash2.default.isFinite(recommended) ? '' + recommended : null;
	      var bg = _lodash2.default.get(wizard, 'bgInput', null);
	      var iob = _lodash2.default.get(wizard, 'insulinOnBoard', null);
	      var carbs = bolusUtils.getCarbs(wizard);
	      var carbsInput = _lodash2.default.isFinite(carbs) && carbs > 0;
	      var carbRatio = _lodash2.default.get(wizard, 'insulinCarbRatio', null);
	      var isf = _lodash2.default.get(wizard, 'insulinSensitivity', null);
	      var delivered = bolusUtils.getDelivered(wizard);
	      var isInterrupted = bolusUtils.isInterruptedBolus(wizard);
	      var programmed = bolusUtils.getProgrammed(wizard);
	      var hasExtended = bolusUtils.hasExtended(wizard);
	      var isAnimasExtended = this.isAnimasExtended();
	
	      var overrideLine = null;
	      if (bolusUtils.isOverride(wizard)) {
	        overrideLine = _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.override },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Override'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            '+' + (0, _format.formatInsulin)(programmed - recommended)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.units },
	            'U'
	          )
	        );
	      }
	      if (bolusUtils.isUnderride(wizard)) {
	        overrideLine = _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.override },
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.label },
	            'Underride'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.value },
	            '-' + (0, _format.formatInsulin)(recommended - programmed)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BolusTooltip2.default.units },
	            'U'
	          )
	        );
	      }
	      var deliveredLine = _lodash2.default.isFinite(delivered) && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.delivered },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Delivered'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '' + (0, _format.formatInsulin)(delivered)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	      var suggestedLine = (isInterrupted || overrideLine) && !!suggested && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.suggested },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Suggested'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          (0, _format.formatInsulin)(suggested)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	      var bgLine = !!bg && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.bg },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'BG'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          this.formatBgValue(bg)
	        ),
	        _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	      );
	      var carbsLine = !!carbs && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.carbs },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Carbs'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          carbs
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'g'
	        )
	      );
	      var iobLine = !!iob && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.iob },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'IOB'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '' + (0, _format.formatInsulin)(iob)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	      var interruptedLine = isInterrupted && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.interrupted },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Interrupted'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '-' + (0, _format.formatInsulin)(programmed - delivered)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	      var icRatioLine = !!carbsInput && !!carbRatio && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.carbRatio },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'I:C Ratio'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '1:' + carbRatio
	        ),
	        _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	      );
	      var isfLine = !!isf && !!bg && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.isf },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'ISF'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '' + this.formatBgValue(isf)
	        ),
	        _react2.default.createElement('div', { className: _BolusTooltip2.default.units })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.container },
	        bgLine,
	        carbsLine,
	        iobLine,
	        suggestedLine,
	        this.getExtended(),
	        (isInterrupted || overrideLine || hasExtended) && _react2.default.createElement('div', { className: _BolusTooltip2.default.dividerSmall }),
	        overrideLine,
	        interruptedLine,
	        deliveredLine,
	        (icRatioLine || isfLine || bg || isAnimasExtended) && _react2.default.createElement('div', { className: _BolusTooltip2.default.dividerLarge }),
	        icRatioLine,
	        isfLine,
	        !!bg && this.getTarget(),
	        this.animasExtendedAnnotationMessage()
	      );
	    }
	  }, {
	    key: 'renderNormal',
	    value: function renderNormal() {
	      var bolus = this.props.bolus;
	      var delivered = bolusUtils.getDelivered(bolus);
	      var isInterrupted = bolusUtils.isInterruptedBolus(bolus);
	      var programmed = bolusUtils.getProgrammed(bolus);
	      var isAnimasExtended = this.isAnimasExtended();
	
	      var deliveredLine = _lodash2.default.isFinite(delivered) && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.delivered },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Delivered'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '' + (0, _format.formatInsulin)(delivered)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	      var interruptedLine = isInterrupted && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.interrupted },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Interrupted'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '-' + (0, _format.formatInsulin)(programmed - delivered)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	      var programmedLine = isInterrupted && !!programmed && _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.programmed },
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.label },
	          'Programmed'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.value },
	          '' + (0, _format.formatInsulin)(programmed)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BolusTooltip2.default.units },
	          'U'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.container },
	        programmedLine,
	        interruptedLine,
	        deliveredLine,
	        this.getExtended(),
	        isAnimasExtended && _react2.default.createElement('div', { className: _BolusTooltip2.default.dividerLarge }),
	        this.animasExtendedAnnotationMessage()
	      );
	    }
	  }, {
	    key: 'renderBolus',
	    value: function renderBolus() {
	      var content = void 0;
	      if (this.props.bolus.type === 'wizard') {
	        content = this.renderWizard();
	      } else {
	        content = this.renderNormal();
	      }
	      return content;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = _react2.default.createElement(
	        'div',
	        { className: _BolusTooltip2.default.title },
	        (0, _datetime.formatLocalizedFromUTC)(this.props.bolus.normalTime, this.props.timePrefs, 'h:mm a')
	      );
	      return _react2.default.createElement(_Tooltip2.default, _extends({}, this.props, { title: title, content: this.renderBolus() }));
	    }
	  }]);
	
	  return BolusTooltip;
	}(_react.PureComponent);
	
	BolusTooltip.propTypes = {
	  position: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  offset: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number,
	    horizontal: _react.PropTypes.number
	  }),
	  tail: _react.PropTypes.bool.isRequired,
	  side: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
	  tailColor: _react.PropTypes.string.isRequired,
	  tailWidth: _react.PropTypes.number.isRequired,
	  tailHeight: _react.PropTypes.number.isRequired,
	  backgroundColor: _react.PropTypes.string,
	  borderColor: _react.PropTypes.string.isRequired,
	  borderWidth: _react.PropTypes.number.isRequired,
	  bolus: _react.PropTypes.shape({
	    type: _react.PropTypes.string.isRequired
	  }).isRequired,
	  bgPrefs: _react.PropTypes.object.isRequired,
	  timePrefs: _react.PropTypes.object.isRequired
	};
	
	BolusTooltip.defaultProps = {
	  tail: true,
	  side: 'right',
	  tailWidth: 9,
	  tailHeight: 17,
	  tailColor: _colors2.default.bolus,
	  borderColor: _colors2.default.bolus,
	  borderWidth: 2
	};
	
	var _default = BolusTooltip;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BolusTooltip, 'BolusTooltip', '/Users/krystophv/tidepool/viz/src/components/daily/bolustooltip/BolusTooltip.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/components/daily/bolustooltip/BolusTooltip.js');
	})();

	;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBolusFromInsulinEvent = getBolusFromInsulinEvent;
	exports.getCarbs = getCarbs;
	exports.getProgrammed = getProgrammed;
	exports.getRecommended = getRecommended;
	exports.getDelivered = getDelivered;
	exports.getDuration = getDuration;
	exports.getExtended = getExtended;
	exports.getExtendedPercentage = getExtendedPercentage;
	exports.getMaxDuration = getMaxDuration;
	exports.getMaxValue = getMaxValue;
	exports.getNormalPercentage = getNormalPercentage;
	exports.getTotalBolus = getTotalBolus;
	exports.getTotalCarbs = getTotalCarbs;
	exports.hasExtended = hasExtended;
	exports.isInterruptedBolus = isInterruptedBolus;
	exports.isOverride = isOverride;
	exports.isUnderride = isUnderride;
	exports.getAnnotations = getAnnotations;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _format = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * fixFloatingPoint
	 * @param {Number} numeric value
	 *
	 * @return {Number} numeric value rounded to 3 decimal places
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	/* the logic here (and the tests) are a port of tideline's
	   js/plot/util/commonbolus.js */
	
	function fixFloatingPoint(n) {
	  return parseFloat((0, _format.formatDecimalNumber)(n, 3));
	}
	
	/**
	 * getBolusFromInsulinEvent
	 * @param {Object} insulinEvent - a Tidepool wizard or bolus object
	 *
	 * @return {Object} a Tidepool bolus object
	 */
	function getBolusFromInsulinEvent(insulinEvent) {
	  var bolus = insulinEvent;
	  if (insulinEvent.bolus) {
	    bolus = insulinEvent.bolus;
	  }
	  return bolus;
	}
	
	/**
	 * getCarbs
	 * @param {Object} insulinEvent - a Tidepool wizard or bolus object
	 *
	 * @return {Number} grams of carbs input into bolus calculator
	 *                  NaN if bolus calculator not used; null if no carbInput
	 */
	function getCarbs(insulinEvent) {
	  if (insulinEvent.type !== 'wizard') {
	    return NaN;
	  }
	  return _lodash2.default.get(insulinEvent, 'carbInput', null);
	}
	
	/**
	 * getProgrammed
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Number} value of insulin programmed for delivery in the given insulinEvent
	 */
	function getProgrammed(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	    if (!_lodash2.default.inRange(bolus.normal, Infinity) && !_lodash2.default.inRange(bolus.extended, Infinity)) {
	      return NaN;
	    }
	  }
	  if (bolus.extended != null && bolus.expectedExtended != null) {
	    if (bolus.normal != null) {
	      if (bolus.expectedNormal != null) {
	        return fixFloatingPoint(bolus.expectedNormal + bolus.expectedExtended);
	      }
	      return fixFloatingPoint(bolus.normal + bolus.expectedExtended);
	    }
	    return bolus.expectedExtended;
	  } else if (bolus.extended != null) {
	    if (bolus.normal != null) {
	      if (bolus.expectedNormal != null) {
	        // this situation should not exist!
	        throw new Error('Combo bolus found with a cancelled `normal` portion and non-cancelled `extended`!');
	      }
	      return fixFloatingPoint(bolus.normal + bolus.extended);
	    }
	    return bolus.extended;
	  }
	  return bolus.expectedNormal || bolus.normal;
	}
	
	/**
	 * getRecommended
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Number} total recommended insulin dose
	 */
	function getRecommended(insulinEvent) {
	  // a simple manual/"quick" bolus won't have a `recommended` field
	  if (!insulinEvent.recommended) {
	    return NaN;
	  }
	  var netRecommendation = _lodash2.default.get(insulinEvent, ['recommended', 'net'], null);
	  if (netRecommendation !== null) {
	    return netRecommendation;
	  }
	  var rec = 0;
	  rec += _lodash2.default.get(insulinEvent, ['recommended', 'carb'], 0);
	  rec += _lodash2.default.get(insulinEvent, ['recommended', 'correction'], 0);
	
	  return fixFloatingPoint(rec);
	}
	
	/**
	 * getDelivered
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Number} units of insulin delivered in this insulinEvent
	 */
	function getDelivered(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	    if (!_lodash2.default.inRange(bolus.normal, Infinity) && !_lodash2.default.inRange(bolus.extended, Infinity)) {
	      return NaN;
	    }
	  }
	  if (bolus.extended != null) {
	    if (bolus.normal != null) {
	      return fixFloatingPoint(bolus.extended + bolus.normal);
	    }
	    return bolus.extended;
	  }
	  return bolus.normal;
	}
	
	/**
	 * getDuration
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Number} duration value in milliseconds
	 */
	function getDuration(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	  }
	  // don't want truthiness here because want to return duration
	  // from a bolus interrupted immediately (duration = 0)
	  if (!_lodash2.default.inRange(bolus.duration, Infinity)) {
	    return NaN;
	  }
	  return bolus.duration;
	}
	
	/**
	 * getExtended
	 * @param {Object} insulinEvent - a Tidepool wizard or bolus object
	 *
	 * @return {Number} units of insulin delivered over an extended duration
	 */
	function getExtended(insulinEvent) {
	  var bolus = getBolusFromInsulinEvent(insulinEvent);
	
	  // don't want truthiness here because want to return expectedExtended
	  // from a bolus interrupted immediately (extended = 0)
	  if (!_lodash2.default.inRange(bolus.extended, Infinity)) {
	    return NaN;
	  }
	
	  return bolus.extended;
	}
	
	/**
	 * getExtendedPercentage
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {String} percentage of combo bolus delivered later
	 */
	function getExtendedPercentage(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	  }
	  if (!bolus.normal || !(bolus.extended || bolus.expectedExtended)) {
	    return NaN;
	  }
	  var extended = bolus.expectedExtended || bolus.extended;
	  var programmed = getProgrammed(bolus);
	  return (0, _format.formatPercentage)(extended / programmed);
	}
	
	/**
	 * getMaxDuration
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Number} duration value in milliseconds
	 */
	function getMaxDuration(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	  }
	  // don't want truthiness here because want to return expectedDuration
	  // from a bolus interrupted immediately (duration = 0)
	  if (!_lodash2.default.inRange(bolus.duration, Infinity)) {
	    return NaN;
	  }
	  return bolus.expectedDuration || bolus.duration;
	}
	
	/**
	 * getMaxValue
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Number} max programmed or recommended value wrt the insulinEvent
	 */
	function getMaxValue(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	    if (!bolus.normal && !bolus.extended) {
	      return NaN;
	    }
	  }
	  var programmed = getProgrammed(bolus);
	  var recommended = getRecommended(insulinEvent) || 0;
	  return recommended > programmed ? recommended : programmed;
	}
	
	/**
	 * getNormalPercentage
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {String} percentage of combo bolus delivered immediately
	 */
	function getNormalPercentage(insulinEvent) {
	  var bolus = insulinEvent;
	  if (_lodash2.default.get(insulinEvent, 'type') === 'wizard') {
	    bolus = getBolusFromInsulinEvent(insulinEvent);
	  }
	  if (!(bolus.normal || bolus.expectedNormal) || !(bolus.extended || bolus.expectedExtended)) {
	    return NaN;
	  }
	  var normal = bolus.expectedNormal || bolus.normal;
	  var programmed = getProgrammed(bolus);
	  return (0, _format.formatPercentage)(normal / programmed);
	}
	
	/**
	 * getTotalBolus
	 * @param {Array} insulinEvents - Array of Tidepool bolus or wizard objects
	 *
	 * @return {Number} total bolus insulin in units
	 */
	function getTotalBolus(insulinEvents) {
	  return _lodash2.default.reduce(insulinEvents, function (result, insulinEvent) {
	    return result + getDelivered(insulinEvent);
	  }, 0);
	}
	
	/**
	 * getTotalCarbs
	 * @param {Array} insulinEvents - Array of Tidepool bolus or wizard objects
	 *
	 * @return {Number} total of carbs input into bolus calculator
	 */
	function getTotalCarbs(insulinEvents) {
	  return _lodash2.default.reduce(insulinEvents, function (result, insulinEvent) {
	    var carbs = getCarbs(insulinEvent);
	    return result + (_lodash2.default.inRange(carbs, Infinity) ? carbs : 0);
	  }, 0);
	}
	
	/**
	 * hasExtended
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Boolean} whether the bolus has an extended delivery portion
	 */
	function hasExtended(insulinEvent) {
	  var bolus = getBolusFromInsulinEvent(insulinEvent);
	
	  // NB: intentionally invoking truthiness here
	  // a bolus with `extended` value 0 and `expectedExtended` value 0 is pointless to render
	  return Boolean(bolus.extended || bolus.expectedExtended) || false;
	}
	
	/**
	 * isInterruptedBolus
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Boolean} whether the bolus was interrupted or not
	 */
	function isInterruptedBolus(insulinEvent) {
	  var bolus = getBolusFromInsulinEvent(insulinEvent);
	
	  var cancelledDuringNormal = Boolean(bolus.normal != null && bolus.expectedNormal && bolus.normal !== bolus.expectedNormal);
	
	  var cancelledDuringExtended = Boolean(bolus.extended != null && bolus.expectedExtended && bolus.extended !== bolus.expectedExtended);
	
	  if (_lodash2.default.inRange(bolus.normal, Infinity)) {
	    if (!bolus.extended) {
	      return cancelledDuringNormal;
	    }
	    return cancelledDuringNormal || cancelledDuringExtended;
	  }
	  return cancelledDuringExtended;
	}
	
	/**
	 * isOverride
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Boolean} whether the bolus programmed was larger than the calculated recommendation
	 */
	function isOverride(insulinEvent) {
	  return getRecommended(insulinEvent) < getProgrammed(insulinEvent);
	}
	
	/**
	 * isUnderride
	 * @param {Object} insulinEvent - a Tidepool bolus or wizard object
	 *
	 * @return {Boolean} whether the bolus programmed was smaller than the calculated recommendation
	 */
	function isUnderride(insulinEvent) {
	  return getRecommended(insulinEvent) > getProgrammed(insulinEvent);
	}
	
	/**
	 * getAnnoations
	 * @param {Object} insulinEvent - a Tidebool bolus or wizard object
	 *
	 * @returns {Array} array of annotations for the bolus or an empty array
	 */
	function getAnnotations(insulinEvent) {
	  var bolus = getBolusFromInsulinEvent(insulinEvent);
	  var annotations = _lodash2.default.get(bolus, 'annotations', []);
	  return annotations;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fixFloatingPoint, 'fixFloatingPoint', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getBolusFromInsulinEvent, 'getBolusFromInsulinEvent', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getCarbs, 'getCarbs', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getProgrammed, 'getProgrammed', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getRecommended, 'getRecommended', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getDelivered, 'getDelivered', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getDuration, 'getDuration', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getExtended, 'getExtended', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getExtendedPercentage, 'getExtendedPercentage', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getMaxDuration, 'getMaxDuration', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getMaxValue, 'getMaxValue', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getNormalPercentage, 'getNormalPercentage', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getTotalBolus, 'getTotalBolus', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getTotalCarbs, 'getTotalCarbs', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(hasExtended, 'hasExtended', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(isInterruptedBolus, 'isInterruptedBolus', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(isOverride, 'isOverride', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(isUnderride, 'isUnderride', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	
	  __REACT_HOT_LOADER__.register(getAnnotations, 'getAnnotations', '/Users/krystophv/tidepool/viz/src/utils/bolus.js');
	})();

	;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(184);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./BolusTooltip.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./BolusTooltip.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	// imports
	exports.i(__webpack_require__(36), "");
	exports.i(__webpack_require__(10), undefined);
	
	// module
	exports.push([module.id, ".BolusTooltip--container--167gw{opacity:1;display:flex;flex-direction:column;min-width:160px;margin:2px 0;max-width:180px}.BolusTooltip--row--1jm89{display:flex;flex-direction:row;justify-content:space-between;line-height:20px}.BolusTooltip--label--3U6Co{flex-grow:1}.BolusTooltip--value--CjDYe{margin-left:20px}.BolusTooltip--units--3WdXa{min-width:.7em;margin-left:10px}.BolusTooltip--title--XTRD4{text-align:right}.BolusTooltip--delivered--3b0OB,.BolusTooltip--suggested--K26R-{font-weight:700}.BolusTooltip--override--aYOrH{color:var(--bolus--ride);font-weight:700}.BolusTooltip--interrupted--2vwB_{color:var(--bolus--interrupted);font-weight:700}.BolusTooltip--extended--3RKeZ,.BolusTooltip--normal--12S2B{color:var(--gray-medium)}.BolusTooltip--dividerSmall--2H8yA{background-color:var(--bolus);height:2px;margin:5px -10px}.BolusTooltip--dividerLarge--3jWD6{background-color:var(--bolus);height:4px;margin:5px -10px}", ""]);
	
	// exports
	exports.locals = {
		"container": "BolusTooltip--container--167gw",
		"row": "BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"label": "BolusTooltip--label--3U6Co",
		"value": "BolusTooltip--value--CjDYe",
		"units": "BolusTooltip--units--3WdXa",
		"title": "BolusTooltip--title--XTRD4 " + __webpack_require__(10).locals["smallSize"] + "",
		"suggested": "BolusTooltip--suggested--K26R- BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"delivered": "BolusTooltip--delivered--3b0OB BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"override": "BolusTooltip--override--aYOrH BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"interrupted": "BolusTooltip--interrupted--2vwB_ BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"normal": "BolusTooltip--normal--12S2B BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"extended": "BolusTooltip--extended--3RKeZ BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"programmed": "BolusTooltip--programmed--1TYwP BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"carbs": "BolusTooltip--carbs--2W3-j BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"bg": "BolusTooltip--bg--2LtLN BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"iob": "BolusTooltip--iob--4ru_N BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"target": "BolusTooltip--target--Md26g BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"isf": "BolusTooltip--isf--3JDIt BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"carbRatio": "BolusTooltip--carbRatio--mE8oW BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"annotation": "BolusTooltip--annotation--3Y_ay BolusTooltip--row--1jm89 " + __webpack_require__(10).locals["smallSize"] + "",
		"dividerSmall": "BolusTooltip--dividerSmall--2H8yA",
		"dividerLarge": "BolusTooltip--dividerLarge--3jWD6"
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(47);
	
	var _trendsStateByUser = __webpack_require__(186);
	
	var _trendsStateByUser2 = _interopRequireDefault(_trendsStateByUser);
	
	var _settingsStateByUser = __webpack_require__(188);
	
	var _settingsStateByUser2 = _interopRequireDefault(_settingsStateByUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _redux.combineReducers)({ settings: _settingsStateByUser2.default, trends: _trendsStateByUser2.default }); /*
	                                                                                                                               * == BSD2 LICENSE ==
	                                                                                                                               * Copyright (c) 2016, Tidepool Project
	                                                                                                                               *
	                                                                                                                               * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                               * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                               * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                               *
	                                                                                                                               * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                               * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                               * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                               *
	                                                                                                                               * You should have received a copy of the License along with this program; if
	                                                                                                                               * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                               * == BSD2 LICENSE ==
	                                                                                                                               */

	exports.default = _default;
	;

	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/redux/reducers/index.js');
	})();

	;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CBG_FLAGS, _initialState;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactAddonsUpdate = __webpack_require__(187);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _actionTypes = __webpack_require__(51);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var CBG_FLAGS = 'cbgFlags';
	var CBG_100_ENABLED = 'cbg100Enabled';
	var CBG_80_ENABLED = 'cbg80Enabled';
	var CBG_50_ENABLED = 'cbg50Enabled';
	var CBG_MEDIAN_ENABLED = 'cbgMedianEnabled';
	var FOCUSED_CBG_DATE_TRACE = 'focusedCbgDateTrace';
	var FOCUSED_CBG_SLICE = 'focusedCbgSlice';
	var FOCUSED_CBG_KEYS = 'focusedCbgSliceKeys';
	var FOCUSED_SMBG = 'focusedSmbg';
	var FOCUSED_SMBG_RANGE_AVG = 'focusedSmbgRangeAvg';
	var SHOW_CBG_DATE_TRACES = 'showingCbgDateTraces';
	var TOUCHED = 'touched';
	
	var CBG_FLAG_MAP = {
	  100: CBG_100_ENABLED,
	  80: CBG_80_ENABLED,
	  50: CBG_50_ENABLED,
	  median: CBG_MEDIAN_ENABLED
	};
	
	var initialState = (_initialState = {}, _defineProperty(_initialState, CBG_FLAGS, (_CBG_FLAGS = {}, _defineProperty(_CBG_FLAGS, CBG_100_ENABLED, true), _defineProperty(_CBG_FLAGS, CBG_80_ENABLED, true), _defineProperty(_CBG_FLAGS, CBG_50_ENABLED, true), _defineProperty(_CBG_FLAGS, CBG_MEDIAN_ENABLED, true), _CBG_FLAGS)), _defineProperty(_initialState, FOCUSED_CBG_DATE_TRACE, null), _defineProperty(_initialState, FOCUSED_CBG_SLICE, null), _defineProperty(_initialState, FOCUSED_CBG_KEYS, null), _defineProperty(_initialState, FOCUSED_SMBG, null), _defineProperty(_initialState, FOCUSED_SMBG_RANGE_AVG, null), _defineProperty(_initialState, SHOW_CBG_DATE_TRACES, false), _defineProperty(_initialState, TOUCHED, false), _initialState);
	
	var trendsStateByUser = function trendsStateByUser() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.FETCH_PATIENT_DATA_SUCCESS:
	      {
	        var userId = action.payload.patientId;
	
	        if (state[userId]) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, userId, { $set: _lodash2.default.assign({}, initialState) }));
	      }
	    case actionTypes.FOCUS_TRENDS_CBG_DATE_TRACE:
	      {
	        var _action$payload = action.payload,
	            _userId = _action$payload.userId,
	            data = _action$payload.cbgDatum,
	            position = _action$payload.cbgPosition;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId, _defineProperty({}, FOCUSED_CBG_DATE_TRACE, { $set: { data: data, position: position } })));
	      }
	    case actionTypes.FOCUS_TRENDS_CBG_SLICE:
	      {
	        var _userId4;
	
	        var _action$payload2 = action.payload,
	            focusedKeys = _action$payload2.focusedKeys,
	            _data = _action$payload2.sliceData,
	            _position = _action$payload2.slicePosition,
	            _userId3 = _action$payload2.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId3, (_userId4 = {}, _defineProperty(_userId4, FOCUSED_CBG_SLICE, { $set: { data: _data, position: _position } }), _defineProperty(_userId4, FOCUSED_CBG_KEYS, { $set: focusedKeys }), _userId4)));
	      }
	    case actionTypes.FOCUS_TRENDS_SMBG:
	      {
	        var _action$payload3 = action.payload,
	            datum = _action$payload3.smbgDatum,
	            _position2 = _action$payload3.smbgPosition,
	            _userId5 = _action$payload3.userId,
	            allSmbgsOnDate = _action$payload3.allSmbgsOnDate,
	            allPositions = _action$payload3.allPositions,
	            date = _action$payload3.date;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId5, _defineProperty({}, FOCUSED_SMBG, { $set: { datum: datum, position: _position2, allSmbgsOnDate: allSmbgsOnDate, allPositions: allPositions, date: date } })));
	      }
	    case actionTypes.FOCUS_TRENDS_SMBG_RANGE_AVG:
	      {
	        var _action$payload4 = action.payload,
	            _data2 = _action$payload4.rangeAvgData,
	            _position3 = _action$payload4.rangeAvgPosition,
	            _userId7 = _action$payload4.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId7, _defineProperty({}, FOCUSED_SMBG_RANGE_AVG, { $set: { data: _data2, position: _position3 } })));
	      }
	    case actionTypes.LOGOUT_REQUEST:
	      return {};
	    case actionTypes.MARK_TRENDS_VIEWED:
	      {
	        var _userId9 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId9, _defineProperty({}, TOUCHED, { $set: true })));
	      }
	    case actionTypes.SHOW_CBG_DATE_TRACES:
	      {
	        var _userId11 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId11, _defineProperty({}, SHOW_CBG_DATE_TRACES, { $set: true })));
	      }
	    case actionTypes.TURN_OFF_CBG_RANGE:
	      {
	        var _action$payload5 = action.payload,
	            _userId13 = _action$payload5.userId,
	            range = _action$payload5.range;
	
	        var key = _lodash2.default.get(CBG_FLAG_MAP, range);
	        if (!key) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId13, _defineProperty({}, CBG_FLAGS, _defineProperty({}, key, { $set: false }))));
	      }
	    case actionTypes.TURN_ON_CBG_RANGE:
	      {
	        var _action$payload6 = action.payload,
	            _userId15 = _action$payload6.userId,
	            _range = _action$payload6.range;
	
	        var _key = _lodash2.default.get(CBG_FLAG_MAP, _range);
	        if (!_key) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId15, _defineProperty({}, CBG_FLAGS, _defineProperty({}, _key, { $set: true }))));
	      }
	    case actionTypes.UNFOCUS_TRENDS_CBG_DATE_TRACE:
	      {
	        var _userId17 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId17, _defineProperty({}, FOCUSED_CBG_DATE_TRACE, { $set: null })));
	      }
	    case actionTypes.UNFOCUS_TRENDS_CBG_SLICE:
	      {
	        var _userId20;
	
	        var _userId19 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId19, (_userId20 = {}, _defineProperty(_userId20, FOCUSED_CBG_DATE_TRACE, { $set: null }), _defineProperty(_userId20, FOCUSED_CBG_SLICE, { $set: null }), _defineProperty(_userId20, FOCUSED_CBG_KEYS, { $set: null }), _defineProperty(_userId20, SHOW_CBG_DATE_TRACES, { $set: false }), _userId20)));
	      }
	    case actionTypes.UNFOCUS_TRENDS_SMBG:
	      {
	        var _userId21 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId21, _defineProperty({}, FOCUSED_SMBG, { $set: null })));
	      }
	    case actionTypes.UNFOCUS_TRENDS_SMBG_RANGE_AVG:
	      {
	        var _userId23 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId23, _defineProperty({}, FOCUSED_SMBG_RANGE_AVG, { $set: null })));
	      }
	    default:
	      return state;
	  }
	};
	
	var _default = trendsStateByUser;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBG_FLAGS, 'CBG_FLAGS', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_100_ENABLED, 'CBG_100_ENABLED', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_80_ENABLED, 'CBG_80_ENABLED', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_50_ENABLED, 'CBG_50_ENABLED', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_MEDIAN_ENABLED, 'CBG_MEDIAN_ENABLED', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_CBG_DATE_TRACE, 'FOCUSED_CBG_DATE_TRACE', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_CBG_SLICE, 'FOCUSED_CBG_SLICE', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_CBG_KEYS, 'FOCUSED_CBG_KEYS', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_SMBG, 'FOCUSED_SMBG', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_SMBG_RANGE_AVG, 'FOCUSED_SMBG_RANGE_AVG', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(SHOW_CBG_DATE_TRACES, 'SHOW_CBG_DATE_TRACES', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(TOUCHED, 'TOUCHED', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_FLAG_MAP, 'CBG_FLAG_MAP', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(trendsStateByUser, 'trendsStateByUser', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	})();

	;

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = require("react-addons-update");

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactAddonsUpdate = __webpack_require__(187);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _actionTypes = __webpack_require__(51);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var settingsStateByUser = function settingsStateByUser() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.FETCH_PATIENT_DATA_SUCCESS:
	      {
	        var userId = action.payload.patientId;
	
	        if (state[userId]) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, userId, { $set: {} }));
	      }
	    case actionTypes.LOGOUT_REQUEST:
	      return {};
	    case actionTypes.MARK_SETTINGS_VIEWED:
	      {
	        var _userId = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId, { touched: { $set: true } }));
	      }
	    case actionTypes.TOGGLE_SETTINGS_SECTION:
	      {
	        var _action$payload = action.payload,
	            deviceKey = _action$payload.deviceKey,
	            _userId2 = _action$payload.userId,
	            scheduleOrProfileKey = _action$payload.scheduleOrProfileKey;
	
	        if (!state[_userId2][deviceKey]) {
	          return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId2, { $merge: _defineProperty({}, deviceKey, _defineProperty({}, scheduleOrProfileKey, true)) }));
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId2, _defineProperty({}, deviceKey, _defineProperty({}, scheduleOrProfileKey, {
	          $apply: function $apply(val) {
	            return !val;
	          }
	        }))));
	      }
	    default:
	      return state;
	  }
	};
	
	var _default = settingsStateByUser;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(settingsStateByUser, 'settingsStateByUser', '/Users/krystophv/tidepool/viz/src/redux/reducers/settingsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/krystophv/tidepool/viz/src/redux/reducers/settingsStateByUser.js');
	})();

	;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripDatum = stripDatum;
	exports.filterWithDurationFnMaker = filterWithDurationFnMaker;
	exports.filterPointInTimeFnMaker = filterPointInTimeFnMaker;
	exports.selectDailyViewData = selectDailyViewData;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(23);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _d3Array = __webpack_require__(105);
	
	var _basal = __webpack_require__(190);
	
	var _device = __webpack_require__(191);
	
	var _datetime = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * stripDatum
	 * @param {Object} d - a Tidepool datum
	 *
	 * @return {Object} Tidepool datum stripped of all fields not needed client-side
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function stripDatum(d) {
	  return _lodash2.default.assign({}, _lodash2.default.omit(d, ['clockDriftOffset', 'conversionOffset', 'createdUserId', 'deviceId', 'deviceSerialNumber', 'deviceTime', 'displayOffset', 'guid', 'localDayOfWeek', 'localDate', 'modifiedUserId', 'payload', 'scheduleName', 'source', 'time', 'timezoneOffset', 'units', 'uploadId']));
	}
	
	/**
	 * filterWithDurationFnMaker
	 *
	 * @param {String} dateStart - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 * @param {String} dateEnd - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 *
	 * @returns {Function} Function that recieves a Tidepool datum with an extended duration
	 *                     to determine if it falls into the given range
	 */
	function filterWithDurationFnMaker(dateStart, dateEnd) {
	  return function (d) {
	    if (d.normalTime && d.normalEnd) {
	      if (d.normalTime === dateStart) {
	        return true;
	      } else if (d.normalTime < dateStart && d.normalEnd > dateStart && d.normalEnd <= dateEnd) {
	        return true;
	      } else if (d.normalTime > dateStart && d.normalTime < dateEnd) {
	        return true;
	      }
	      return false;
	    }
	    return d.normalTime >= dateStart && d.normalTime < dateEnd;
	  };
	}
	
	/**
	 * filterPointInTimeFnMaker
	 *
	 * @param {String} dateStart - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 * @param {String} dateEnd - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 *
	 * @returns {Function} Function that recieves a Tidepool datum to determine if it falls into
	 *                     the given range
	 */
	function filterPointInTimeFnMaker(dateStart, dateEnd) {
	  return function (d) {
	    return d.normalTime >= dateStart && d.normalTime < dateEnd;
	  };
	}
	
	/**
	 * selectDailyViewData
	 * @param {String} mostRecent - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 * @param {Array} groupedData - Object of tideline-preprocessed Tidepool diabetes data & notes;
	 *                              grouped by type
	 * @param {Number} numDays - number of days of data to select
	 * @param {Object} timePrefs - object containing timezoneAware Boolean, timezoneName String or null
	 *
	 * @return {Object} selected data for daily print view
	 */
	function selectDailyViewData(mostRecent, groupedData, numDays, timePrefs) {
	  var timezone = (0, _datetime.getTimezoneFromTimePrefs)(timePrefs);
	  var end = (0, _datetime.getLocalizedCeiling)(mostRecent, timePrefs);
	  var lastDate = void 0;
	
	  var dateBoundaries = [end.toISOString()];
	  var last = end;
	  for (var i = 0; i < numDays; ++i) {
	    var startOfDate = _momentTimezone2.default.utc(last).tz(timezone).subtract(1, 'day').toDate();
	    dateBoundaries.push(startOfDate.toISOString());
	    last = startOfDate;
	  }
	  dateBoundaries.reverse();
	
	  var selected = { dataByDate: {} };
	  var selectedDataByDate = selected.dataByDate;
	
	  var _loop = function _loop(_i) {
	    var thisDateStart = dateBoundaries[_i];
	    var thisDateEnd = dateBoundaries[_i + 1];
	    var date = _momentTimezone2.default.utc(Date.parse(thisDateStart)).tz(timezone).format('YYYY-MM-DD');
	    selected.dataByDate[date] = {
	      bounds: [Date.parse(thisDateStart), Date.parse(thisDateEnd)],
	      date: date,
	      data: _lodash2.default.mapValues(groupedData, function (dataForType) {
	        if (_lodash2.default.isEmpty(dataForType)) {
	          return [];
	        }
	        var filterFn = _lodash2.default.includes(['basal', 'bolus'], dataForType[0].type) ? filterWithDurationFnMaker(thisDateStart, thisDateEnd) : filterPointInTimeFnMaker(thisDateStart, thisDateEnd);
	        return _lodash2.default.sortBy(_lodash2.default.map(_lodash2.default.filter(dataForType, filterFn), function (d) {
	          var reshaped = stripDatum(d);
	          if (reshaped.suppressed) {
	            reshaped.suppressed = stripDatum(reshaped.suppressed);
	          }
	          reshaped.utc = Date.parse(d.normalTime);
	          return reshaped;
	        }), 'utc');
	      })
	    };
	
	    if (_i === numDays - 1) {
	      lastDate = date;
	    }
	    // TODO: select out infusion site changes, calibrations from deviceEvent array
	    // (NB: deviceEvent not being passed through via blip yet!!)
	  };
	
	  for (var _i = 0; _i < numDays; ++_i) {
	    _loop(_i);
	  }
	
	  // TODO: properly factor out into own utility? API needs thinking about
	  var bgs = _lodash2.default.reduce(selectedDataByDate, function (all, date) {
	    return all.concat(_lodash2.default.get(date, ['data', 'cbg'], [])).concat(_lodash2.default.get(date, ['data', 'smbg'], []));
	  }, []);
	  selected.bgRange = (0, _d3Array.extent)(bgs, function (d) {
	    return d.value;
	  });
	
	  var boluses = _lodash2.default.reduce(selectedDataByDate, function (all, date) {
	    return all.concat(_lodash2.default.get(date, ['data', 'bolus'], []));
	  }, []);
	  _lodash2.default.each(boluses, function (bolus) {
	    // eslint-disable-next-line no-param-reassign
	    bolus.threeHrBin = Math.floor(_momentTimezone2.default.utc(bolus.utc).tz(timezone).hours() / 3) * 3;
	  });
	  selected.bolusRange = (0, _d3Array.extent)(boluses, function (d) {
	    return d.normal + (d.extended || 0);
	  });
	
	  _lodash2.default.each(selectedDataByDate, function (dateObj) {
	    var bolusesForDate = dateObj.data.bolus;
	
	    selectedDataByDate[dateObj.date].data.bolus = _lodash2.default.map(bolusesForDate, function (bolus) {
	      if (bolus.wizard) {
	        var reversed = stripDatum(bolus.wizard);
	        reversed.bolus = _lodash2.default.omit(bolus, 'wizard');
	        return reversed;
	      }
	      return bolus;
	    });
	  });
	
	  var allBasals = _lodash2.default.reduce(selectedDataByDate, function (all, date) {
	    return all.concat(_lodash2.default.get(date, ['data', 'basal'], []));
	  }, []);
	  var rawBasalRange = (0, _d3Array.extent)(allBasals, function (d) {
	    return _lodash2.default.max([_lodash2.default.get(d, ['suppressed', 'rate'], 0), d.rate]);
	  });
	  // multiply the max rate by 1.1 to add a little buffer so the highest basals
	  // don't sit at the very top of the basal rendering area and bump into boluses
	  selected.basalRange = [0, rawBasalRange[1] * 1.1];
	
	  _lodash2.default.each(selected.dataByDate, function (dateData) {
	    var bounds = dateData.bounds,
	        basals = dateData.data.basal;
	
	    for (var _i2 = 0; _i2 < basals.length; ++_i2) {
	      var basal = basals[_i2];
	      // trim the first and last basals to fit within the date's bounds
	      if (basal.utc < bounds[0]) {
	        basal.duration = basal.duration - (bounds[0] - basal.utc);
	        basal.utc = bounds[0];
	      }
	      if (_i2 === basals.length - 1 && dateData.date !== lastDate) {
	        basal.duration = bounds[1] - basal.utc;
	      }
	      var nextBasal = void 0;
	      basal.subType = basal.deliveryType;
	      delete basal.deliveryType;
	      if (_i2 !== basals.length - 1) {
	        nextBasal = basals[_i2 + 1];
	        if (basal.utc + basal.duration !== nextBasal.utc) {
	          basal.discontinuousEnd = true;
	          nextBasal.discontinuousStart = true;
	        }
	      }
	    }
	    /* eslint-disable no-param-reassign */
	    dateData.data.basalSequences = (0, _basal.getBasalSequences)(basals);
	    dateData.data.timeInAutoRatio = (0, _basal.getGroupDurations)(basals, bounds[0], bounds[1]);
	    /* eslint-enable no-param-reassign */
	  });
	
	  if (_lodash2.default.get(groupedData, 'upload.length', 0) > 0) {
	    selected.latestPumpUpload = (0, _device.getLatestPumpUpload)(groupedData.upload);
	  }
	
	  return selected;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(stripDatum, 'stripDatum', '/Users/krystophv/tidepool/viz/src/utils/print/data.js');
	
	  __REACT_HOT_LOADER__.register(filterWithDurationFnMaker, 'filterWithDurationFnMaker', '/Users/krystophv/tidepool/viz/src/utils/print/data.js');
	
	  __REACT_HOT_LOADER__.register(filterPointInTimeFnMaker, 'filterPointInTimeFnMaker', '/Users/krystophv/tidepool/viz/src/utils/print/data.js');
	
	  __REACT_HOT_LOADER__.register(selectDailyViewData, 'selectDailyViewData', '/Users/krystophv/tidepool/viz/src/utils/print/data.js');
	})();

	;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBasalSequences = getBasalSequences;
	exports.getBasalPathGroupType = getBasalPathGroupType;
	exports.getBasalPathGroups = getBasalPathGroups;
	exports.getTotalBasal = getTotalBasal;
	exports.getEndpoints = getEndpoints;
	exports.getGroupDurations = getGroupDurations;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _datetime = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* getBasalSequences
	* @param {Array} basals - Array of preprocessed Tidepool basal objects
	*
	* @return {Array} Array of Arrays where each component Array is a sequence of basals
	*                 of the same subType to be rendered as a unit
	*/
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function getBasalSequences(basals) {
	  var basalSequences = [];
	  var currentBasal = basals[0];
	  var seq = [basals[0]];
	
	  var idx = 1;
	  while (idx <= basals.length - 1) {
	    var nextBasal = basals[idx];
	    var basalTypeChange = nextBasal.subType !== currentBasal.subType;
	
	    if (basalTypeChange || currentBasal.discontinuousEnd || nextBasal.rate === 0) {
	      basalSequences.push(seq);
	      seq = [];
	    }
	
	    seq.push(nextBasal);
	    currentBasal = nextBasal;
	    ++idx;
	  }
	  basalSequences.push(seq);
	
	  return basalSequences;
	}
	
	/**
	 * getBasalPathGroupType
	 * @param {Object} basal - single basal datum
	 * @return {String} the path group type
	 */
	function getBasalPathGroupType() {
	  var datum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var deliveryType = _lodash2.default.get(datum, 'subType', datum.deliveryType);
	  var suppressedDeliveryType = _lodash2.default.get(datum.suppressed, 'subType', _lodash2.default.get(datum.suppressed, 'deliveryType'));
	  return _lodash2.default.contains([deliveryType, suppressedDeliveryType], 'automated') ? 'automated' : 'manual';
	}
	
	/**
	 * getBasalPathGroups
	 * @param {Array} basals - Array of preprocessed Tidepool basal objects
	 * @return {Array} groups of alternating 'automated' and 'manual' datums
	 */
	function getBasalPathGroups(basals) {
	  var basalPathGroups = [];
	  var currentPathType = void 0;
	  _lodash2.default.each(basals, function (datum) {
	    var pathType = getBasalPathGroupType(datum);
	    if (pathType !== currentPathType) {
	      currentPathType = pathType;
	      basalPathGroups.push([]);
	    }
	    _lodash2.default.last(basalPathGroups).push(datum);
	  });
	
	  return basalPathGroups;
	}
	
	/**
	 * getTotalBasal
	 * @param {Array} basals - Array of preprocessed Tidepool basal objects
	 *                         trimmed to fit within the timespan the total basal
	 *                         is being calculated over
	 *
	 * @return {Number} total basal insulin in units
	 */
	function getTotalBasal(basals) {
	  return _lodash2.default.reduce(basals, function (result, basal) {
	    return result + basal.rate * (basal.duration / _datetime.ONE_HR);
	  }, 0);
	}
	
	/**
	 * Get the start and end indexes and datetimes of basal datums within a given time range
	 * @param {Array} data Array of Tidepool basal data
	 * @param {String} s ISO date string for the start of the range
	 * @param {String} e ISO date string for the end of the range
	 * @param {Boolean} optionalExtents If true, allow basal gaps at start and end extents of the range.
	 * @returns {Object} The start and end datetimes and indexes
	 */
	function getEndpoints(data, s, e) {
	  var optionalExtents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var start = new Date(s);
	  var end = new Date(e);
	
	  var startIndex = _lodash2.default.findIndex(data, function (segment) {
	    return (optionalExtents || new Date(segment.normalTime).valueOf() <= start) && start <= new Date(segment.normalEnd).valueOf();
	  });
	
	  var endIndex = _lodash2.default.findLastIndex(data, function (segment) {
	    return new Date(segment.normalTime).valueOf() <= end && (optionalExtents || end <= new Date(segment.normalEnd).valueOf());
	  });
	
	  return {
	    start: {
	      datetime: start.toISOString(),
	      index: startIndex
	    },
	    end: {
	      datetime: end.toISOString(),
	      index: endIndex
	    }
	  };
	}
	
	/**
	 * Get durations of basal groups within a given span of time
	 * @param {Array} data Array of Tidepool basal data
	 * @param {String} s ISO date string for the start of the range
	 * @param {String} e ISO date string for the end of the range
	 * @returns {Object} The durations (in ms) keyed by basal group type
	 */
	function getGroupDurations(data, s, e) {
	  var endpoints = getEndpoints(data, s, e, true);
	
	  var durations = {
	    automated: 0,
	    manual: 0
	  };
	
	  if (endpoints.start.index >= 0 && endpoints.end.index >= 0) {
	    var start = new Date(endpoints.start.datetime);
	    var end = new Date(endpoints.end.datetime);
	
	    // handle first segment, which may have started before the start endpoint
	    var segment = data[endpoints.start.index];
	    var initialSegmentDuration = _lodash2.default.min([new Date(segment.normalEnd) - start, segment.duration]);
	    durations[getBasalPathGroupType(segment)] = initialSegmentDuration;
	
	    // add the durations of all subsequent basals, minus the last
	    var i = endpoints.start.index + 1;
	    while (i < endpoints.end.index) {
	      segment = data[i];
	      durations[getBasalPathGroupType(segment)] += segment.duration;
	      i++;
	    }
	
	    // handle last segment, which may go past the end endpoint
	    segment = data[endpoints.end.index];
	    durations[getBasalPathGroupType(segment)] += _lodash2.default.min([end - new Date(segment.normalTime), segment.duration]);
	  }
	
	  return durations;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBasalSequences, 'getBasalSequences', '/Users/krystophv/tidepool/viz/src/utils/basal.js');
	
	  __REACT_HOT_LOADER__.register(getBasalPathGroupType, 'getBasalPathGroupType', '/Users/krystophv/tidepool/viz/src/utils/basal.js');
	
	  __REACT_HOT_LOADER__.register(getBasalPathGroups, 'getBasalPathGroups', '/Users/krystophv/tidepool/viz/src/utils/basal.js');
	
	  __REACT_HOT_LOADER__.register(getTotalBasal, 'getTotalBasal', '/Users/krystophv/tidepool/viz/src/utils/basal.js');
	
	  __REACT_HOT_LOADER__.register(getEndpoints, 'getEndpoints', '/Users/krystophv/tidepool/viz/src/utils/basal.js');
	
	  __REACT_HOT_LOADER__.register(getGroupDurations, 'getGroupDurations', '/Users/krystophv/tidepool/viz/src/utils/basal.js');
	})();

	;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLatestPumpUpload = getLatestPumpUpload;
	exports.isAutomatedBasalDevice = isAutomatedBasalDevice;
	exports.getPumpVocabulary = getPumpVocabulary;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(18);
	
	var _data = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the latest upload datum
	 * @param {Array} uploadData Array of Tidepool upload data
	 * @returns {Object} The latest upload datum
	 */
	function getLatestPumpUpload() {
	  var uploadData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return _lodash2.default.findLast(uploadData, { deviceTags: ['insulin-pump'] });
	}
	
	/**
	 * Check if the provided upload datum was for an automated basal device
	 * @param {String} manufacturer Manufacturer name
	 * @param {String} deviceModel Device model number
	 * @returns {Boolean}
	 */
	function isAutomatedBasalDevice(manufacturer, deviceModel) {
	  return _lodash2.default.includes(_lodash2.default.get(_constants.AUTOMATED_BASAL_DEVICE_MODELS, (0, _data.deviceName)(manufacturer), []), deviceModel);
	}
	
	/**
	 * Get a pump terminology vocabulary, with default fallbacks for missing keys
	 * @param {String} manufacturer Manufacturer name
	 * @returns {Object} pump vocabulary
	 */
	function getPumpVocabulary(manufacturer) {
	  var vocabulary = _lodash2.default.cloneDeep(_constants.pumpVocabulary);
	  return _lodash2.default.defaults(_lodash2.default.get(vocabulary, (0, _data.deviceName)(manufacturer), {}), vocabulary.default);
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getLatestPumpUpload, 'getLatestPumpUpload', '/Users/krystophv/tidepool/viz/src/utils/device.js');
	
	  __REACT_HOT_LOADER__.register(isAutomatedBasalDevice, 'isAutomatedBasalDevice', '/Users/krystophv/tidepool/viz/src/utils/device.js');
	
	  __REACT_HOT_LOADER__.register(getPumpVocabulary, 'getPumpVocabulary', '/Users/krystophv/tidepool/viz/src/utils/device.js');
	})();

	;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** index.js
 **/